var _rect, _rect2, _path, _ellipse, _path2, _rect3, _path3, _ellipse2, _path4, _rect4, _path5, _ellipse3, _path6, _path7, _rect5, _rect6, _rect7, _rect8, _rect9, _path8, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _path9, _rect28, _rect29, _path10, _path11, _path12, _rect30, _rect31, _path13, _path14, _rect32, _rect33, _path15, _path16, _rect34, _rect35, _rect36, _mask, _path17, _path18, _rect37, _path19, _path20, _rect38, _rect39, _rect40, _mask2, _path21, _path22, _rect41, _path23, _path24, _rect42, _rect43, _rect44, _path25, _path26, _path27, _rect45, _rect46, _rect47, _rect48, _path28, _path29, _path30, _rect49, _rect50, _rect51, _path31, _path32, _path33, _rect52, _path34, _mask3, _path35, _path36, _path37, _path38, _path39, _rect53, _path40, _mask4, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _ellipse4, _path68, _path69, _rect54, _path70, _ellipse5, _ellipse6, _path71, _path72, _path73, _path74, _rect55, _path75, _path76, _path77, _rect56, _path78, _path79, _mask5, _path80, _path81, _rect57, _path82, _path83, _mask6, _path84, _path85, _rect58, _path86, _path87, _mask7, _path88, _path89, _rect59, _path90, _path91, _mask8, _path92, _path93, _rect60, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _ellipse7, _path110, _path111, _path112, _ellipse8, _path113, _path114, _path115, _ellipse9, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _circle, _circle2, _circle3, _path123, _circle4, _circle5, _circle6, _path124, _circle7, _circle8, _circle9, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _mask9, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _mask10, _path183, _path184, _path185, _path186, _path187, _mask11, _path188, _path189, _path190, _path191, _path192, _mask12, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _mask13, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _ellipse10, _ellipse11, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _ellipse12, _ellipse13, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _rect61, _path276, _rect62, _rect63, _path277, _rect64, _rect65, _path278, _rect66, _rect67, _path279, _rect68, _path280, _path281, _rect69, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _mask14, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _ellipse14, _path329, _path330, _ellipse15, _path331, _path332, _ellipse16, _path333, _ellipse17, _ellipse18, _path334, _path335, _path336, _path337, _ellipse19, _ellipse20, _path338, _path339, _path340, _path341, _ellipse21, _ellipse22, _path342, _path343, _path344, _path345, _path346, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _path347, _path348, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _ellipse23, _path406, _path407, _path408, _ellipse24, _path409, _path410, _path411, _ellipse25, _path412, _path413, _rect70, _rect71, _rect72, _ellipse26, _ellipse27, _g, _path414, _rect73, _rect74, _rect75, _ellipse28, _ellipse29, _g2, _path415, _path416, _mask15, _path417, _path418, _rect76, _path419, _path420, _mask16, _path421, _path422, _rect77, _path423, _path424, _mask17, _path425, _path426, _rect78, _path427, _rect79, _circle34, _circle35, _circle36, _circle37, _circle38, _circle39, _path428, _path429, _path430, _path431, _path432, _path433, _rect80, _circle40, _circle41, _circle42, _circle43, _circle44, _circle45, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _rect81, _path445, _path446, _path447, _rect82, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _circle46, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgGroceryStoreContrast = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1200,
    height: 800,
    viewBox: "0 0 1200 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4896_18569)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 800,
    fill: "#1E1E1E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 147,
    width: 4,
    height: 30,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.887 54.6883C121.829 50.7469 126.441 47.6305 131.455 45.4502C132.01 41.6181 133.788 38.0403 136.558 35.2699C139.945 31.8831 144.539 29.9803 149.328 29.9803C154.118 29.9803 158.712 31.8831 162.098 35.2699C164.944 38.1152 166.742 41.812 167.244 45.7614C171.988 47.9231 176.355 50.9308 180.113 54.6883C188.274 62.8497 192.898 73.8871 192.998 85.4184C192.999 85.4366 193 85.4549 193 85.4731C193 85.4868 193 85.5005 192.999 85.5142C193 85.6097 193 85.7053 193 85.801H192.94C191.738 89.0942 172.525 91.7119 149 91.7119C125.475 91.7119 106.262 89.0942 105.06 85.801H105C105 85.7053 105 85.6098 105.001 85.5142C105 85.5005 105 85.4868 105 85.4731C105 85.4549 105.001 85.4366 105.002 85.4184C105.102 73.8871 109.726 62.8496 117.887 54.6883Z",
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 149.431,
    cy: 83.9018,
    rx: 41.8431,
    ry: 5.60784,
    fill: "#1E1E1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M157.803 80.8823C160.565 80.8823 162.886 83.1914 161.907 85.7737C161.858 85.9048 161.806 86.0352 161.752 86.1648C161.059 87.8396 160.042 89.3613 158.76 90.6431C157.478 91.9249 155.957 92.9417 154.282 93.6355C152.607 94.3292 150.812 94.6862 148.999 94.6862C147.186 94.6862 145.391 94.3292 143.717 93.6355C142.042 92.9417 140.52 91.9249 139.238 90.6431C137.957 89.3613 136.94 87.8396 136.246 86.1648C136.192 86.0352 136.141 85.9048 136.091 85.7737C135.112 83.1914 137.434 80.8823 140.195 80.8823L148.999 80.8823H157.803Z",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 249,
    width: 4,
    height: 30,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M219.887 54.6883C223.829 50.7469 228.441 47.6305 233.455 45.4502C234.01 41.6181 235.788 38.0403 238.558 35.2699C241.945 31.8831 246.539 29.9803 251.328 29.9803C256.118 29.9803 260.712 31.8831 264.098 35.2699C266.944 38.1152 268.742 41.812 269.244 45.7614C273.988 47.9231 278.355 50.9308 282.113 54.6883C290.274 62.8497 294.898 73.8871 294.998 85.4184C294.999 85.4366 295 85.4549 295 85.4731C295 85.4868 295 85.5005 294.999 85.5142C295 85.6097 295 85.7053 295 85.801H294.94C293.738 89.0942 274.525 91.7119 251 91.7119C227.475 91.7119 208.262 89.0942 207.06 85.801H207C207 85.7053 207 85.6098 207.001 85.5142C207 85.5005 207 85.4868 207 85.4731C207 85.4549 207.001 85.4366 207.002 85.4184C207.102 73.8871 211.726 62.8496 219.887 54.6883Z",
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 251.431,
    cy: 83.9018,
    rx: 41.8431,
    ry: 5.60784,
    fill: "#1E1E1E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M259.803 80.8823C262.565 80.8823 264.886 83.1914 263.907 85.7737C263.858 85.9048 263.806 86.0352 263.752 86.1648C263.059 87.8396 262.042 89.3613 260.76 90.6431C259.478 91.9249 257.957 92.9417 256.282 93.6355C254.607 94.3292 252.812 94.6862 250.999 94.6862C249.186 94.6862 247.391 94.3292 245.717 93.6355C244.042 92.9417 242.52 91.9249 241.238 90.6431C239.957 89.3613 238.94 87.8396 238.246 86.1648C238.192 86.0352 238.141 85.9048 238.091 85.7737C237.112 83.1914 239.434 80.8823 242.195 80.8823L250.999 80.8823H259.803Z",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    width: 4,
    height: 30,
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8873 54.6883C23.8286 50.7469 28.4407 47.6305 33.4552 45.4502C34.0105 41.6181 35.7878 38.0403 38.5582 35.2699C41.9451 31.8831 46.5386 29.9803 51.3284 29.9803C56.1181 29.9803 60.7116 31.8831 64.0985 35.2699C66.9437 38.1152 68.7416 41.812 69.2438 45.7614C73.9881 47.9231 78.3552 50.9308 82.1127 54.6883C90.2741 62.8497 94.8982 73.8871 94.9983 85.4184C94.9994 85.4366 95 85.4549 95 85.4731C95 85.4868 94.9997 85.5005 94.9991 85.5142C94.9997 85.6097 95 85.7053 95 85.801H94.9403C93.7379 89.0942 74.525 91.7119 51 91.7119C27.475 91.7119 8.26206 89.0942 7.0597 85.801H7C7 85.7053 7.00031 85.6098 7.00093 85.5142C7.00031 85.5005 7 85.4868 7 85.4731C7 85.4549 7.00055 85.4366 7.00166 85.4184C7.10181 73.8871 11.7259 62.8496 19.8873 54.6883Z",
    fill: "white"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 51.431,
    cy: 83.9018,
    rx: 41.8431,
    ry: 5.60784,
    fill: "#1E1E1E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8032 80.8823C62.5646 80.8823 64.886 83.1914 63.9075 85.7737C63.8578 85.9048 63.8061 86.0352 63.7524 86.1648C63.0587 87.8396 62.0419 89.3613 60.7601 90.6431C59.4783 91.9249 57.9565 92.9417 56.2818 93.6355C54.607 94.3292 52.812 94.6862 50.9992 94.6862C49.1865 94.6862 47.3915 94.3292 45.7167 93.6355C44.0419 92.9417 42.5202 91.9249 41.2384 90.6431C39.9566 89.3613 38.9398 87.8396 38.2461 86.1648C38.1924 86.0352 38.1407 85.9048 38.091 85.7737C37.1125 83.1914 39.4339 80.8823 42.1953 80.8823L50.9992 80.8823H59.8032Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 383H196C198.761 383 201 385.239 201 388V395C201 397.761 198.761 400 196 400H0V383Z",
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 400,
    width: 400,
    height: 58,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 900,
    y: 400,
    width: 300,
    height: 58,
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 400.5,
    y: 58.5,
    width: 399,
    height: 142,
    stroke: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 516,
    width: 275,
    height: 171,
    fill: "#AD673A"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 412,
    y: 414,
    width: 375,
    height: 172,
    fill: "#AD673A"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M901 449H1201V800H901V449Z",
    fill: "white"
  }))), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 401,
    y: 192,
    width: 400,
    height: 9,
    fill: "white"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 902,
    y: 780,
    width: 298,
    height: 20,
    fill: "white"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 900,
    y: 444,
    width: 9,
    height: 356,
    fill: "white"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 1191,
    y: 444,
    width: 9,
    height: 356,
    fill: "white"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 529,
    y: 16,
    width: 141,
    height: 26,
    fill: "#1E1E1E"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 1017,
    y: 416,
    width: 68,
    height: 26,
    fill: "#1E1E1E"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 415,
    y: 16,
    width: 69,
    height: 4,
    fill: "#1E1E1E"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 921,
    y: 416,
    width: 68,
    height: 4,
    fill: "#1E1E1E"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 721,
    y: 16,
    width: 65,
    height: 4,
    fill: "#1E1E1E"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 1115,
    y: 416,
    width: 68,
    height: 4,
    fill: "#1E1E1E"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 415,
    y: 28,
    width: 69,
    height: 3,
    fill: "#1E1E1E"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 921,
    y: 428,
    width: 68,
    height: 3,
    fill: "#1E1E1E"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 721,
    y: 28,
    width: 65,
    height: 3,
    fill: "#1E1E1E"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 1115,
    y: 428,
    width: 68,
    height: 3,
    fill: "#1E1E1E"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 415,
    y: 38,
    width: 69,
    height: 4,
    fill: "#1E1E1E"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 921,
    y: 438,
    width: 68,
    height: 4,
    fill: "#1E1E1E"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 721,
    y: 38,
    width: 65,
    height: 4,
    fill: "#1E1E1E"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 1115,
    y: 438,
    width: 68,
    height: 4,
    fill: "#1E1E1E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M787 401H401V409V414V586V595V599H799V594V586V414V401H787ZM787 586V414H413V586H787Z",
    fill: "white"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 909,
    y: 578,
    width: 282,
    height: 13,
    fill: "white"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 909,
    y: 680,
    width: 282,
    height: 13,
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M299 501H12H0V515.214V685.786V689.066V700H299V686.879V685.786V515.214V502.093V501ZM287 685.786V515.214H12V685.786H287Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M912.844 742.037H949.712L944.584 777.015C944.376 778.439 943.154 779.494 941.715 779.494H920.841C919.401 779.494 918.18 778.439 917.971 777.015L912.844 742.037Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M939.393 757.771C940.715 757.639 941.931 757.475 943.006 757.282C944.538 757.009 945.753 756.683 946.582 756.326C947.411 755.968 947.837 755.584 947.837 755.197H947.994L947.04 761.703C946.863 761.717 946.686 761.731 946.508 761.744C944.032 761.927 941.464 762.065 938.845 762.155C937.545 764.618 934.646 766.333 931.278 766.333C927.908 766.333 925.007 764.616 923.709 762.151C921.134 762.06 918.61 761.924 916.174 761.744C915.996 761.731 915.818 761.717 915.641 761.704L914.688 755.197H914.844C914.844 755.584 915.271 755.968 916.1 756.326C916.929 756.683 918.144 757.009 919.676 757.282C920.718 757.469 921.892 757.629 923.166 757.759C923.966 754.559 927.294 752.16 931.278 752.16C935.267 752.16 938.599 754.566 939.393 757.771Z",
    fill: "#1E1E1E"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 910.5,
    y: 738.5,
    width: 41.555,
    height: 5.04939,
    rx: 2.5247,
    fill: "#1E1E1E",
    stroke: "white"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    width: 1.84805,
    height: 29.3145,
    rx: 0.924023,
    transform: "matrix(0.985247 -0.171139 0.142519 0.989792 915.609 746.403)",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M953.844 742.037H990.712L985.584 777.015C985.376 778.439 984.154 779.494 982.715 779.494H961.841C960.401 779.494 959.18 778.439 958.971 777.015L953.844 742.037Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M980.394 757.771C981.715 757.639 982.931 757.475 984.006 757.282C985.538 757.009 986.753 756.683 987.582 756.326C988.411 755.968 988.837 755.584 988.837 755.197H988.994L988.04 761.703C987.863 761.717 987.686 761.731 987.508 761.744C985.032 761.927 982.464 762.065 979.845 762.155C978.546 764.618 975.646 766.333 972.278 766.333C968.908 766.333 966.007 764.616 964.709 762.151C962.134 762.06 959.61 761.924 957.174 761.744C956.996 761.731 956.818 761.717 956.641 761.704L955.688 755.197H955.844C955.844 755.584 956.271 755.968 957.1 756.326C957.929 756.683 959.144 757.009 960.676 757.282C961.718 757.469 962.892 757.629 964.166 757.759C964.966 754.559 968.294 752.16 972.278 752.16C976.267 752.16 979.599 754.566 980.394 757.771Z",
    fill: "#1E1E1E"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 951.5,
    y: 738.5,
    width: 41.555,
    height: 5.04939,
    rx: 2.5247,
    fill: "#1E1E1E",
    stroke: "white"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    width: 1.84805,
    height: 29.3145,
    rx: 0.924023,
    transform: "matrix(0.985247 -0.171139 0.142519 0.989792 956.609 746.403)",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M936.578 705.599H968.144L963.806 735.19C963.598 736.614 962.376 737.67 960.937 737.67H943.785C942.346 737.67 941.125 736.614 940.916 735.19L936.578 705.599Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M959.309 719.072C960.44 718.958 961.482 718.818 962.402 718.653C963.713 718.419 964.754 718.14 965.464 717.834C966.173 717.528 966.539 717.199 966.539 716.867H966.673L965.856 722.438C965.705 722.45 965.553 722.462 965.4 722.473C963.28 722.63 961.082 722.748 958.839 722.825C957.727 724.934 955.245 726.402 952.361 726.402C949.476 726.402 946.992 724.932 945.88 722.821C943.676 722.744 941.514 722.627 939.429 722.473C939.276 722.462 939.124 722.45 938.973 722.438L938.156 716.867H938.29C938.29 717.199 938.656 717.528 939.366 717.834C940.075 718.14 941.116 718.419 942.427 718.653C943.319 718.813 944.324 718.95 945.415 719.061C946.101 716.322 948.95 714.268 952.361 714.268C955.776 714.268 958.629 716.327 959.309 719.072Z",
    fill: "#1E1E1E"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 934.5,
    y: 702.5,
    width: 35.7227,
    height: 4.46703,
    rx: 2.23352,
    fill: "#1E1E1E",
    stroke: "white"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    width: 1.58227,
    height: 25.0987,
    rx: 0.791136,
    transform: "matrix(0.985247 -0.171139 0.142519 0.989792 938.945 709.338)",
    fill: "white"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 1036.21,
    y: 492,
    width: 10,
    height: 8.97662,
    rx: 3,
    transform: "rotate(35.5055 1036.21 492)",
    fill: "white"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-55-inside-1_4896_18569",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1029 491H1027V493.698L1009 506.263V577H1047V506.263L1029 493.698V491Z"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1029 491H1027V493.698L1009 506.263V577H1047V506.263L1029 493.698V491Z",
    fill: "#1E1E1E"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M1027 491V490H1026V491H1027ZM1029 491H1030V490H1029V491ZM1027 493.698L1027.57 494.518L1028 494.22V493.698H1027ZM1009 506.263L1008.43 505.443L1008 505.742V506.263H1009ZM1009 577H1008V578H1009V577ZM1047 577V578H1048V577H1047ZM1047 506.263H1048V505.742L1047.57 505.443L1047 506.263ZM1029 493.698H1028V494.22L1028.43 494.518L1029 493.698ZM1027 492H1029V490H1027V492ZM1028 493.698V491H1026V493.698H1028ZM1009.57 507.083L1027.57 494.518L1026.43 492.878L1008.43 505.443L1009.57 507.083ZM1010 577V506.263H1008V577H1010ZM1047 576H1009V578H1047V576ZM1046 506.263V577H1048V506.263H1046ZM1028.43 494.518L1046.43 507.083L1047.57 505.443L1029.57 492.878L1028.43 494.518ZM1028 491V493.698H1030V491H1028Z",
    fill: "white",
    mask: "url(#path-55-inside-1_4896_18569)"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    x: 1014,
    y: 515,
    width: 3,
    height: 42,
    rx: 1.5,
    fill: "#1E1E1E"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M1028 496L1044.45 507.25H1011.55L1028 496Z",
    fill: "#1E1E1E"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M1028 496L1011.5 507.25H1021L1028 496Z",
    fill: "white"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 1035.78,
    y: 494,
    width: 1,
    height: 3,
    rx: 0.5,
    transform: "rotate(36.4192 1035.78 494)",
    fill: "#1E1E1E"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 1022,
    y: 526,
    width: 25,
    height: 31,
    fill: "white"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 1078.21,
    y: 492,
    width: 10,
    height: 8.97662,
    rx: 3,
    transform: "rotate(35.5055 1078.21 492)",
    fill: "white"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-63-inside-2_4896_18569",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1071 491H1069V493.698L1051 506.263V577H1089V506.263L1071 493.698V491Z"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1071 491H1069V493.698L1051 506.263V577H1089V506.263L1071 493.698V491Z",
    fill: "#1E1E1E"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M1069 491V490H1068V491H1069ZM1071 491H1072V490H1071V491ZM1069 493.698L1069.57 494.518L1070 494.22V493.698H1069ZM1051 506.263L1050.43 505.443L1050 505.742V506.263H1051ZM1051 577H1050V578H1051V577ZM1089 577V578H1090V577H1089ZM1089 506.263H1090V505.742L1089.57 505.443L1089 506.263ZM1071 493.698H1070V494.22L1070.43 494.518L1071 493.698ZM1069 492H1071V490H1069V492ZM1070 493.698V491H1068V493.698H1070ZM1051.57 507.083L1069.57 494.518L1068.43 492.878L1050.43 505.443L1051.57 507.083ZM1052 577V506.263H1050V577H1052ZM1089 576H1051V578H1089V576ZM1088 506.263V577H1090V506.263H1088ZM1070.43 494.518L1088.43 507.083L1089.57 505.443L1071.57 492.878L1070.43 494.518ZM1070 491V493.698H1072V491H1070Z",
    fill: "white",
    mask: "url(#path-63-inside-2_4896_18569)"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    x: 1056,
    y: 515,
    width: 3,
    height: 42,
    rx: 1.5,
    fill: "#1E1E1E"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M1070 496L1086.45 507.25H1053.55L1070 496Z",
    fill: "#1E1E1E"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M1070 496L1053.5 507.25H1063L1070 496Z",
    fill: "white"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 1077.78,
    y: 494,
    width: 1,
    height: 3,
    rx: 0.5,
    transform: "rotate(36.4192 1077.78 494)",
    fill: "#1E1E1E"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 1064,
    y: 526,
    width: 25,
    height: 31,
    fill: "white"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 940.213,
    y: 492,
    width: 10,
    height: 8.97662,
    rx: 3,
    transform: "rotate(35.5055 940.213 492)",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M933 491H931V493.698L913 506.263V577H951V506.263L933 493.698V491Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M932 496L948.454 507.25H915.546L932 496Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M932 496L915.5 507.25H925L932 496Z",
    fill: "#1E1E1E"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 939.781,
    y: 494,
    width: 1,
    height: 3,
    rx: 0.5,
    transform: "rotate(36.4192 939.781 494)",
    fill: "#1E1E1E"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 926.5,
    y: 526.5,
    width: 24,
    height: 30,
    fill: "#1E1E1E",
    stroke: "white"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 918,
    y: 515,
    width: 3,
    height: 42,
    rx: 1.5,
    fill: "white"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 982.213,
    y: 492,
    width: 10,
    height: 8.97662,
    rx: 3,
    transform: "rotate(35.5055 982.213 492)",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M975 491H973V493.698L955 506.263V577H993V506.263L975 493.698V491Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M974 496L990.454 507.25H957.546L974 496Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M974 496L957.5 507.25H967L974 496Z",
    fill: "#1E1E1E"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 981.781,
    y: 494,
    width: 1,
    height: 3,
    rx: 0.5,
    transform: "rotate(36.4192 981.781 494)",
    fill: "#1E1E1E"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 968.5,
    y: 526.5,
    width: 24,
    height: 30,
    fill: "#1E1E1E",
    stroke: "white"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 960,
    y: 515,
    width: 3,
    height: 42,
    rx: 1.5,
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M1168 495.5C1173.25 495.5 1177.5 499.753 1177.5 505V511.553C1177.5 513.614 1178.22 515.511 1179.14 517.295C1179.61 518.187 1180.13 519.061 1180.64 519.917C1180.69 520.001 1180.74 520.084 1180.79 520.167C1181.26 520.94 1181.72 521.699 1182.13 522.459C1182.75 523.59 1183.14 524.863 1183.25 526.224L1186.61 567.224C1187.07 572.758 1182.7 577.5 1177.15 577.5H1152.85C1147.3 577.5 1142.93 572.758 1143.38 567.224L1146.74 526.224C1146.85 524.985 1147.18 523.818 1147.71 522.765C1148.03 522.109 1148.39 521.454 1148.75 520.788C1148.81 520.673 1148.88 520.558 1148.94 520.443C1149.36 519.661 1149.79 518.862 1150.16 518.049C1150.92 516.425 1151.5 514.707 1151.5 512.861V505C1151.5 499.753 1155.75 495.5 1161 495.5H1168Z",
    fill: "white",
    stroke: "#1E1E1E"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M1154.37 480.5C1152.28 480.5 1150.65 482.328 1150.9 484.409L1152.19 495.409C1152.4 497.172 1153.89 498.5 1155.67 498.5H1173.33C1175.11 498.5 1176.6 497.172 1176.81 495.409L1178.1 484.409C1178.35 482.328 1176.72 480.5 1174.63 480.5H1154.37Z",
    fill: "#1E1E1E",
    stroke: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1147.01 569.347C1148.36 572.062 1150.65 569.056 1150.87 566.033L1153.58 528.985C1153.67 527.807 1153.96 526.697 1154.4 525.695C1154.67 525.094 1154.96 524.495 1155.25 523.893C1156.33 521.674 1157.42 519.422 1157.42 516.947V509.843C1157.42 504.853 1161.03 500.807 1165.49 500.807H1171.14C1171.14 500.807 1171.14 500.807 1171.14 500.807C1169.79 499.672 1168.12 499 1166.3 499H1160.65C1156.19 499 1152.58 503.046 1152.58 508.036V515.14C1152.58 517.614 1151.48 519.866 1150.41 522.085C1150.12 522.687 1149.83 523.287 1149.56 523.888C1149.11 524.889 1148.83 525.999 1148.74 527.177L1146.03 564.226C1145.89 566.081 1146.26 567.843 1147.01 569.347Z",
    fill: "white"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 1152.96,
    y: 483.446,
    width: 3,
    height: 13.1632,
    rx: 1.5,
    transform: "rotate(-8.63853 1152.96 483.446)",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M1155.45 534.953C1155.48 533.315 1156.81 532 1158.45 532H1180.73C1182.29 532 1183.59 533.205 1183.72 534.766L1185.75 560.766C1185.88 562.51 1184.51 564 1182.76 564H1158.05C1156.37 564 1155.02 562.628 1155.05 560.953L1155.45 534.953Z",
    fill: "#1E1E1E"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-89-inside-3_4896_18569",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1184.24 550.177C1182.38 553.387 1179.31 555.724 1175.72 556.674C1172.13 557.624 1168.31 557.109 1165.1 555.243C1161.89 553.376 1159.56 550.311 1158.61 546.722C1157.66 543.132 1158.17 539.313 1160.04 536.103L1172.14 543.14L1184.24 550.177Z"
  }))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M1184.24 550.177C1182.38 553.387 1179.31 555.724 1175.72 556.674C1172.13 557.624 1168.31 557.109 1165.1 555.243C1161.89 553.376 1159.56 550.311 1158.61 546.722C1157.66 543.132 1158.17 539.313 1160.04 536.103L1172.14 543.14L1184.24 550.177Z",
    fill: "#1E1E1E",
    stroke: "white",
    strokeWidth: 2,
    mask: "url(#path-89-inside-3_4896_18569)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M1182.51 549.172C1181.05 551.694 1178.55 553.477 1175.57 554.129C1172.58 554.781 1169.36 554.249 1166.61 552.649C1163.86 551.049 1161.8 548.513 1160.89 545.599C1159.99 542.684 1160.3 539.63 1161.77 537.108L1172.14 543.14L1182.51 549.172Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M1133.15 495.5C1138.39 495.5 1142.65 499.753 1142.65 505V511.553C1142.65 513.614 1143.37 515.511 1144.29 517.295C1144.76 518.187 1145.28 519.061 1145.79 519.917C1145.84 520.001 1145.89 520.084 1145.94 520.167C1146.41 520.94 1146.87 521.699 1147.28 522.459C1147.9 523.59 1148.29 524.863 1148.4 526.224L1151.76 567.224C1152.22 572.758 1147.85 577.5 1142.29 577.5H1118C1112.45 577.5 1108.08 572.758 1108.53 567.224L1111.89 526.224C1111.99 524.985 1112.33 523.818 1112.86 522.765C1113.18 522.109 1113.54 521.454 1113.9 520.788C1113.96 520.673 1114.02 520.558 1114.09 520.443C1114.51 519.661 1114.94 518.862 1115.31 518.049C1116.07 516.425 1116.65 514.707 1116.65 512.861V505C1116.65 499.753 1120.9 495.5 1126.15 495.5H1133.15Z",
    fill: "white",
    stroke: "#1E1E1E"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M1119.52 480.5C1117.43 480.5 1115.8 482.328 1116.05 484.409L1117.34 495.409C1117.55 497.172 1119.04 498.5 1120.82 498.5H1138.48C1140.26 498.5 1141.75 497.172 1141.96 495.409L1143.25 484.409C1143.5 482.328 1141.87 480.5 1139.77 480.5H1119.52Z",
    fill: "#1E1E1E",
    stroke: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1112.16 569.347C1113.51 572.062 1115.8 569.056 1116.02 566.033L1118.73 528.985C1118.82 527.807 1119.1 526.697 1119.55 525.695C1119.82 525.094 1120.11 524.495 1120.4 523.893C1121.48 521.674 1122.57 519.422 1122.57 516.947V509.843C1122.57 504.853 1126.18 500.807 1130.64 500.807H1136.29C1136.29 500.807 1136.29 500.807 1136.29 500.807C1134.94 499.672 1133.27 499 1131.45 499H1125.8C1121.34 499 1117.73 503.046 1117.73 508.036V515.14C1117.73 517.614 1116.63 519.866 1115.56 522.085C1115.26 522.687 1114.97 523.287 1114.71 523.888C1114.26 524.889 1113.98 525.999 1113.89 527.177L1111.18 564.226C1111.04 566.081 1111.41 567.843 1112.16 569.347Z",
    fill: "white"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 1118.11,
    y: 483.446,
    width: 3,
    height: 13.1632,
    rx: 1.5,
    transform: "rotate(-8.63853 1118.11 483.446)",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M1120.6 534.953C1120.63 533.315 1121.96 532 1123.6 532H1145.87C1147.44 532 1148.74 533.205 1148.86 534.766L1150.9 560.766C1151.03 562.51 1149.65 564 1147.9 564H1123.2C1121.52 564 1120.17 562.628 1120.2 560.953L1120.6 534.953Z",
    fill: "#1E1E1E"
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-96-inside-4_4896_18569",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1149.39 550.177C1147.52 553.387 1144.46 555.724 1140.87 556.674C1137.28 557.624 1133.46 557.109 1130.25 555.243C1127.04 553.376 1124.7 550.311 1123.75 546.722C1122.8 543.132 1123.32 539.313 1125.19 536.103L1137.29 543.14L1149.39 550.177Z"
  }))), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M1149.39 550.177C1147.52 553.387 1144.46 555.724 1140.87 556.674C1137.28 557.624 1133.46 557.109 1130.25 555.243C1127.04 553.376 1124.7 550.311 1123.75 546.722C1122.8 543.132 1123.32 539.313 1125.19 536.103L1137.29 543.14L1149.39 550.177Z",
    fill: "#1E1E1E",
    stroke: "white",
    strokeWidth: 2,
    mask: "url(#path-96-inside-4_4896_18569)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M1147.66 549.172C1146.2 551.694 1143.7 553.477 1140.71 554.129C1137.73 554.781 1134.51 554.249 1131.76 552.649C1129.01 551.049 1126.95 548.513 1126.04 545.599C1125.13 542.684 1125.45 539.63 1126.91 537.108L1137.29 543.14L1147.66 549.172Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M910.21 666.412C909.936 665.454 910.655 664.5 911.652 664.5H995.348C996.345 664.5 997.064 665.454 996.79 666.412L993.645 677.412C993.461 678.056 992.872 678.5 992.203 678.5H914.797C914.128 678.5 913.539 678.056 913.355 677.412L910.21 666.412Z",
    fill: "white",
    stroke: "#1E1E1E"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M929 664C929 660.817 928.21 657.765 926.803 655.515C925.397 653.264 923.489 652 921.5 652C919.511 652 917.603 653.264 916.197 655.515C914.79 657.765 914 660.817 914 664L921.5 664H929Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M918.016 657.08C916.825 659.047 916.778 661.197 916.145 660.814C915.513 660.431 915.966 658.527 917.157 656.56C918.349 654.594 919.827 653.311 920.459 653.694C921.092 654.077 919.207 655.114 918.016 657.08Z",
    fill: "#1E1E1E"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M945 664C945 660.817 944.21 657.765 942.803 655.515C941.397 653.264 939.489 652 937.5 652C935.511 652 933.603 653.264 932.197 655.515C930.79 657.765 930 660.817 930 664L937.5 664H945Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M934.016 657.08C932.825 659.047 932.778 661.197 932.145 660.814C931.513 660.431 931.966 658.527 933.157 656.56C934.349 654.594 935.827 653.311 936.459 653.694C937.092 654.077 935.207 655.114 934.016 657.08Z",
    fill: "#1E1E1E"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M961 664C961 660.817 960.21 657.765 958.803 655.515C957.397 653.264 955.489 652 953.5 652C951.511 652 949.603 653.264 948.197 655.515C946.79 657.765 946 660.817 946 664L953.5 664H961Z",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M950.016 657.08C948.825 659.047 948.778 661.197 948.145 660.814C947.513 660.431 947.966 658.527 949.157 656.56C950.349 654.594 951.827 653.311 952.459 653.694C953.092 654.077 951.207 655.114 950.016 657.08Z",
    fill: "#1E1E1E"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M977 664C977 660.817 976.21 657.765 974.803 655.515C973.397 653.264 971.489 652 969.5 652C967.511 652 965.603 653.264 964.197 655.515C962.79 657.765 962 660.817 962 664L969.5 664H977Z",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M966.016 657.08C964.825 659.047 964.778 661.197 964.145 660.814C963.513 660.431 963.966 658.527 965.157 656.56C966.349 654.594 967.827 653.311 968.459 653.694C969.092 654.077 967.207 655.114 966.016 657.08Z",
    fill: "#1E1E1E"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M993 664C993 660.817 992.21 657.765 990.803 655.515C989.397 653.264 987.489 652 985.5 652C983.511 652 981.603 653.264 980.197 655.515C978.79 657.765 978 660.817 978 664L985.5 664H993Z",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M982.016 657.08C980.825 659.047 980.778 661.197 980.145 660.814C979.513 660.431 979.966 658.527 981.157 656.56C982.349 654.594 983.827 653.311 984.459 653.694C985.092 654.077 983.207 655.114 982.016 657.08Z",
    fill: "#1E1E1E"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M997.271 660.45C997.636 661.728 996.677 663 995.348 663L911.652 663C910.323 663 909.364 661.728 909.729 660.45L912.874 649.45C913.12 648.592 913.905 648 914.797 648L992.203 648C993.095 648 993.88 648.592 994.126 649.45L997.271 660.45Z",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M910.21 634.412C909.936 633.454 910.655 632.5 911.652 632.5H995.348C996.345 632.5 997.064 633.454 996.79 634.412L993.645 645.412C993.461 646.056 992.872 646.5 992.203 646.5H914.797C914.128 646.5 913.539 646.056 913.355 645.412L910.21 634.412Z",
    fill: "white",
    stroke: "#1E1E1E"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M929 632C929 628.817 928.21 625.765 926.803 623.515C925.397 621.264 923.489 620 921.5 620C919.511 620 917.603 621.264 916.197 623.515C914.79 625.765 914 628.817 914 632L921.5 632H929Z",
    fill: "white"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M918.016 625.08C916.825 627.047 916.778 629.197 916.145 628.814C915.513 628.431 915.966 626.527 917.157 624.56C918.349 622.594 919.827 621.311 920.459 621.694C921.092 622.077 919.207 623.114 918.016 625.08Z",
    fill: "#1E1E1E"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M945 632C945 628.817 944.21 625.765 942.803 623.515C941.397 621.264 939.489 620 937.5 620C935.511 620 933.603 621.264 932.197 623.515C930.79 625.765 930 628.817 930 632L937.5 632H945Z",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M934.016 625.08C932.825 627.047 932.778 629.197 932.145 628.814C931.513 628.431 931.966 626.527 933.157 624.56C934.349 622.594 935.827 621.311 936.459 621.694C937.092 622.077 935.207 623.114 934.016 625.08Z",
    fill: "#1E1E1E"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M961 632C961 628.817 960.21 625.765 958.803 623.515C957.397 621.264 955.489 620 953.5 620C951.511 620 949.603 621.264 948.197 623.515C946.79 625.765 946 628.817 946 632L953.5 632H961Z",
    fill: "white"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M950.016 625.08C948.825 627.047 948.778 629.197 948.145 628.814C947.513 628.431 947.966 626.527 949.157 624.56C950.349 622.594 951.827 621.311 952.459 621.694C953.092 622.077 951.207 623.114 950.016 625.08Z",
    fill: "#1E1E1E"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M977 632C977 628.817 976.21 625.765 974.803 623.515C973.397 621.264 971.489 620 969.5 620C967.511 620 965.603 621.264 964.197 623.515C962.79 625.765 962 628.817 962 632L969.5 632H977Z",
    fill: "white"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M966.016 625.08C964.825 627.047 964.778 629.197 964.145 628.814C963.513 628.431 963.966 626.527 965.157 624.56C966.349 622.594 967.827 621.311 968.459 621.694C969.092 622.077 967.207 623.114 966.016 625.08Z",
    fill: "#1E1E1E"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M993 632C993 628.817 992.21 625.765 990.803 623.515C989.397 621.264 987.489 620 985.5 620C983.511 620 981.603 621.264 980.197 623.515C978.79 625.765 978 628.817 978 632L985.5 632H993Z",
    fill: "white"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M982.016 625.08C980.825 627.047 980.778 629.197 980.145 628.814C979.513 628.431 979.966 626.527 981.157 624.56C982.349 622.594 983.827 621.311 984.459 621.694C985.092 622.077 983.207 623.114 982.016 625.08Z",
    fill: "#1E1E1E"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M997.271 628.45C997.636 629.728 996.677 631 995.348 631L911.652 631C910.323 631 909.364 629.728 909.729 628.45L912.874 617.45C913.12 616.592 913.905 616 914.797 616L992.203 616C993.095 616 993.88 616.592 994.126 617.45L997.271 628.45Z",
    fill: "white"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M1137.52 650.275C1137.65 658.003 1138.39 663.511 1139.61 667.429C1140.83 671.34 1142.53 673.635 1144.56 674.991C1146.6 676.353 1149.04 676.816 1151.85 676.924C1153.26 676.978 1154.74 676.943 1156.3 676.895C1156.54 676.887 1156.78 676.879 1157.02 676.871C1158.35 676.828 1159.74 676.783 1161.15 676.783C1174.16 676.783 1184.79 664.973 1184.79 650.283C1184.79 635.594 1174.16 623.783 1161.15 623.783C1159.51 623.783 1157.89 623.708 1156.34 623.635L1156.24 623.63C1154.66 623.556 1153.14 623.487 1151.69 623.502C1148.79 623.533 1146.25 623.906 1144.15 625.209C1142.06 626.502 1140.34 628.757 1139.17 632.707C1137.99 636.668 1137.38 642.297 1137.52 650.275Z",
    fill: "#1E1E1E",
    stroke: "white"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 24.1364,
    ry: 27,
    transform: "matrix(-1 0 0 1 1147.14 650.284)",
    fill: "white"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M1128.36 648.784C1127.93 634.384 1139.63 627.784 1145.53 626.284C1149.82 626.284 1153.57 627.284 1145.53 629.284C1137.48 631.284 1133.19 638.784 1131.58 643.284C1129.97 647.784 1128.9 666.784 1128.36 648.784Z",
    fill: "white"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M1121.98 650.519C1113.3 652.363 1109.6 658.297 1108.65 661.5H1152.16L1121.98 650.519Z",
    fill: "#1E1E1E",
    stroke: "white"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 16,
    transform: "matrix(-1 0 0 1 1155 662)",
    fill: "white"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M1148.54 666.844C1148.54 666.425 1148.63 666.013 1148.81 665.65C1148.99 665.286 1149.24 664.983 1149.55 664.77C1149.86 664.558 1150.21 664.443 1150.57 664.438C1150.93 664.432 1151.28 664.536 1151.59 664.739C1151.9 664.942 1152.17 665.237 1152.35 665.595C1152.54 665.953 1152.64 666.362 1152.65 666.781C1152.66 667.199 1152.57 667.614 1152.41 667.983C1152.24 668.351 1151.99 668.662 1151.68 668.884L1150.59 666.844H1148.54Z",
    fill: "#1E1E1E"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 2.08154,
    ry: 2.38441,
    transform: "matrix(0.954192 0.299194 0.223199 -0.974773 1144.13 673.031)",
    fill: "#1E1E1E"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 1.18532,
    ry: 1.35779,
    transform: "matrix(0.954192 0.299194 0.223199 -0.974773 1111.59 665.696)",
    fill: "#1E1E1E"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M1129.7 668.902C1130.07 669.422 1130.58 669.774 1131.14 669.897C1131.71 670.019 1132.29 669.904 1132.79 669.571C1133.29 669.238 1133.68 668.709 1133.88 668.077C1134.08 667.445 1134.08 666.751 1133.89 666.117C1133.69 665.483 1133.31 664.95 1132.81 664.613C1132.31 664.275 1131.73 664.154 1131.16 664.271C1130.6 664.388 1130.08 664.736 1129.71 665.252C1129.34 665.769 1129.14 666.422 1129.14 667.095L1131.59 667.086L1129.7 668.902Z",
    fill: "#1E1E1E"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M1122.74 673.507C1122.61 674.077 1122.31 674.57 1121.89 674.894C1121.47 675.219 1120.96 675.351 1120.46 675.266C1119.96 675.18 1119.51 674.884 1119.18 674.433C1118.86 673.981 1118.69 673.407 1118.7 672.817C1118.72 672.228 1118.91 671.665 1119.26 671.236C1119.6 670.806 1120.07 670.54 1120.57 670.488C1121.08 670.435 1121.58 670.6 1121.98 670.951C1122.39 671.303 1122.67 671.815 1122.77 672.392L1120.76 672.884L1122.74 673.507Z",
    fill: "#1E1E1E"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M1072.26 616.106C1072.26 613.286 1069.98 611 1067.16 611C1064.34 611 1062.05 613.286 1062.05 616.106V635.395C1062.05 639.852 1058.87 643.57 1055.44 646.42C1051.5 649.699 1049 654.601 1049 660.078C1049 665.068 1051.08 669.58 1054.43 672.822C1055.26 673.629 1055.81 674.707 1055.81 675.866C1055.81 677.957 1057.5 679.652 1059.6 679.652H1074.72C1076.81 679.652 1078.5 677.957 1078.5 675.866C1078.5 674.707 1079.05 673.629 1079.88 672.822C1083.23 669.58 1085.31 665.068 1085.31 660.078C1085.31 654.601 1082.81 649.699 1078.87 646.42C1075.44 643.57 1072.26 639.852 1072.26 635.395V616.106Z",
    fill: "white"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M1071.77 663.621C1074.32 666.169 1078.66 666.139 1079.68 662.681C1079.79 662.31 1079.88 661.934 1079.95 661.553C1080.46 659.022 1080.2 656.398 1079.21 654.013C1078.22 651.629 1076.55 649.591 1074.41 648.157C1072.26 646.723 1069.74 645.957 1067.16 645.957C1064.57 645.957 1062.05 646.723 1059.91 648.157C1057.76 649.591 1056.09 651.629 1055.1 654.013C1054.11 656.398 1053.85 659.022 1054.36 661.553C1054.43 661.934 1054.52 662.31 1054.63 662.681C1055.65 666.139 1059.99 666.169 1062.54 663.621C1065.09 661.073 1069.22 661.073 1071.77 663.621Z",
    fill: "#1E1E1E"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 1062.05,
    y: 610.78,
    width: 10.2128,
    height: 4.53901,
    fill: "#1E1E1E"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M1062 605C1062 602.239 1064.24 600 1067 600H1067.21C1069.97 600 1072.21 602.239 1072.21 605V610.78H1062V605Z",
    fill: "white"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M1038.16 611.848C1040.7 611.848 1042.76 613.91 1042.76 616.454V635.743C1042.76 640.44 1046.1 644.287 1049.55 647.152C1053.38 650.341 1055.81 655.105 1055.81 660.426C1055.81 665.273 1053.79 669.658 1050.54 672.811C1049.63 673.692 1049 674.893 1049 676.213C1049 678.029 1047.53 679.5 1045.72 679.5H1030.6C1028.78 679.5 1027.31 678.029 1027.31 676.213C1027.31 674.893 1026.69 673.692 1025.77 672.811C1022.52 669.658 1020.5 665.273 1020.5 660.426C1020.5 655.105 1022.93 650.341 1026.76 647.152C1030.21 644.287 1033.55 640.44 1033.55 635.743V616.454C1033.55 613.91 1035.61 611.848 1038.16 611.848Z",
    fill: "white",
    stroke: "#1E1E1E"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M1042.77 663.621C1045.32 666.169 1049.66 666.139 1050.68 662.681C1050.79 662.31 1050.88 661.934 1050.95 661.553C1051.46 659.022 1051.2 656.398 1050.21 654.013C1049.22 651.629 1047.55 649.591 1045.41 648.157C1043.26 646.723 1040.74 645.957 1038.16 645.957C1035.57 645.957 1033.05 646.723 1030.91 648.157C1028.76 649.591 1027.09 651.629 1026.1 654.013C1025.11 656.398 1024.85 659.022 1025.36 661.553C1025.43 661.934 1025.52 662.31 1025.63 662.681C1026.65 666.139 1030.99 666.169 1033.54 663.621C1036.09 661.073 1040.22 661.073 1042.77 663.621Z",
    fill: "#1E1E1E"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 1033.05,
    y: 610.78,
    width: 10.2128,
    height: 4.53901,
    fill: "#1E1E1E"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M1033.05 605C1033.05 602.239 1035.29 600 1038.05 600H1038.26C1041.02 600 1043.26 602.239 1043.26 605V610.78H1033.05V605Z",
    fill: "white"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M1027.41 742.89H1084.22L1082.54 774.442C1082.4 776.998 1080.29 779.001 1077.73 779.001H1034.32C1031.79 779.001 1029.68 777.036 1029.52 774.506L1027.41 742.89Z",
    fill: "white"
  })), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "path-141-outside-5_4896_18569",
    maskUnits: "userSpaceOnUse",
    x: 1024,
    y: 733.223,
    width: 65,
    height: 11,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 1024,
    y: 733.223,
    width: 65,
    height: 11
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1029.81 734.223C1028.49 734.223 1027.41 735.3 1027.41 736.63V738.556C1026.08 738.556 1025 739.634 1025 740.963V742.889H1087.11V740.963C1087.11 739.634 1086.03 738.556 1084.7 738.556L1084.22 738.556V736.63C1084.22 735.3 1083.14 734.223 1081.81 734.223H1029.81Z"
  }))), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1029.81 734.223C1028.49 734.223 1027.41 735.3 1027.41 736.63V738.556C1026.08 738.556 1025 739.634 1025 740.963V742.889H1087.11V740.963C1087.11 739.634 1086.03 738.556 1084.7 738.556L1084.22 738.556V736.63C1084.22 735.3 1083.14 734.223 1081.81 734.223H1029.81Z",
    fill: "#1E1E1E"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M1027.41 738.556L1027.41 739.556L1028.41 739.556V738.556H1027.41ZM1025 742.889H1024V743.889H1025V742.889ZM1087.11 742.889V743.889H1088.11V742.889H1087.11ZM1084.7 738.556V737.556V738.556ZM1084.22 738.556H1083.22V739.556L1084.22 739.556V738.556ZM1028.41 736.63C1028.41 735.853 1029.04 735.223 1029.81 735.223V733.223C1027.93 733.223 1026.41 734.748 1026.41 736.63H1028.41ZM1028.41 738.556V736.63H1026.41V738.556H1028.41ZM1026 740.963C1026 740.186 1026.63 739.556 1027.41 739.556L1027.41 737.556C1025.53 737.556 1024 739.082 1024 740.963H1026ZM1026 742.889V740.963H1024V742.889H1026ZM1087.11 741.889H1025V743.889H1087.11V741.889ZM1086.11 740.963V742.889H1088.11V740.963H1086.11ZM1084.7 739.556C1085.48 739.556 1086.11 740.186 1086.11 740.963H1088.11C1088.11 739.082 1086.59 737.556 1084.7 737.556V739.556ZM1084.22 739.556L1084.7 739.556V737.556L1084.22 737.556V739.556ZM1083.22 736.63V738.556H1085.22V736.63H1083.22ZM1081.81 735.223C1082.59 735.223 1083.22 735.853 1083.22 736.63H1085.22C1085.22 734.748 1083.7 733.223 1081.81 733.223V735.223ZM1029.81 735.223H1081.81V733.223H1029.81V735.223Z",
    fill: "white",
    mask: "url(#path-141-outside-5_4896_18569)"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 1038.02,
    y: 747.242,
    width: 36.0741,
    height: 23.0741,
    rx: 0.944444,
    fill: "white",
    stroke: "#1E1E1E"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M1052.2 761.186L1074.83 746.742V769.371C1074.83 770.169 1074.19 770.816 1073.39 770.816H1037.76L1052.2 761.186Z",
    fill: "#1E1E1E"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M1118.41 742.89H1175.22L1173.54 774.442C1173.4 776.998 1171.29 779.001 1168.73 779.001H1125.32C1122.79 779.001 1120.68 777.036 1120.52 774.506L1118.41 742.89Z",
    fill: "white"
  })), _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", {
    id: "path-146-outside-6_4896_18569",
    maskUnits: "userSpaceOnUse",
    x: 1115,
    y: 733.223,
    width: 65,
    height: 11,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 1115,
    y: 733.223,
    width: 65,
    height: 11
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1120.81 734.223C1119.49 734.223 1118.41 735.3 1118.41 736.63V738.556C1117.08 738.556 1116 739.634 1116 740.963V742.889H1178.11V740.963C1178.11 739.634 1177.03 738.556 1175.7 738.556L1175.22 738.556V736.63C1175.22 735.3 1174.14 734.223 1172.81 734.223H1120.81Z"
  }))), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1120.81 734.223C1119.49 734.223 1118.41 735.3 1118.41 736.63V738.556C1117.08 738.556 1116 739.634 1116 740.963V742.889H1178.11V740.963C1178.11 739.634 1177.03 738.556 1175.7 738.556L1175.22 738.556V736.63C1175.22 735.3 1174.14 734.223 1172.81 734.223H1120.81Z",
    fill: "#1E1E1E"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M1118.41 738.556L1118.41 739.556L1119.41 739.556V738.556H1118.41ZM1116 742.889H1115V743.889H1116V742.889ZM1178.11 742.889V743.889H1179.11V742.889H1178.11ZM1175.7 738.556V737.556V738.556ZM1175.22 738.556H1174.22V739.556L1175.22 739.556V738.556ZM1119.41 736.63C1119.41 735.853 1120.04 735.223 1120.81 735.223V733.223C1118.93 733.223 1117.41 734.748 1117.41 736.63H1119.41ZM1119.41 738.556V736.63H1117.41V738.556H1119.41ZM1117 740.963C1117 740.186 1117.63 739.556 1118.41 739.556L1118.41 737.556C1116.53 737.556 1115 739.082 1115 740.963H1117ZM1117 742.889V740.963H1115V742.889H1117ZM1178.11 741.889H1116V743.889H1178.11V741.889ZM1177.11 740.963V742.889H1179.11V740.963H1177.11ZM1175.7 739.556C1176.48 739.556 1177.11 740.186 1177.11 740.963H1179.11C1179.11 739.082 1177.59 737.556 1175.7 737.556V739.556ZM1175.22 739.556L1175.7 739.556V737.556L1175.22 737.556V739.556ZM1174.22 736.63V738.556H1176.22V736.63H1174.22ZM1172.81 735.223C1173.59 735.223 1174.22 735.853 1174.22 736.63H1176.22C1176.22 734.748 1174.7 733.223 1172.81 733.223V735.223ZM1120.81 735.223H1172.81V733.223H1120.81V735.223Z",
    fill: "white",
    mask: "url(#path-146-outside-6_4896_18569)"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 1129.02,
    y: 747.242,
    width: 36.0741,
    height: 23.0741,
    rx: 0.944444,
    fill: "white",
    stroke: "#1E1E1E"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M1143.2 761.186L1165.83 746.742V769.371C1165.83 770.169 1165.19 770.816 1164.39 770.816H1128.76L1143.2 761.186Z",
    fill: "#1E1E1E"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M1034.79 707.45H1077.07L1075.82 730.931C1075.72 732.833 1074.15 734.323 1072.24 734.323H1039.93C1038.05 734.323 1036.49 732.861 1036.36 730.978L1034.79 707.45Z",
    fill: "white"
  })), _mask7 || (_mask7 = /*#__PURE__*/React.createElement("mask", {
    id: "path-151-outside-7_4896_18569",
    maskUnits: "userSpaceOnUse",
    x: 1032,
    y: 700,
    width: 49,
    height: 9,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 1032,
    y: 700,
    width: 49,
    height: 9
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1036.58 701C1035.59 701 1034.79 701.802 1034.79 702.792V704.225H1034.79C1033.8 704.225 1033 705.027 1033 706.016V707.449H1079.22V706.016C1079.22 705.027 1078.42 704.225 1077.43 704.225H1077.07V702.792C1077.07 701.802 1076.27 701 1075.28 701H1036.58Z"
  }))), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1036.58 701C1035.59 701 1034.79 701.802 1034.79 702.792V704.225H1034.79C1033.8 704.225 1033 705.027 1033 706.016V707.449H1079.22V706.016C1079.22 705.027 1078.42 704.225 1077.43 704.225H1077.07V702.792C1077.07 701.802 1076.27 701 1075.28 701H1036.58Z",
    fill: "#1E1E1E"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M1034.79 704.225V705.225H1035.79V704.225H1034.79ZM1033 707.449H1032V708.449H1033V707.449ZM1079.22 707.449V708.449H1080.22V707.449H1079.22ZM1077.07 704.225H1076.07V705.225H1077.07V704.225ZM1035.79 702.792C1035.79 702.354 1036.15 702 1036.58 702V700C1035.04 700 1033.79 701.25 1033.79 702.792H1035.79ZM1035.79 704.225V702.792H1033.79V704.225H1035.79ZM1034.79 705.225H1034.79V703.225H1034.79V705.225ZM1034 706.016C1034 705.579 1034.35 705.225 1034.79 705.225V703.225C1033.25 703.225 1032 704.474 1032 706.016H1034ZM1034 707.449V706.016H1032V707.449H1034ZM1079.22 706.449H1033V708.449H1079.22V706.449ZM1078.22 706.016V707.449H1080.22V706.016H1078.22ZM1077.43 705.225C1077.87 705.225 1078.22 705.579 1078.22 706.016H1080.22C1080.22 704.474 1078.97 703.225 1077.43 703.225V705.225ZM1077.07 705.225H1077.43V703.225H1077.07V705.225ZM1076.07 702.792V704.225H1078.07V702.792H1076.07ZM1075.28 702C1075.72 702 1076.07 702.354 1076.07 702.792H1078.07C1078.07 701.25 1076.82 700 1075.28 700V702ZM1036.58 702H1075.28V700H1036.58V702Z",
    fill: "white",
    mask: "url(#path-151-outside-7_4896_18569)"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 1042.82,
    y: 710.816,
    width: 26.59,
    height: 16.9156,
    rx: 0.574935,
    fill: "white",
    stroke: "#1E1E1E"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M1044.15 727.732L1053.52 721.484L1069.59 711.228V727.157C1069.59 727.474 1069.33 727.732 1069.01 727.732H1044.15Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M1124.79 707.45H1167.07L1165.82 730.931C1165.72 732.833 1164.15 734.323 1162.24 734.323H1129.93C1128.05 734.323 1126.49 732.861 1126.36 730.978L1124.79 707.45Z",
    fill: "white"
  })), _mask8 || (_mask8 = /*#__PURE__*/React.createElement("mask", {
    id: "path-156-outside-8_4896_18569",
    maskUnits: "userSpaceOnUse",
    x: 1122,
    y: 700,
    width: 49,
    height: 9,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 1122,
    y: 700,
    width: 49,
    height: 9
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1126.58 701C1125.59 701 1124.79 701.802 1124.79 702.792V704.225H1124.79C1123.8 704.225 1123 705.027 1123 706.016V707.449H1169.22V706.016C1169.22 705.027 1168.42 704.225 1167.43 704.225H1167.07V702.792C1167.07 701.802 1166.27 701 1165.28 701H1126.58Z"
  }))), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1126.58 701C1125.59 701 1124.79 701.802 1124.79 702.792V704.225H1124.79C1123.8 704.225 1123 705.027 1123 706.016V707.449H1169.22V706.016C1169.22 705.027 1168.42 704.225 1167.43 704.225H1167.07V702.792C1167.07 701.802 1166.27 701 1165.28 701H1126.58Z",
    fill: "#1E1E1E"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M1124.79 704.225V705.225H1125.79V704.225H1124.79ZM1123 707.449H1122V708.449H1123V707.449ZM1169.22 707.449V708.449H1170.22V707.449H1169.22ZM1167.07 704.225H1166.07V705.225H1167.07V704.225ZM1125.79 702.792C1125.79 702.354 1126.15 702 1126.58 702V700C1125.04 700 1123.79 701.25 1123.79 702.792H1125.79ZM1125.79 704.225V702.792H1123.79V704.225H1125.79ZM1124.79 705.225H1124.79V703.225H1124.79V705.225ZM1124 706.016C1124 705.579 1124.35 705.225 1124.79 705.225V703.225C1123.25 703.225 1122 704.474 1122 706.016H1124ZM1124 707.449V706.016H1122V707.449H1124ZM1169.22 706.449H1123V708.449H1169.22V706.449ZM1168.22 706.016V707.449H1170.22V706.016H1168.22ZM1167.43 705.225C1167.87 705.225 1168.22 705.579 1168.22 706.016H1170.22C1170.22 704.474 1168.97 703.225 1167.43 703.225V705.225ZM1167.07 705.225H1167.43V703.225H1167.07V705.225ZM1166.07 702.792V704.225H1168.07V702.792H1166.07ZM1165.28 702C1165.72 702 1166.07 702.354 1166.07 702.792H1168.07C1168.07 701.25 1166.82 700 1165.28 700V702ZM1126.58 702H1165.28V700H1126.58V702Z",
    fill: "white",
    mask: "url(#path-156-outside-8_4896_18569)"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 1132.82,
    y: 710.816,
    width: 26.59,
    height: 16.9156,
    rx: 0.574935,
    fill: "white",
    stroke: "#1E1E1E"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M1143.25 721.065L1160.09 710.316V727.157C1160.09 727.75 1159.6 728.232 1159.01 728.232H1132.5L1143.25 721.065Z",
    fill: "#1E1E1E"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M254.959 523.965C254.449 525.495 253.945 526.817 253.084 528.149C252.225 529.48 250.996 530.844 249.016 532.422C245.039 535.591 238.089 539.584 225.177 545.89C217.192 549.789 212.872 554.089 211.253 558.133C209.617 562.218 210.769 565.963 213.527 568.576C219 573.761 230.701 574.473 239.567 565.3C243.863 560.856 250.787 553.633 256.486 546.238C259.336 542.541 261.891 538.787 263.66 535.305C265.42 531.839 266.441 528.569 266.123 525.865C265.874 523.743 265.155 522.259 264.136 521.322C263.113 520.383 261.842 520.045 260.594 520.111C259.352 520.176 258.119 520.64 257.116 521.323C256.118 522.003 255.303 522.932 254.959 523.965Z",
    fill: "white",
    stroke: "#1E1E1E"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M263.239 521.203V517H260.236L260.837 520.603L263.239 521.203Z",
    fill: "#1E1E1E"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M231.416 565.036C239.102 562.635 249.029 550.425 253.032 544.621C254.317 542.82 251.831 541.619 250.63 544.621C249.429 547.623 238.021 557.831 231.416 562.034C224.811 566.237 221.809 568.039 231.416 565.036Z",
    fill: "#1E1E1E"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M260.925 518.902H260.843L260.765 518.928C259.621 519.316 257.906 520.05 256.466 521.006C255.746 521.484 255.075 522.03 254.579 522.632C254.084 523.232 253.732 523.927 253.732 524.69C253.732 525.347 253.881 525.898 254.275 526.232C254.681 526.577 255.193 526.564 255.61 526.459C256.147 526.323 256.722 525.987 257.216 525.628C257.333 526.044 257.536 526.488 257.857 526.89C258.46 527.646 259.444 528.211 260.925 528.211C262.07 528.211 262.883 527.872 263.416 527.319C263.5 527.231 263.577 527.139 263.645 527.044C263.748 527.234 263.869 527.413 264.012 527.575C264.271 527.868 264.604 528.106 265.022 528.225C265.439 528.345 265.905 528.336 266.415 528.192C267.356 527.927 267.809 527.074 267.915 526.152C268.022 525.225 267.807 524.117 267.318 523.063C266.336 520.948 264.176 518.902 260.925 518.902Z",
    fill: "#1E1E1E",
    stroke: "white"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M275.959 551.965C275.449 553.495 274.945 554.817 274.084 556.149C273.225 557.48 271.996 558.844 270.016 560.422C266.039 563.591 259.089 567.584 246.177 573.89C238.192 577.789 233.872 582.089 232.253 586.134C230.617 590.218 231.769 593.963 234.527 596.576C240 601.761 251.701 602.473 260.567 593.301C264.863 588.856 271.787 581.633 277.486 574.238C280.336 570.541 282.891 566.787 284.66 563.305C286.42 559.839 287.441 556.569 287.123 553.865C286.874 551.743 286.155 550.259 285.136 549.323C284.113 548.383 282.842 548.045 281.594 548.111C280.352 548.177 279.119 548.64 278.116 549.323C277.118 550.003 276.303 550.932 275.959 551.965Z",
    fill: "white",
    stroke: "#1E1E1E"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M284.239 549.203V545H281.236L281.837 548.603L284.239 549.203Z",
    fill: "#1E1E1E"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M252.416 593.036C260.102 590.635 270.029 578.426 274.032 572.621C275.317 570.82 272.831 569.619 271.63 572.621C270.429 575.623 259.021 585.831 252.416 590.034C245.811 594.237 242.809 596.039 252.416 593.036Z",
    fill: "#1E1E1E"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M281.925 546.902H281.843L281.765 546.928C280.621 547.316 278.906 548.05 277.466 549.006C276.746 549.484 276.075 550.03 275.579 550.632C275.084 551.233 274.732 551.927 274.732 552.69C274.732 553.347 274.881 553.898 275.275 554.233C275.681 554.577 276.193 554.564 276.61 554.459C277.147 554.323 277.722 553.988 278.216 553.628C278.333 554.044 278.536 554.488 278.857 554.89C279.46 555.646 280.444 556.211 281.925 556.211C283.07 556.211 283.883 555.872 284.416 555.319C284.5 555.231 284.577 555.139 284.645 555.044C284.748 555.234 284.869 555.413 285.012 555.575C285.271 555.868 285.604 556.106 286.022 556.225C286.439 556.345 286.905 556.336 287.415 556.192C288.356 555.927 288.809 555.074 288.915 554.152C289.022 553.225 288.807 552.117 288.318 551.063C287.336 548.948 285.176 546.902 281.925 546.902Z",
    fill: "#1E1E1E",
    stroke: "white"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M258.994 536.781C258.333 538.763 257.676 540.487 256.553 542.226C255.432 543.964 253.83 545.738 251.259 547.787C246.102 551.898 237.1 557.068 220.4 565.223C210.088 570.259 204.538 575.799 202.463 580.981C200.372 586.204 201.842 590.985 205.369 594.326C212.38 600.969 227.421 601.909 238.842 590.094C244.399 584.346 253.348 575.009 260.714 565.452C264.396 560.674 267.695 555.827 269.977 551.335C272.251 546.859 273.555 542.661 273.148 539.21C272.828 536.488 271.91 534.606 270.624 533.425C269.335 532.241 267.732 531.813 266.15 531.896C264.575 531.98 263.005 532.569 261.727 533.439C260.454 534.306 259.426 535.483 258.994 536.781Z",
    fill: "white",
    stroke: "#1E1E1E"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M269.565 533.163V527.727H265.682L266.458 532.386L269.565 533.163Z",
    fill: "#1E1E1E"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M228.404 589.854C238.344 586.748 251.184 570.957 256.361 563.45C258.024 561.12 254.808 559.567 253.255 563.45C251.701 567.333 236.946 580.535 228.404 585.971C219.861 591.407 215.978 593.737 228.404 589.854Z",
    fill: "#1E1E1E"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M266.57 530.332H266.487L266.409 530.359C264.939 530.857 262.733 531.802 260.883 533.029C259.959 533.643 259.104 534.34 258.475 535.103C257.847 535.865 257.414 536.732 257.414 537.671C257.414 538.506 257.603 539.164 258.064 539.555C258.537 539.955 259.141 539.948 259.66 539.817C260.393 539.631 261.194 539.143 261.86 538.637C261.996 539.216 262.261 539.855 262.717 540.426C263.467 541.366 264.696 542.079 266.57 542.079C268.02 542.079 269.031 541.651 269.686 540.97C269.851 540.799 269.989 540.616 270.104 540.426C270.255 540.744 270.441 541.045 270.673 541.306C270.992 541.667 271.4 541.957 271.909 542.103C272.418 542.249 272.992 542.24 273.63 542.06C274.768 541.74 275.331 540.707 275.465 539.545C275.6 538.38 275.33 536.974 274.705 535.629C273.454 532.932 270.704 530.332 266.57 530.332Z",
    fill: "#1E1E1E",
    stroke: "white"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M150.5 577.159C150.5 589.222 140.091 599 127.25 599C114.409 599 104 589.222 104 577.159C104 565.097 114.409 556.728 127.25 556.728C140.091 556.728 150.5 565.097 150.5 577.159Z",
    fill: "white"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M110.606 579.273C107.788 571.946 111.78 564.947 114.129 562.364C117.651 562.364 117.652 567.296 114.129 570.818C110.606 574.341 114.129 588.432 110.606 579.273Z",
    fill: "#1E1E1E"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M115.955 559.381C118.774 557.127 124.645 558.442 127.228 559.381C133.569 557.267 142.023 559.381 137.796 559.381C133.569 559.381 128.637 561.496 132.864 561.496C135.96 561.496 137.167 565.652 137.591 567.324C137.724 567.512 137.796 567.686 137.796 567.836C137.796 568.214 137.746 567.935 137.591 567.324C136.47 565.741 131.005 563.13 127.228 565.018C123.001 567.132 127.228 574.882 123.705 569.246C120.183 563.609 123.705 563.609 123.705 561.496C123.705 559.382 112.433 562.2 115.955 559.381Z",
    fill: "#1E1E1E"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 127.249,
    cy: 561.659,
    rx: 3.52273,
    ry: 2.11364,
    fill: "#1E1E1E"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M197 577.159C197 589.222 186.591 599 173.75 599C160.909 599 150.5 589.222 150.5 577.159C150.5 565.097 160.909 556.728 173.75 556.728C186.591 556.728 197 565.097 197 577.159Z",
    fill: "white"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M157.106 579.273C154.288 571.946 158.28 564.947 160.629 562.364C164.151 562.364 164.152 567.296 160.629 570.818C157.106 574.341 160.629 588.432 157.106 579.273Z",
    fill: "#1E1E1E"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M162.455 559.381C165.274 557.127 171.145 558.442 173.728 559.381C180.069 557.267 188.523 559.381 184.296 559.381C180.069 559.381 175.137 561.496 179.364 561.496C182.46 561.496 183.667 565.652 184.091 567.324C184.224 567.512 184.296 567.686 184.296 567.836C184.296 568.214 184.246 567.935 184.091 567.324C182.97 565.741 177.505 563.13 173.728 565.018C169.501 567.132 173.728 574.882 170.205 569.246C166.683 563.609 170.205 563.609 170.205 561.496C170.205 559.382 158.933 562.2 162.455 559.381Z",
    fill: "#1E1E1E"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 173.749,
    cy: 561.659,
    rx: 3.52273,
    ry: 2.11364,
    fill: "#1E1E1E"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M173.045 537.704C173.045 549.767 162.636 559.545 149.795 559.545C136.954 559.545 126.545 549.767 126.545 537.704C126.545 525.642 136.954 517.272 149.795 517.272C162.636 517.272 173.045 525.642 173.045 537.704Z",
    fill: "white"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M133.151 539.818C130.333 532.491 134.325 525.492 136.674 522.909C140.196 522.909 140.197 527.841 136.674 531.363C133.151 534.886 136.674 548.977 133.151 539.818Z",
    fill: "#1E1E1E"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M138.5 519.926C141.318 517.672 147.19 518.987 149.773 519.926C156.114 517.812 164.568 519.926 160.341 519.926C156.114 519.926 151.182 522.04 155.409 522.04C158.505 522.04 159.712 526.197 160.136 527.869C160.269 528.057 160.341 528.231 160.341 528.381C160.341 528.759 160.291 528.48 160.136 527.869C159.015 526.286 153.55 523.675 149.773 525.563C145.546 527.677 149.773 535.427 146.25 529.79C142.728 524.154 146.25 524.154 146.25 522.04C146.25 519.927 134.978 522.745 138.5 519.926Z",
    fill: "#1E1E1E"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 149.794,
    cy: 522.204,
    rx: 3.52273,
    ry: 2.11364,
    fill: "#1E1E1E"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2373 558.176C62.6099 580.365 63.8494 590.402 57.8198 593.764C51.7903 597.126 40.7749 592.54 28.4024 570.352C16.0299 548.163 10.8879 527.45 16.9175 524.088C22.947 520.726 37.8648 535.988 50.2373 558.176Z",
    fill: "white"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6824 587.599C32.6487 577.731 18.1487 551.264 16.0539 533.513C14.5983 521.177 20.421 529.717 20.421 536.834C20.421 543.951 42.7415 577.636 44.6824 580.957C46.6233 584.278 59.7244 599.935 44.6824 587.599Z",
    fill: "#1E1E1E"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2373 554.176C99.6099 576.365 100.849 586.402 94.8198 589.764C88.7903 593.126 77.7749 588.54 65.4024 566.352C53.0299 544.163 47.8879 523.45 53.9175 520.088C59.947 516.726 74.8648 531.988 87.2373 554.176Z",
    fill: "white"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6824 583.599C69.6487 573.731 55.1487 547.264 53.0539 529.513C51.5983 517.177 57.421 525.717 57.421 532.834C57.421 539.951 79.7415 573.636 81.6824 576.957C83.6233 580.278 96.7244 595.935 81.6824 583.599Z",
    fill: "#1E1E1E"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0633 597.201C77.6821 596.298 78.8202 594.937 79.3968 593.052C79.968 591.184 79.9801 588.831 79.4203 585.935C78.3016 580.15 74.865 572.036 68.674 560.933C62.4726 549.811 55.625 540.41 49.5563 534.201C46.5246 531.099 43.6669 528.773 41.1633 527.434C38.6836 526.108 36.4134 525.681 34.674 526.651C32.9345 527.621 32.1047 529.777 31.9294 532.583C31.7523 535.417 32.2289 539.071 33.2739 543.28C35.3657 551.706 39.7643 562.473 45.9657 573.595C52.1706 584.723 58.0629 591.49 63.2051 595.05C68.3485 598.612 72.8208 599.009 76.0633 597.201Z",
    fill: "white",
    stroke: "#1E1E1E"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6824 590.599C50.6487 580.731 36.1487 554.264 34.0539 536.513C32.5983 524.177 38.421 532.717 38.421 539.834C38.421 546.951 60.7415 580.636 62.6824 583.957C64.6233 587.278 77.7244 602.935 62.6824 590.599Z",
    fill: "#1E1E1E"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M255.5 640C251.523 640 248.269 643.096 248.016 647.009C241.337 647.264 236 652.759 236 659.5C236 666.068 241.066 671.454 247.504 671.961C246.181 673.966 244.379 675.97 242 677.5C235 682 242.5 687 246.5 686.5C249.701 686.1 252.582 682.177 256.168 677.295C256.659 676.626 257.164 675.939 257.684 675.24C259.973 678.139 263.519 680 267.5 680C274.404 680 280 674.404 280 667.5C280 665.509 279.534 663.626 278.706 661.956C280.751 659.73 282 656.761 282 653.5C282 646.596 276.404 641 269.5 641C266.639 641 264.002 641.962 261.895 643.579C260.575 641.432 258.205 640 255.5 640Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 252.5,
    cy: 666.5,
    r: 7.5,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 654,
    r: 9,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 269,
    cy: 662,
    r: 11,
    fill: "white"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M226.5 606C222.523 606 219.269 609.096 219.016 613.009C212.337 613.264 207 618.759 207 625.5C207 632.068 212.066 637.454 218.504 637.961C217.181 639.966 215.379 641.97 213 643.5C206 648 213.5 653 217.5 652.5C220.701 652.1 223.582 648.177 227.168 643.295C227.659 642.626 228.164 641.939 228.684 641.24C230.973 644.139 234.519 646 238.5 646C245.404 646 251 640.404 251 633.5C251 631.509 250.534 629.626 249.706 627.956C251.751 625.73 253 622.761 253 619.5C253 612.596 247.404 607 240.5 607C237.639 607 235.002 607.962 232.895 609.579C231.575 607.432 229.205 606 226.5 606Z",
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 223.5,
    cy: 632.5,
    r: 7.5,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 226,
    cy: 620,
    r: 9,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 240,
    cy: 628,
    r: 11,
    fill: "white"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M278.756 606.709C276.727 606.709 274.857 607.391 273.363 608.538C272.428 607.015 270.747 606 268.828 606C266.008 606 263.7 608.195 263.521 610.971C258.784 611.151 255 615.048 255 619.828C255 624.486 258.593 628.305 263.158 628.665C262.22 630.087 260.942 631.508 259.255 632.593C254.291 635.784 259.609 639.33 262.446 638.975C264.716 638.692 266.759 635.91 269.302 632.447C269.65 631.973 270.008 631.486 270.377 630.991C272.001 633.046 274.515 634.366 277.338 634.366C282.234 634.366 286.203 630.397 286.203 625.502C286.203 624.09 285.872 622.755 285.285 621.57C286.735 619.992 287.621 617.886 287.621 615.574C287.621 610.678 283.652 606.709 278.756 606.709Z",
    fill: "white"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 266.701,
    cy: 624.792,
    r: 5.31861,
    fill: "white"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 268.474,
    cy: 615.928,
    r: 6.38234,
    fill: "white"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 278.402,
    cy: 621.601,
    r: 7.80063,
    fill: "white"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4976 650.279C34.3577 664.274 54.3341 686.661 57.9299 684.127C61.5258 681.594 48.3294 654.43 38.4693 640.435C28.6092 626.441 25.8194 630.914 22.2235 633.448C18.6277 635.981 14.6375 636.284 24.4976 650.279Z",
    fill: "white"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6061 648.598C26.5119 648.551 27.2084 648.441 27.94 647.925",
    stroke: "#1E1E1E",
    strokeWidth: 0.430518,
    strokeLinecap: "round"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4531 645.106C39.0199 646.361 38.3937 648.08 37.3215 648.978C36.9419 649.295 36.5027 649.56 36.0975 649.846",
    stroke: "#1E1E1E",
    strokeWidth: 0.430518,
    strokeLinecap: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1578 657.589C33.3066 657.587 34.7284 657.805 35.7378 657.118C36.0742 656.89 36.4034 656.649 36.736 656.415C37.288 656.026 37.8399 655.637 38.3918 655.248",
    stroke: "#1E1E1E",
    strokeWidth: 0.430518,
    strokeLinecap: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5273 655.455C46.3809 657.784 45.6454 659.656 43.6406 660.861C43.0219 661.232 42.5306 661.727 41.9482 662.137",
    stroke: "#1E1E1E",
    strokeWidth: 0.430518,
    strokeLinecap: "round"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5688 667.536C42.2066 667.034 43.8871 666.578 45.463 665.899C45.6348 665.826 45.7791 665.736 45.9582 665.683",
    stroke: "#1E1E1E",
    strokeWidth: 0.430518,
    strokeLinecap: "round"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5293 625.872C27.7289 626.941 26.3768 630.115 25.616 636.91C25.4872 638.06 24.0765 638.562 23.2276 637.828C22.3756 637.091 21.2726 636.224 20.1172 635.507C19.5269 635.141 18.7499 634.813 17.93 634.497C17.6792 634.401 17.4227 634.305 17.1681 634.21C16.6113 634.002 16.0633 633.798 15.6036 633.597C15.2654 633.449 14.9499 633.293 14.6941 633.125C14.4509 632.966 14.196 632.754 14.0663 632.469C13.9964 632.316 13.9633 632.142 13.9894 631.958C14.0149 631.777 14.0929 631.618 14.195 631.483C14.3895 631.225 14.7054 631.008 15.0921 630.81C16.0223 630.335 17.0934 630.544 18.0366 630.937C18.9952 631.337 19.9427 631.978 20.7106 632.549C20.7801 632.601 20.8484 632.653 20.9153 632.703C20.1215 630.987 19.3259 628.453 18.9115 626.248C18.6522 624.868 18.5282 623.549 18.6774 622.609C18.7508 622.146 18.9033 621.687 19.2254 621.381C19.5888 621.037 20.0658 620.978 20.5558 621.13C21.052 621.284 21.4328 621.625 21.726 622.027C22.0184 622.428 22.2443 622.917 22.4267 623.422C22.7301 624.262 22.9384 625.225 23.1126 626.03C23.1465 626.186 23.179 626.337 23.2107 626.479C23.2975 626.869 23.3755 627.188 23.4538 627.425C23.6302 627.106 23.8537 626.577 24.1367 625.768C24.5617 624.553 24.9851 623.7 25.411 623.146C25.8328 622.597 26.3266 622.258 26.8881 622.285C27.4313 622.312 27.843 622.675 28.1273 623.046C28.4212 623.43 28.6542 623.918 28.8278 624.39C29.0379 624.962 28.7916 625.522 28.5293 625.872ZM23.5969 627.752C23.5969 627.752 23.5962 627.751 23.5949 627.749L23.5969 627.752ZM23.2543 627.715C23.253 627.716 23.2523 627.717 23.2523 627.717L23.2543 627.715Z",
    fill: "#1E1E1E",
    stroke: "white"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9813 626.507C39.3473 639.801 58.3227 661.066 61.7384 658.659C65.1541 656.253 52.6189 630.45 43.2529 617.157C33.8869 603.863 31.2368 608.113 27.8212 610.52C24.4055 612.926 20.6153 613.214 29.9813 626.507Z",
    fill: "white"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0341 624.91C31.8945 624.865 32.5561 624.761 33.2511 624.272",
    stroke: "#1E1E1E",
    strokeWidth: 0.408946,
    strokeLinecap: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1855 621.594C43.774 622.786 43.1792 624.419 42.1607 625.271C41.8002 625.573 41.3829 625.825 40.9981 626.096",
    stroke: "#1E1E1E",
    strokeWidth: 0.408946,
    strokeLinecap: "round"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2577 633.45C38.3489 633.448 39.6995 633.655 40.6583 633.003C40.9778 632.786 41.2906 632.558 41.6065 632.335C42.1308 631.966 42.6551 631.596 43.1794 631.227",
    stroke: "#1E1E1E",
    strokeWidth: 0.408946,
    strokeLinecap: "round"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9062 631.424C50.7671 633.636 50.0685 635.414 48.1642 636.558C47.5765 636.911 47.1097 637.381 46.5566 637.771",
    stroke: "#1E1E1E",
    strokeWidth: 0.408946,
    strokeLinecap: "round"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M45.248 642.899C46.8038 642.423 48.4001 641.989 49.8971 641.345C50.0602 641.275 50.1973 641.19 50.3674 641.139",
    stroke: "#1E1E1E",
    strokeWidth: 0.408946,
    strokeLinecap: "round"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8298 603.338C33.0737 604.347 31.7899 607.357 31.0674 613.811C30.9427 614.924 29.5783 615.408 28.7574 614.699C27.9486 613.999 26.902 613.176 25.806 612.496C25.2474 612.15 24.5113 611.839 23.7325 611.54C23.4949 611.448 23.2516 611.357 23.0099 611.267C22.4806 611.069 21.959 610.875 21.5217 610.684C21.2 610.543 20.8987 610.394 20.654 610.234C20.4219 610.081 20.1749 609.877 20.0487 609.6C19.9805 609.45 19.9481 609.281 19.9736 609.1C19.9986 608.923 20.0748 608.769 20.1737 608.637C20.3619 608.388 20.666 608.179 21.0345 607.991C21.928 607.535 22.9544 607.737 23.8524 608.111C24.766 608.492 25.6679 609.102 26.3978 609.646C26.4366 609.675 26.4751 609.703 26.5131 609.732C25.7716 608.101 25.0359 605.742 24.6492 603.684C24.4029 602.373 24.2843 601.116 24.4268 600.219C24.4968 599.778 24.6429 599.335 24.9548 599.039C25.3081 598.704 25.7713 598.648 26.2432 598.794C26.7213 598.943 27.0871 599.271 27.3676 599.656C27.6473 600.039 27.8629 600.506 28.0365 600.987C28.3253 601.787 28.5237 602.703 28.6891 603.468C28.7212 603.616 28.7521 603.759 28.7822 603.894C28.8579 604.235 28.9265 604.518 28.9945 604.735C29.1566 604.43 29.3597 603.942 29.6136 603.216C30.0177 602.06 30.4209 601.247 30.8278 600.718C31.2307 600.194 31.7067 599.864 32.2521 599.891C32.7791 599.916 33.1761 600.269 33.4478 600.623C33.7291 600.991 33.9514 601.457 34.1168 601.907L33.649 602.079L34.1168 601.907C34.3207 602.461 34.0812 603.002 33.8298 603.338ZM29.1436 605.092C29.1436 605.092 29.143 605.091 29.1418 605.09L29.1436 605.092ZM28.7833 605.054C28.7821 605.055 28.7815 605.056 28.7815 605.056L28.7833 605.054Z",
    fill: "#1E1E1E",
    stroke: "white"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4976 641.279C67.3577 655.274 87.3341 677.661 90.9299 675.127C94.5258 672.594 81.3294 645.43 71.4693 631.435C61.6092 617.441 58.8194 621.914 55.2235 624.448C51.6277 626.981 47.6375 627.284 57.4976 641.279Z",
    fill: "white"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6061 639.598C59.5119 639.551 60.2084 639.441 60.94 638.925",
    stroke: "#1E1E1E",
    strokeWidth: 0.430518,
    strokeLinecap: "round"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4531 636.106C72.0199 637.361 71.3937 639.08 70.3215 639.978C69.9419 640.295 69.5027 640.56 69.0975 640.846",
    stroke: "#1E1E1E",
    strokeWidth: 0.430518,
    strokeLinecap: "round"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1578 648.589C66.3066 648.587 67.7284 648.805 68.7378 648.118C69.0742 647.89 69.4034 647.649 69.736 647.415C70.288 647.026 70.8399 646.637 71.3918 646.248",
    stroke: "#1E1E1E",
    strokeWidth: 0.430518,
    strokeLinecap: "round"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5273 646.455C79.3809 648.784 78.6454 650.656 76.6406 651.861C76.0219 652.232 75.5306 652.727 74.9482 653.137",
    stroke: "#1E1E1E",
    strokeWidth: 0.430518,
    strokeLinecap: "round"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5688 658.536C75.2066 658.034 76.8871 657.578 78.463 656.899C78.6348 656.826 78.7791 656.736 78.9582 656.683",
    stroke: "#1E1E1E",
    strokeWidth: 0.430518,
    strokeLinecap: "round"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5293 616.872C60.7289 617.941 59.3768 621.115 58.616 627.91C58.4872 629.06 57.0765 629.562 56.2276 628.828C55.3756 628.091 54.2726 627.224 53.1172 626.507C52.5269 626.141 51.7499 625.813 50.93 625.497C50.6792 625.401 50.4227 625.305 50.1681 625.21C49.6113 625.002 49.0633 624.798 48.6036 624.597C48.2654 624.449 47.9499 624.293 47.6941 624.125C47.4509 623.966 47.196 623.754 47.0663 623.469C46.9964 623.316 46.9633 623.142 46.9894 622.958C47.0149 622.777 47.0929 622.618 47.195 622.483C47.3895 622.225 47.7054 622.008 48.0921 621.81C49.0223 621.335 50.0934 621.544 51.0366 621.937C51.9952 622.337 52.9427 622.978 53.7106 623.549C53.7801 623.601 53.8484 623.653 53.9153 623.703C53.1215 621.987 52.3259 619.453 51.9115 617.248C51.6522 615.868 51.5282 614.549 51.6774 613.609C51.7508 613.146 51.9033 612.687 52.2254 612.381C52.5888 612.037 53.0658 611.978 53.5558 612.13C54.052 612.284 54.4328 612.625 54.726 613.027C55.0184 613.428 55.2443 613.917 55.4267 614.422C55.7301 615.262 55.9384 616.225 56.1126 617.03C56.1465 617.186 56.179 617.337 56.2107 617.479C56.2975 617.869 56.3755 618.188 56.4538 618.425C56.6302 618.106 56.8537 617.577 57.1367 616.768C57.5617 615.553 57.9851 614.7 58.411 614.146C58.8328 613.597 59.3266 613.258 59.8881 613.285C60.4313 613.312 60.843 613.675 61.1273 614.046C61.4212 614.43 61.6542 614.918 61.8278 615.39C62.0379 615.962 61.7916 616.522 61.5293 616.872ZM56.5969 618.752C56.5969 618.752 56.5962 618.751 56.5949 618.749L56.5969 618.752ZM56.2543 618.715C56.253 618.716 56.2523 618.717 56.2523 618.717L56.2543 618.715Z",
    fill: "#1E1E1E",
    stroke: "white"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3015 461.693C58.3015 467.714 55.3959 472.21 50.6543 475.223C45.892 478.249 39.27 479.779 31.9007 479.779C24.5315 479.779 17.9095 478.249 13.1472 475.223C8.40553 472.21 5.5 467.714 5.5 461.693C5.5 458.725 6.84869 455.374 9.00615 451.981C11.1574 448.597 14.0794 445.225 17.1489 442.229C20.2175 439.233 23.4205 436.626 26.1233 434.771C27.4753 433.844 28.6943 433.109 29.703 432.61C30.735 432.098 31.4766 431.868 31.9007 431.868C31.984 431.868 32.1753 431.907 32.5014 432.037C32.8125 432.161 33.2009 432.349 33.6587 432.6C34.5732 433.102 35.7337 433.838 37.0542 434.768C39.6939 436.626 42.946 439.236 46.1076 442.234C49.2707 445.232 52.3303 448.606 54.5954 451.99C56.8682 455.386 58.3015 458.734 58.3015 461.693Z",
    fill: "white",
    stroke: "#1E1E1E"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4121 433.324C39.4008 437.563 54.7913 449.758 52.4436 464.627",
    stroke: "#1B2432",
    strokeWidth: 0.978209,
    strokeLinecap: "round"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4121 433.324C23.6976 437.563 8.83522 449.758 11.1024 464.627",
    stroke: "#1B2432",
    strokeWidth: 0.978209,
    strokeLinecap: "round"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4121 433.324C39.4008 437.563 48.5308 457.78 43.6397 472.453",
    stroke: "#1B2432",
    strokeWidth: 0.978209,
    strokeLinecap: "round"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4121 433.324C23.9433 437.563 15.4074 457.78 19.9802 472.453",
    stroke: "#1B2432",
    strokeWidth: 0.978209,
    strokeLinecap: "round"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4121 434.303C28.5395 438.754 21.63 460.225 29.9448 476.366",
    stroke: "#1B2432",
    strokeWidth: 0.978209,
    strokeLinecap: "round"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6623 482.724C24.6232 482.724 30.6424 478.125 33.2219 476.658C33.5567 476.468 33.9662 476.528 34.2573 476.78L39.1339 481.007C39.8182 481.6 39.4001 482.724 38.4945 482.724H25.6623Z",
    fill: "white"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0322 429.773C78.3541 435.062 76.0442 439.165 72.0383 442.066C68.0127 444.982 62.2667 446.684 55.7745 447.079C49.2823 447.475 43.3722 446.482 39.0226 444.076C34.6944 441.682 31.9039 437.889 31.582 432.601C31.4237 430 32.4272 426.983 34.1456 423.879C35.8584 420.785 38.2513 417.658 40.7955 414.853C43.3388 412.048 46.0212 409.579 48.3025 407.801C49.4437 406.911 50.477 406.2 51.3367 405.707C52.2188 405.201 52.8502 404.965 53.2096 404.943C53.2714 404.939 53.4333 404.96 53.7267 405.056C54.0045 405.148 54.3548 405.292 54.7708 405.488C55.6017 405.88 56.6628 406.467 57.8761 407.215C60.3014 408.71 63.3073 410.836 66.2543 413.308C69.2029 415.781 72.0788 418.589 74.2547 421.448C76.4388 424.317 77.8744 427.181 78.0322 429.773Z",
    fill: "white",
    stroke: "#1E1E1E"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8535 406.195C60.1264 409.505 74.3542 419.434 73.0819 432.673",
    stroke: "#1B2432",
    strokeWidth: 0.864293,
    strokeLinecap: "round"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8535 406.195C46.2775 410.348 33.8248 421.901 36.6225 434.892",
    stroke: "#1B2432",
    strokeWidth: 0.864293,
    strokeLinecap: "round"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8535 406.195C60.1264 409.505 69.2635 426.844 65.7377 440.047",
    stroke: "#1B2432",
    strokeWidth: 0.864293,
    strokeLinecap: "round"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8535 406.195C46.4942 410.335 40.0516 428.622 44.8721 441.317",
    stroke: "#1B2432",
    strokeWidth: 0.864293,
    strokeLinecap: "round"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9043 407.058C50.6098 411.137 45.6689 430.444 53.8683 444.232",
    stroke: "#1B2432",
    strokeWidth: 0.864293,
    strokeLinecap: "round"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4329 450.07C49.5165 450.126 54.578 445.747 56.7742 444.314C57.0592 444.128 57.4236 444.16 57.6939 444.366L62.2215 447.832C62.8568 448.318 62.5484 449.332 61.7498 449.381L50.4329 450.07Z",
    fill: "white"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M88.508 477.194C85.5002 481.555 81.1516 483.361 76.2088 483.174C71.2417 482.987 65.6687 480.783 60.3143 477.091C54.9599 473.398 50.9196 468.972 48.9794 464.396C47.0487 459.842 47.1908 455.135 50.1986 450.774C51.6778 448.629 54.3281 446.873 57.5952 445.489C60.8516 444.11 64.664 443.124 68.3967 442.484C72.1282 441.845 75.7623 441.556 78.655 441.563C80.102 441.566 81.354 441.644 82.3349 441.785C83.3415 441.931 83.9841 442.134 84.2805 442.339C84.3315 442.374 84.4462 442.49 84.6175 442.747C84.7798 442.991 84.9668 443.32 85.1731 443.731C85.5853 444.552 86.0591 445.668 86.5528 447.005C87.5397 449.678 88.595 453.205 89.3906 456.969C90.1866 460.734 90.7188 464.718 90.6688 468.31C90.6187 471.916 89.9825 475.056 88.508 477.194Z",
    fill: "white",
    stroke: "#1E1E1E"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2266 443.105C86.9109 450.196 91.9881 466.786 82.8221 476.423",
    stroke: "#1B2432",
    strokeWidth: 0.864293,
    strokeLinecap: "round"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2266 443.105C75.4891 442.319 58.5618 443.734 52.7525 455.686",
    stroke: "#1B2432",
    strokeWidth: 0.864293,
    strokeLinecap: "round"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2266 443.105C86.9109 450.196 83.4109 469.48 72.4932 477.699",
    stroke: "#1B2432",
    strokeWidth: 0.864293,
    strokeLinecap: "round"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2266 443.105C75.6678 442.442 59.3186 452.865 55.2844 465.831",
    stroke: "#1B2432",
    strokeWidth: 0.864293,
    strokeLinecap: "round"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7363 443.817C78.4143 445.613 62.6183 457.765 60.5699 473.676",
    stroke: "#1B2432",
    strokeWidth: 0.864293,
    strokeLinecap: "round"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2645 476.152C53.5088 475.63 60.1937 475.305 62.8058 475.531C63.1449 475.561 63.4124 475.81 63.4976 476.14L64.9247 481.66C65.1249 482.434 64.2568 483.043 63.5981 482.588L54.2645 476.152Z",
    fill: "white"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M163.857 458.214C163.857 463.841 162.677 468.014 160.7 471.119C158.724 474.221 155.927 476.298 152.62 477.691C145.971 480.492 137.342 480.5 129.393 480.5C121.577 480.5 116.13 478.147 112.629 474.237C109.12 470.317 107.5 464.757 107.5 458.214C107.5 451.798 110.89 446.638 116.266 443.06C121.652 439.477 129.014 437.5 136.857 437.5C144.699 437.5 151.46 439.476 156.248 443.045C161.022 446.604 163.857 451.762 163.857 458.214Z",
    fill: "white",
    stroke: "#1E1E1E"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M123.5 447.93C123.5 449.964 121.928 449.964 120.626 449.964C119.324 449.964 121.929 449.112 121.929 447.93C121.929 446.748 119.938 446.036 121.24 446.036C122.541 446.036 123.5 446.748 123.5 447.93Z",
    fill: "#1E1E1E"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M142.357 472.287C142.357 474.321 141.398 472.287 140.097 472.287C138.795 472.287 137.643 473.469 137.643 472.287C137.643 471.105 138.795 470.393 140.097 470.393C141.398 470.393 142.357 471.105 142.357 472.287Z",
    fill: "#1E1E1E"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M151.787 450.283C151.787 452.317 150.215 452.317 148.913 452.317C147.611 452.317 147.072 451.464 147.072 450.283C147.072 449.101 148.913 450.745 150.215 450.745C151.517 450.745 151.787 449.101 151.787 450.283Z",
    fill: "#1E1E1E"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M189.939 445.679C187.261 449.543 184.469 451.84 181.645 453.027C178.823 454.212 175.924 454.308 172.996 453.692C167.102 452.452 161.173 448.353 155.698 444.558C150.331 440.839 147.721 436.64 147.181 432.307C146.638 427.961 148.165 423.381 151.279 418.887C154.321 414.498 159.088 412.571 164.474 412.673C169.871 412.775 175.867 414.92 181.255 418.654C186.643 422.387 190.341 426.96 191.927 431.68C193.508 436.384 193.002 441.26 189.939 445.679Z",
    fill: "white",
    stroke: "#1E1E1E"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M167.132 419.394C166.162 420.795 165.08 420.045 164.183 419.424C163.287 418.803 165.487 419.458 166.051 418.645C166.614 417.831 165.584 416.391 166.48 417.012C167.376 417.633 167.696 418.581 167.132 419.394Z",
    fill: "#1E1E1E"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M168.494 445.156C167.523 446.557 167.834 444.699 166.938 444.078C166.042 443.457 164.685 443.721 165.249 442.907C165.812 442.094 166.945 442.153 167.842 442.774C168.738 443.395 169.058 444.343 168.494 445.156Z",
    fill: "#1E1E1E"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M185.481 434.507C184.51 435.908 183.428 435.158 182.532 434.537C181.636 433.916 181.672 433.072 182.236 432.258C182.799 431.445 183.282 433.455 184.178 434.076C185.074 434.697 186.044 433.694 185.481 434.507Z",
    fill: "#1E1E1E"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M195.089 464.054C195.089 467.221 194.425 469.548 193.329 471.27C192.235 472.988 190.684 474.143 188.837 474.921C185.107 476.492 180.252 476.5 175.723 476.5C171.327 476.5 168.297 475.178 166.359 473.013C164.413 470.839 163.5 467.738 163.5 464.054C163.5 460.495 165.376 457.625 168.384 455.623C171.402 453.615 175.541 452.5 179.964 452.5C184.386 452.5 188.179 453.615 190.853 455.608C193.513 457.591 195.089 460.459 195.089 464.054Z",
    fill: "white",
    stroke: "#1E1E1E"
  })), _mask9 || (_mask9 = /*#__PURE__*/React.createElement("mask", {
    id: "path-253-inside-9_4896_18569",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.375 458.21C172.375 459.366 171.482 459.366 170.742 459.366C170.003 459.366 171.482 458.882 171.482 458.21C171.482 457.539 170.351 457.134 171.091 457.134C171.83 457.134 172.375 457.539 172.375 458.21Z"
  }))), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M172.375 458.21C172.375 459.366 171.482 459.366 170.742 459.366C170.003 459.366 171.482 458.882 171.482 458.21C171.482 457.539 170.351 457.134 171.091 457.134C171.83 457.134 172.375 457.539 172.375 458.21Z",
    fill: "#1E1E1E"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M171.375 458.21C171.375 458.374 171.344 458.403 171.361 458.373C171.385 458.332 171.42 458.312 171.42 458.312C171.403 458.32 171.345 458.34 171.214 458.353C171.082 458.366 170.936 458.366 170.742 458.366V460.366C171.05 460.366 171.699 460.384 172.252 460.131C172.567 459.987 172.872 459.75 173.087 459.384C173.295 459.029 173.375 458.625 173.375 458.21H171.375ZM170.742 458.366C170.719 458.366 170.726 458.365 170.752 458.368C170.765 458.37 170.867 458.381 170.994 458.443C171.128 458.507 171.424 458.697 171.513 459.104C171.592 459.468 171.441 459.734 171.395 459.808C171.308 459.948 171.208 460.012 171.273 459.961C171.306 459.935 171.346 459.906 171.429 459.844C171.566 459.743 171.802 459.568 172.002 459.347C172.192 459.139 172.482 458.749 172.482 458.21H170.482C170.482 458.008 170.588 457.93 170.523 458.001C170.469 458.06 170.381 458.132 170.241 458.236C170.185 458.277 170.098 458.34 170.029 458.395C169.993 458.423 169.818 458.556 169.696 458.753C169.633 458.854 169.475 459.145 169.559 459.531C169.653 459.959 169.965 460.167 170.129 460.246C170.287 460.321 170.433 460.344 170.505 460.353C170.591 460.364 170.673 460.366 170.742 460.366V458.366ZM172.482 458.21C172.482 457.755 172.29 457.401 172.131 457.178C171.975 456.959 171.788 456.783 171.706 456.704C171.65 456.649 171.645 456.642 171.652 456.65C171.657 456.656 171.688 456.693 171.723 456.754C171.752 456.805 171.83 456.953 171.839 457.166C171.85 457.426 171.754 457.684 171.567 457.875C171.414 458.032 171.251 458.089 171.192 458.108C171.078 458.143 171.013 458.134 171.091 458.134V456.134C170.984 456.134 170.792 456.138 170.599 456.198C170.499 456.229 170.309 456.301 170.137 456.477C169.933 456.686 169.829 456.966 169.841 457.25C169.851 457.487 169.938 457.662 169.985 457.744C170.037 457.834 170.092 457.904 170.127 457.945C170.194 458.024 170.273 458.1 170.312 458.137C170.42 458.243 170.47 458.294 170.503 458.34C170.533 458.382 170.482 458.33 170.482 458.21H172.482ZM171.091 458.134C171.287 458.134 171.37 458.188 171.381 458.198C171.385 458.201 171.379 458.197 171.374 458.187C171.37 458.176 171.375 458.18 171.375 458.21H173.375C173.375 457.578 173.106 457.021 172.64 456.643C172.194 456.282 171.634 456.134 171.091 456.134V458.134Z",
    fill: "#1E1E1E",
    mask: "url(#path-253-inside-9_4896_18569)"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M182.571 472.292C182.571 472.292 182.572 472.29 182.573 472.285C182.572 472.29 182.571 472.293 182.571 472.292ZM182.497 471.74C182.317 471.643 182.08 471.549 181.804 471.549C181.547 471.549 181.312 471.607 181.123 471.667C181.121 471.668 181.119 471.669 181.116 471.669C181.119 471.668 181.121 471.666 181.123 471.665C181.279 471.552 181.519 471.473 181.804 471.473C182.088 471.473 182.289 471.551 182.409 471.648C182.443 471.675 182.472 471.705 182.497 471.74ZM180.912 472.092C180.912 472.092 180.912 472.09 180.911 472.084C180.912 472.089 180.912 472.092 180.912 472.092Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M186.955 460.202C186.909 460.203 186.862 460.203 186.813 460.203C186.56 460.203 186.454 460.126 186.399 460.059C186.376 460.031 186.355 459.996 186.335 459.951C186.342 459.954 186.348 459.957 186.354 459.96C186.485 460.018 186.642 460.088 186.784 460.142C186.838 460.162 186.895 460.183 186.955 460.202ZM186.268 459.539C186.268 459.539 186.268 459.541 186.268 459.543L186.268 459.539Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M4.8192 474C2.22659 474 0.318962 476.429 0.93301 478.947L5.32107 496.947C5.75786 498.739 7.36304 500 9.20726 500H90.7927C92.637 500 94.2421 498.739 94.6789 496.947L99.067 478.947C99.681 476.429 97.7734 474 95.1808 474H4.8192Z",
    fill: "#1E1E1E",
    stroke: "white",
    strokeWidth: 2
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M2.06367 362.298C1.10754 360.307 2.55897 358 4.76813 358H188.232C190.441 358 191.892 360.307 190.936 362.298L182.295 380.298C181.795 381.338 180.744 382 179.59 382H13.4099C12.2562 382 11.2048 381.338 10.7055 380.298L2.06367 362.298Z",
    fill: "#1E1E1E",
    stroke: "white",
    strokeWidth: 2
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M106.819 474C104.227 474 102.319 476.429 102.933 478.947L107.321 496.947C107.758 498.739 109.363 500 111.207 500H192.793C194.637 500 196.242 498.739 196.679 496.947L201.067 478.947C201.681 476.429 199.773 474 197.181 474H106.819Z",
    fill: "#1E1E1E",
    stroke: "white",
    strokeWidth: 2
  })), _mask10 || (_mask10 = /*#__PURE__*/React.createElement("mask", {
    id: "path-260-outside-10_4896_18569",
    maskUnits: "userSpaceOnUse",
    x: 134,
    y: 297,
    width: 79,
    height: 63,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 134,
    y: 297,
    width: 79,
    height: 63
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.835 358.012H136C139.706 352.833 143.817 347.522 148.277 342.205C173.828 311.736 201.129 292.56 209.256 299.375C216.591 305.527 205.797 330.751 184.835 358.012Z"
  }))), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.835 358.012H136C139.706 352.833 143.817 347.522 148.277 342.205C173.828 311.736 201.129 292.56 209.256 299.375C216.591 305.527 205.797 330.751 184.835 358.012Z",
    fill: "white"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M184.835 358.012V359.012H185.327L185.628 358.622L184.835 358.012ZM136 358.012L135.187 357.43L134.055 359.012H136V358.012ZM148.277 342.205L147.51 341.562L148.277 342.205ZM209.256 299.375L209.898 298.609V298.609L209.256 299.375ZM184.835 357.012H136V359.012H184.835V357.012ZM136.813 358.594C140.504 353.436 144.599 348.146 149.043 342.847L147.51 341.562C143.035 346.899 138.908 352.229 135.187 357.43L136.813 358.594ZM149.043 342.847C161.779 327.659 174.93 315.314 185.875 307.627C191.354 303.779 196.233 301.131 200.198 299.86C204.219 298.57 206.995 298.785 208.613 300.142L209.898 298.609C207.453 296.558 203.769 296.614 199.587 297.955C195.349 299.315 190.282 302.088 184.725 305.99C173.601 313.804 160.325 326.281 147.51 341.562L149.043 342.847ZM208.613 300.142C210.071 301.364 210.784 303.672 210.486 307.215C210.19 310.723 208.917 315.195 206.735 320.391C202.377 330.769 194.49 343.815 184.042 357.403L185.628 358.622C196.142 344.948 204.133 331.752 208.579 321.165C210.799 315.878 212.158 311.187 212.479 307.383C212.796 303.615 212.109 300.463 209.898 298.609L208.613 300.142Z",
    fill: "#1E1E1E",
    mask: "url(#path-260-outside-10_4896_18569)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M184.122 322.512C182.639 320.04 183.111 318.546 175.871 317.062C175.711 317.029 175.539 317.034 175.386 317.091C173.78 317.684 172.166 319.462 177.122 322.512C183.622 326.512 185.622 325.012 184.122 322.512Z",
    fill: "#1E1E1E"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M173.122 330.512C171.639 328.04 172.111 326.546 164.871 325.062C164.711 325.029 164.539 325.034 164.386 325.091C162.78 325.684 161.166 327.462 166.122 330.512C172.622 334.512 174.622 333.012 173.122 330.512Z",
    fill: "#1E1E1E"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M165.122 340.512C163.639 338.04 164.111 336.546 156.871 335.062C156.711 335.029 156.539 335.034 156.386 335.091C154.78 335.684 153.166 337.462 158.122 340.512C164.622 344.512 166.622 343.012 165.122 340.512Z",
    fill: "#1E1E1E"
  })), _mask11 || (_mask11 = /*#__PURE__*/React.createElement("mask", {
    id: "path-265-outside-11_4896_18569",
    maskUnits: "userSpaceOnUse",
    x: 94,
    y: 297,
    width: 79,
    height: 63,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 94,
    y: 297,
    width: 79,
    height: 63
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.835 358.012H96C99.7058 352.833 103.817 347.522 108.277 342.205C133.828 311.736 161.129 292.56 169.256 299.375C176.591 305.527 165.797 330.751 144.835 358.012Z"
  }))), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.835 358.012H96C99.7058 352.833 103.817 347.522 108.277 342.205C133.828 311.736 161.129 292.56 169.256 299.375C176.591 305.527 165.797 330.751 144.835 358.012Z",
    fill: "white"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M144.835 358.012V359.012H145.327L145.628 358.622L144.835 358.012ZM96 358.012L95.1867 357.43L94.055 359.012H96V358.012ZM108.277 342.205L107.51 341.562L108.277 342.205ZM169.256 299.375L169.898 298.609V298.609L169.256 299.375ZM144.835 357.012H96V359.012H144.835V357.012ZM96.8133 358.594C100.504 353.436 104.599 348.146 109.043 342.847L107.51 341.562C103.035 346.899 98.9078 352.229 95.1867 357.43L96.8133 358.594ZM109.043 342.847C121.779 327.659 134.93 315.314 145.875 307.627C151.354 303.779 156.233 301.131 160.198 299.86C164.219 298.57 166.995 298.785 168.613 300.142L169.898 298.609C167.453 296.558 163.769 296.614 159.587 297.955C155.349 299.315 150.282 302.088 144.725 305.99C133.601 313.804 120.325 326.281 107.51 341.562L109.043 342.847ZM168.613 300.142C170.071 301.364 170.784 303.672 170.486 307.215C170.19 310.723 168.917 315.195 166.735 320.391C162.377 330.769 154.49 343.815 144.042 357.403L145.628 358.622C156.142 344.948 164.133 331.752 168.579 321.165C170.799 315.878 172.158 311.187 172.479 307.383C172.796 303.615 172.109 300.463 169.898 298.609L168.613 300.142Z",
    fill: "#1E1E1E",
    mask: "url(#path-265-outside-11_4896_18569)"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M144.122 322.512C142.639 320.04 143.111 318.546 135.871 317.062C135.711 317.029 135.539 317.034 135.386 317.091C133.78 317.684 132.166 319.462 137.122 322.512C143.622 326.512 145.622 325.012 144.122 322.512Z",
    fill: "#1E1E1E"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M133.122 330.512C131.639 328.04 132.111 326.546 124.871 325.062C124.711 325.029 124.539 325.034 124.386 325.091C122.78 325.684 121.166 327.462 126.122 330.512C132.622 334.512 134.622 333.012 133.122 330.512Z",
    fill: "#1E1E1E"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M125.122 340.512C123.639 338.04 124.111 336.546 116.871 335.062C116.711 335.029 116.539 335.034 116.386 335.091C114.78 335.684 113.166 337.462 118.122 340.512C124.622 344.512 126.622 343.012 125.122 340.512Z",
    fill: "#1E1E1E"
  })), _mask12 || (_mask12 = /*#__PURE__*/React.createElement("mask", {
    id: "path-270-outside-12_4896_18569",
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 308,
    width: 67,
    height: 52,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 4,
    y: 308,
    width: 67,
    height: 52
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.0106 358.075C68.9757 354.125 69.5 350.144 69.5 346.34C69.5 326.602 54.6812 309 38.1216 309C21.562 309 5 332.469 5 352.208C5 354.18 5.17232 356.142 5.49903 358.075H68.0106Z"
  }))), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.0106 358.075C68.9757 354.125 69.5 350.144 69.5 346.34C69.5 326.602 54.6812 309 38.1216 309C21.562 309 5 332.469 5 352.208C5 354.18 5.17232 356.142 5.49903 358.075H68.0106Z",
    fill: "white"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0106 358.075V359.075H68.7957L68.982 358.313L68.0106 358.075ZM5.49903 358.075L4.51301 358.242L4.65384 359.075H5.49903V358.075ZM68.5 346.34C68.5 350.054 67.9878 353.955 67.0392 357.838L68.982 358.313C69.9636 354.295 70.5 350.234 70.5 346.34H68.5ZM38.1216 310C46.0379 310 53.6218 314.212 59.2553 320.912C64.8847 327.607 68.5 336.716 68.5 346.34H70.5C70.5 336.226 66.7059 326.665 60.786 319.625C54.8702 312.589 46.7649 308 38.1216 308V310ZM6 352.208C6 342.593 10.0457 331.996 16.1528 323.8C22.2816 315.574 30.3019 310 38.1216 310V308C29.3818 308 20.8412 314.16 14.5491 322.605C8.23534 331.078 4 342.085 4 352.208H6ZM6.48505 357.909C6.16722 356.028 6 354.122 6 352.208H4C4 354.239 4.17741 356.256 4.51301 358.242L6.48505 357.909ZM5.49903 359.075H68.0106V357.075H5.49903V359.075Z",
    fill: "#1E1E1E",
    mask: "url(#path-270-outside-12_4896_18569)"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1367 333.012C59.5687 333.911 60.0369 334.832 60.3583 335.816",
    stroke: "#1E1E1E",
    strokeLinecap: "round"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4949 320.552C44.6902 320.552 43.7717 320.358 42.9951 320.708C42.5932 320.889 42.2587 321.175 41.8301 321.175",
    stroke: "#1E1E1E",
    strokeLinecap: "round"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2615 329.274C31.3369 329.889 30.4377 329.879 29.8184 331.143",
    stroke: "#1E1E1E",
    strokeLinecap: "round"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3516 336.439C38.3496 336.069 39.4078 336.058 40.4055 336.439",
    stroke: "#1E1E1E",
    strokeLinecap: "round"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8242 343.604C53.3675 344.158 54.453 345.312 54.453 346.407",
    stroke: "#1E1E1E",
    strokeLinecap: "round"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9873 351.705C61.8741 352.821 61.5801 354.001 61.5801 355.131",
    stroke: "#1E1E1E",
    strokeLinecap: "round"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5838 330.832C15.7721 332.018 14.5087 333.193 14.1406 334.882",
    stroke: "#1E1E1E",
    strokeLinecap: "round"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5663 347.966C15.0966 348.182 14.752 349.12 14.752 349.835",
    stroke: "#1E1E1E",
    strokeLinecap: "round"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2422 347.966H33.2782",
    stroke: "#1E1E1E",
    strokeLinecap: "round"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5781 322.111C28.2161 321.483 28.8362 320.865 29.6141 320.865",
    stroke: "#1E1E1E",
    strokeLinecap: "round"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2055 352.741C47.9762 353.654 47.6952 354.093 47.1875 354.61",
    stroke: "#1E1E1E",
    strokeLinecap: "round"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9141 355.753C24.6611 356.624 25.6669 356.376 26.5608 356.376",
    stroke: "#1E1E1E",
    strokeLinecap: "round"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9141 339.554C24.6717 339.554 25.4041 339.242 26.1536 339.242",
    stroke: "#1E1E1E",
    strokeLinecap: "round"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5859 329.274C51.1261 329.6 51.6691 329.905 52.2147 330.208",
    stroke: "#1E1E1E",
    strokeLinecap: "round"
  })), _mask13 || (_mask13 = /*#__PURE__*/React.createElement("mask", {
    id: "path-286-outside-13_4896_18569",
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 321,
    width: 67,
    height: 39,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 17,
    y: 321,
    width: 67,
    height: 39
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.0106 358.075C81.9757 355.172 82.5 352.245 82.5 349.449C82.5 334.939 67.6812 322 51.1216 322C34.562 322 18 339.252 18 353.762C18 355.212 18.1723 356.654 18.499 358.075H81.0106Z"
  }))), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.0106 358.075C81.9757 355.172 82.5 352.245 82.5 349.449C82.5 334.939 67.6812 322 51.1216 322C34.562 322 18 339.252 18 353.762C18 355.212 18.1723 356.654 18.499 358.075H81.0106Z",
    fill: "white"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0106 358.075V359.075H81.7321L81.9596 358.391L81.0106 358.075ZM18.499 358.075L17.5244 358.299L17.7028 359.075H18.499V358.075ZM81.5 349.449C81.5 352.122 80.9983 354.942 80.0617 357.76L81.9596 358.391C82.9531 355.401 83.5 352.368 83.5 349.449H81.5ZM51.1216 323C59.1449 323 66.7589 326.137 72.3625 331.036C77.9691 335.938 81.5 342.542 81.5 349.449H83.5C83.5 341.846 79.6215 334.726 73.6788 329.53C67.7331 324.332 59.6579 321 51.1216 321V323ZM19 353.762C19 346.86 22.9628 339.16 29.0533 333.152C35.1359 327.151 43.1777 323 51.1216 323V321C42.506 321 33.987 325.475 27.6487 331.728C21.3182 337.973 17 346.155 17 353.762H19ZM19.4736 357.851C19.1628 356.499 19 355.132 19 353.762H17C17 355.292 17.1818 356.809 17.5244 358.299L19.4736 357.851ZM18.499 359.075H81.0106V357.075H18.499V359.075Z",
    fill: "#1E1E1E",
    mask: "url(#path-286-outside-13_4896_18569)"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1367 339.651C72.5687 340.312 73.0369 340.989 73.3583 341.712",
    stroke: "#1E1E1E",
    strokeLinecap: "round"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4949 330.492C57.6902 330.492 56.7717 330.35 55.9951 330.607C55.5932 330.74 55.2587 330.95 54.8301 330.95",
    stroke: "#1E1E1E",
    strokeLinecap: "round"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2615 336.903C44.3369 337.356 43.4377 337.349 42.8184 338.277",
    stroke: "#1E1E1E",
    strokeLinecap: "round"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3516 342.171C51.3496 341.899 52.4078 341.89 53.4055 342.171",
    stroke: "#1E1E1E",
    strokeLinecap: "round"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8242 347.438C66.3675 347.845 67.453 348.693 67.453 349.499",
    stroke: "#1E1E1E",
    strokeLinecap: "round"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9873 353.392C74.8741 354.212 74.5801 355.08 74.5801 355.911",
    stroke: "#1E1E1E",
    strokeLinecap: "round"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5838 338.049C28.7721 338.921 27.5087 339.784 27.1406 341.026",
    stroke: "#1E1E1E",
    strokeLinecap: "round"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5663 350.644C28.0966 350.802 27.752 351.492 27.752 352.018",
    stroke: "#1E1E1E",
    strokeLinecap: "round"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2422 350.644H46.2782",
    stroke: "#1E1E1E",
    strokeLinecap: "round"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5781 331.638C41.2161 331.177 41.8362 330.722 42.6141 330.722",
    stroke: "#1E1E1E",
    strokeLinecap: "round"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2055 354.154C60.9762 354.825 60.6952 355.147 60.1875 355.528",
    stroke: "#1E1E1E",
    strokeLinecap: "round"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9141 356.368C37.6611 357.008 38.6669 356.826 39.5608 356.826",
    stroke: "#1E1E1E",
    strokeLinecap: "round"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9141 344.461C37.6717 344.461 38.4041 344.232 39.1536 344.232",
    stroke: "#1E1E1E",
    strokeLinecap: "round"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5859 336.903C64.1261 337.144 64.6691 337.367 65.2147 337.59",
    stroke: "#1E1E1E",
    strokeLinecap: "round"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M72.041 346.922C78.8313 361.183 92.5963 360.64 101.861 357.527C103.655 356.924 103.4 354.257 101.79 353.26C95.3283 349.253 92.9189 340.887 87.4063 334.958C80.5971 327.634 87.637 311.121 84.9506 309.112C82.2641 307.104 61.7209 325.249 72.041 346.922Z",
    fill: "#1E1E1E",
    stroke: "white"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5633 358.311C89.7233 359.655 93.1547 350.029 94.2254 345.048C89.4911 354.025 80.3966 355.491 77.881 355.038C75.3655 354.584 78.1132 356.632 84.5633 358.311Z",
    fill: "white"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0249 338.1C71.5316 341.269 80.5169 334.644 84.8212 330.935C75.7783 334.997 70.2829 330.903 69.6895 331.313C69.0961 331.724 68.1415 334.139 70.0249 338.1Z",
    fill: "white"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M98.7413 355.886C110.648 361.549 119.381 354.362 124.008 347.437C125.059 345.863 123.174 343.909 121.285 344.035C115.076 344.449 109.139 340.467 102.512 339.538C93.9806 338.341 89.7142 323.476 86.8269 323.593C83.9396 323.71 80.0646 347.004 98.7413 355.886Z",
    fill: "white",
    stroke: "#1E1E1E"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M113.301 356.696C117.481 354.791 114.544 346.49 112.553 342.578C114.266 351.153 108.983 357.075 107.055 358.139C105.126 359.203 108.076 359.078 113.301 356.696Z",
    fill: "#1E1E1E"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5985 351.084C95.3278 352.384 97.7352 343.072 98.5977 338.254C94.7591 345.883 88.8601 346.132 88.6865 346.728C88.5128 347.325 89.1869 349.459 92.5985 351.084Z",
    fill: "#1E1E1E"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M410.851 133.598C426.328 151.122 423.866 143.518 467.131 140.542C471 140.255 474.869 133.598 463.262 130.623C451.654 127.647 446.73 114.091 430.197 110.454C413.665 106.817 395.375 116.075 410.851 133.598Z",
    fill: "white"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M410.851 131.358C426.328 148.464 423.866 141.041 467.131 138.136C471 137.856 474.869 131.358 463.262 128.453C451.654 125.548 446.73 112.315 430.197 108.764C413.665 105.214 395.375 114.251 410.851 131.358Z",
    fill: "#1E1E1E",
    stroke: "white"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 6.65224,
    ry: 3.55244,
    transform: "matrix(-0.985598 -0.169105 -0.199929 0.97981 423.011 115.241)",
    fill: "white"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.99262,
    ry: 2.58359,
    transform: "matrix(-0.985598 -0.169105 -0.199929 0.97981 421.834 114.712)",
    fill: "white"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M409.77 123.038C411.445 123.431 414.339 124.122 415.223 125.74C415.528 126.298 415.63 127.134 415.677 127.762C415.786 129.193 418.836 128.381 419.312 129.722",
    stroke: "white",
    strokeLinecap: "round"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M449.53 126.38C451.912 127.082 454.3 127.78 456.627 128.64C457.398 128.925 458.648 129.281 459.079 130.077C459.569 130.98 458.895 131.828 460.251 132.183C461.728 132.571 463.336 132.431 464.639 133.063",
    stroke: "white",
    strokeLinecap: "round"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M443.965 134.778C443.555 134.646 440.271 133.657 440.178 133.954C440.06 134.332 439.845 134.734 439.582 135.055C438.698 136.136 436.292 135.224 435.218 134.929",
    stroke: "white",
    strokeLinecap: "round"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M720.261 113.083C751.104 104.124 777.017 128.8 786.604 142.927C786.859 143.303 787.225 143.58 787.662 143.702C796.525 146.184 802.59 140.695 797.493 145.546C790.718 151.993 787.675 166.275 787.952 163.167C788.096 161.544 787.775 158.839 787.285 156.18C786.911 154.151 781.384 152.368 779.33 152.567C774.037 153.08 764.612 151.582 748.731 145.343C721.218 134.533 717.402 120.711 719.029 114.292C719.181 113.696 719.67 113.255 720.261 113.083Z",
    fill: "white"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M724.289 117.958C724.606 124.707 734.468 140.53 771.378 149.832C758.571 144.64 731.224 130.996 724.289 117.958Z",
    fill: "#1E1E1E"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M781.877 143.562C781.61 136.778 777.941 129.43 761.952 124.286C772.631 132.225 775.519 133.797 781.877 143.562Z",
    fill: "white"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M489.675 162.515C467.116 186.828 470.705 176.277 407.64 172.149C402 171.75 396.36 162.515 413.28 158.386C430.2 154.258 437.378 135.45 461.476 130.404C485.574 125.358 512.235 138.203 489.675 162.515Z",
    fill: "white"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M489.675 159.407C467.116 183.14 470.705 172.841 407.64 168.811C402 168.421 396.36 159.407 413.28 155.376C430.2 151.346 437.378 132.986 461.476 128.06C485.574 123.134 512.235 135.673 489.675 159.407Z",
    fill: "#1E1E1E",
    stroke: "white"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 9.68355,
    ry: 4.93885,
    transform: "matrix(0.986926 -0.161173 0.209618 0.977783 471.954 137.046)",
    fill: "white"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 5.81199,
    ry: 3.59189,
    transform: "matrix(0.986926 -0.161173 0.209618 0.977783 473.667 136.313)",
    fill: "white"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M491.251 147.864C488.81 148.409 484.591 149.367 483.303 151.612C482.858 152.387 482.71 153.546 482.64 154.418C482.482 156.403 478.036 155.276 477.342 157.136",
    stroke: "white",
    strokeLinecap: "round"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M433.296 152.5C429.825 153.474 426.344 154.443 422.951 155.636C421.827 156.031 420.006 156.525 419.378 157.629C418.664 158.883 419.645 160.058 417.669 160.552C415.516 161.09 413.172 160.895 411.273 161.773",
    stroke: "white",
    strokeLinecap: "round"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M441.408 164.151C442.006 163.968 446.793 162.597 446.928 163.009C447.1 163.533 447.413 164.09 447.797 164.536C449.086 166.036 452.593 164.771 454.158 164.361",
    stroke: "white",
    strokeLinecap: "round"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M625.193 114.915C626.098 113.391 625.941 111.393 624.676 110.023C623.135 108.354 620.531 108.25 618.862 109.791C618.016 110.573 617.572 111.626 617.54 112.693C616.474 112.64 615.389 112.998 614.543 113.779C612.873 115.321 612.77 117.924 614.311 119.594C615.853 121.264 618.456 121.368 620.126 119.826L620.126 119.826L626.107 126.304L631.29 121.519L625.193 114.915Z",
    fill: "white"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M655.41 148.337C652.931 150.843 649.125 151.651 644.897 150.834C640.672 150.019 636.087 147.586 632.167 143.707C628.246 139.829 625.764 135.271 624.902 131.055C624.04 126.836 624.807 123.021 627.286 120.516C629.764 118.01 633.57 117.202 637.799 118.018C642.023 118.834 646.608 121.267 650.529 125.145C654.45 129.024 656.932 133.582 657.793 137.798C658.656 142.017 657.889 145.831 655.41 148.337Z",
    fill: "white",
    stroke: "#1E1E1E"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M612.011 157.852C616.197 154.364 617.086 151.163 617.01 149.956C614.669 146.565 609.498 135.268 635.23 132.869C669.912 129.636 669.324 140.511 677.26 144.332C685.195 148.153 694.894 155.794 694.6 166.081C694.307 176.368 688.428 178.72 650.513 183.422C612.599 188.125 606.72 162.261 612.011 157.852Z",
    fill: "white",
    stroke: "#1E1E1E"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M663.837 159.904C666.658 156.142 657.567 149.519 652.668 146.678C655.313 143.445 666.482 146.678 674.124 149.911C681.765 153.144 676.475 163.725 678.238 163.431C680.002 163.137 686.174 164.901 685.586 167.546C684.998 170.191 667.951 175.776 659.722 176.657C651.492 177.539 660.31 164.607 663.837 159.904Z",
    fill: "#1E1E1E"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M604.021 123.861C602.955 123.808 601.869 124.166 601.023 124.947C599.354 126.489 599.25 129.092 600.791 130.762C602.333 132.432 604.936 132.535 606.606 130.994L606.606 130.994L612.588 137.472L617.77 132.687L611.673 126.084C612.579 124.559 612.421 122.562 611.157 121.193C609.615 119.523 607.012 119.419 605.342 120.961C604.496 121.741 604.052 122.795 604.021 123.861Z",
    fill: "white"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M641.89 159.505C639.412 162.011 635.606 162.819 631.377 162.003C627.153 161.187 622.568 158.754 618.647 154.876C614.727 150.997 612.244 146.439 611.383 142.224C610.52 138.004 611.288 134.19 613.766 131.684C616.245 129.178 620.051 128.37 624.279 129.187C628.504 130.003 633.089 132.435 637.009 136.314C640.93 140.192 643.412 144.75 644.274 148.966C645.136 153.185 644.369 157 641.89 159.505Z",
    fill: "white",
    stroke: "#1E1E1E"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M704.908 156.416C732.262 137.74 766.453 152.264 780.803 162.303C781.161 162.554 781.582 162.681 782.019 162.654C791.671 162.054 795.775 154.852 792.423 161.104C787.976 169.397 789.937 183.784 789.129 180.782C788.694 179.163 787.37 176.631 785.907 174.236C784.839 172.487 779.086 172.727 777.227 173.593C772.272 175.899 762.417 177.713 744.223 177.145C713.362 176.183 704.769 164.547 704.119 157.988C704.057 157.361 704.388 156.771 704.908 156.416Z",
    fill: "white"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M710.582 159.639C713.241 165.853 728.473 177.387 768.137 173.811C753.692 173.212 721.958 169.539 710.582 159.639Z",
    fill: "#1E1E1E"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M776.32 164.445C773.699 158.181 767.524 152.522 749.955 153.027C763.254 156.906 766.65 157.417 776.32 164.445Z",
    fill: "white"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M401.904 184.231C401.011 182.246 402.463 180 404.64 180H493.36C495.537 180 496.989 182.246 496.096 184.231L492.945 191.231C492.461 192.308 491.39 193 490.21 193H407.79C406.61 193 405.539 192.308 405.055 191.231L401.904 184.231Z",
    fill: "#1E1E1E",
    stroke: "white",
    strokeWidth: 2
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M502.904 575.231C502.011 573.246 503.463 571 505.64 571H594.36C596.537 571 597.989 573.246 597.096 575.231L593.945 582.231C593.461 583.308 592.39 584 591.21 584H508.79C507.61 584 506.539 583.308 506.055 582.231L502.904 575.231Z",
    fill: "white"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M700.643 575.113C699.856 573.143 701.307 571 703.429 571H781.571C783.693 571 785.144 573.143 784.357 575.113L781.56 582.113C781.105 583.253 780.001 584 778.774 584H706.226C704.999 584 703.895 583.253 703.44 582.113L700.643 575.113Z",
    fill: "white"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M504.904 184.231C504.011 182.246 505.463 180 507.64 180H596.36C598.537 180 599.989 182.246 599.096 184.231L595.945 191.231C595.461 192.308 594.39 193 593.21 193H510.79C509.61 193 508.539 192.308 508.055 191.231L504.904 184.231Z",
    fill: "#1E1E1E",
    stroke: "white",
    strokeWidth: 2
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M504.904 151.231C504.011 149.246 505.463 147 507.64 147H596.36C598.537 147 599.989 149.246 599.096 151.231L595.945 158.231C595.461 159.308 594.39 160 593.21 160H510.79C509.61 160 508.539 159.308 508.055 158.231L504.904 151.231Z",
    fill: "#1E1E1E",
    stroke: "white",
    strokeWidth: 2
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M602.904 184.231C602.011 182.246 603.463 180 605.64 180H694.36C696.537 180 697.989 182.246 697.096 184.231L693.945 191.231C693.461 192.308 692.39 193 691.21 193H608.79C607.61 193 606.539 192.308 606.055 191.231L602.904 184.231Z",
    fill: "#1E1E1E",
    stroke: "white",
    strokeWidth: 2
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M702.904 184.231C702.011 182.246 703.463 180 705.64 180H794.36C796.537 180 797.989 182.246 797.096 184.231L793.945 191.231C793.461 192.308 792.39 193 791.21 193H708.79C707.61 193 706.539 192.308 706.055 191.231L702.904 184.231Z",
    fill: "#1E1E1E",
    stroke: "white",
    strokeWidth: 2
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M509.347 180H596C596 169.973 592.514 171.226 587.036 166.839C581.558 162.453 524.785 163.706 515.821 166.839C508.65 169.346 508.517 176.658 509.347 180Z",
    fill: "white"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M583.342 168.39C583.304 169.109 582.158 170.386 581.652 169.373C581.648 169.366 580.928 170.865 580.928 169.999",
    stroke: "#1E1E1E",
    strokeLinecap: "round"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M522.988 168.39C522.988 170.103 524.948 170.173 526.207 170.16C526.888 170.153 526.69 169.856 526.69 170.41C526.69 171.486 529.281 171.287 529.909 171.287",
    stroke: "#1E1E1E",
    strokeLinecap: "round"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M558.062 172.338C557.936 172.394 557.993 172.434 558.062 172.338V172.338Z",
    fill: "white"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M555.016 170.643C555.751 170.681 558.163 170.788 558.163 171.894C558.163 172.649 557.645 172.354 558.386 172.261C559.161 172.164 561.155 173.677 560.488 174.344",
    stroke: "#1E1E1E",
    strokeLinecap: "round"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M590.906 176.275C590.826 176.442 589.458 178.491 589.305 177.956C589.241 177.731 588.51 178.367 588.179 178.52C587.581 178.795 587.043 178.935 587.043 178.046",
    stroke: "#1E1E1E",
    strokeLinecap: "round"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M510.273 177.724C511.196 176.955 512.876 176.208 513.796 177.473C513.912 177.633 513.914 178.063 514.047 177.813C514.326 177.288 514.652 176.919 515.263 176.794C516.28 176.585 516.554 177.655 517.435 177.33C517.896 177.16 518.57 177.096 518.803 177.563",
    stroke: "#1E1E1E",
    strokeLinecap: "round"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M546.968 167.906C545.67 167.964 543.976 168.664 544.805 170.32C545.045 170.8 544.622 170.329 544.161 170.32C543.607 170.31 543.257 170.343 542.945 170.839C542.756 171.138 542.623 171.648 542.623 172.001C542.623 172.282 541.997 171.93 541.648 171.93C540.22 171.93 540.749 173.401 541.336 174.183",
    stroke: "#1E1E1E",
    strokeLinecap: "round"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M509.347 147H596C596 136.973 592.514 138.226 587.036 133.839C581.558 129.453 524.785 130.706 515.821 133.839C508.65 136.346 508.517 143.658 509.347 147Z",
    fill: "white"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M583.342 135.39C583.304 136.109 582.158 137.386 581.652 136.373C581.648 136.366 580.928 137.865 580.928 136.999",
    stroke: "#1E1E1E",
    strokeLinecap: "round"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M522.988 135.39C522.988 137.103 524.948 137.173 526.207 137.16C526.888 137.153 526.69 136.856 526.69 137.41C526.69 138.486 529.281 138.287 529.909 138.287",
    stroke: "#1E1E1E",
    strokeLinecap: "round"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M558.062 139.338C557.936 139.394 557.993 139.434 558.062 139.338V139.338Z",
    fill: "white"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M555.016 137.643C555.751 137.681 558.163 137.788 558.163 138.894C558.163 139.649 557.645 139.354 558.386 139.261C559.161 139.164 561.155 140.677 560.488 141.344",
    stroke: "#1E1E1E",
    strokeLinecap: "round"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M590.906 143.275C590.826 143.442 589.458 145.491 589.305 144.956C589.241 144.731 588.51 145.367 588.179 145.52C587.581 145.795 587.043 145.935 587.043 145.046",
    stroke: "#1E1E1E",
    strokeLinecap: "round"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M510.273 144.724C511.196 143.955 512.876 143.208 513.796 144.473C513.912 144.633 513.914 145.063 514.047 144.813C514.326 144.288 514.652 143.919 515.263 143.794C516.28 143.585 516.554 144.655 517.435 144.33C517.896 144.16 518.57 144.096 518.803 144.563",
    stroke: "#1E1E1E",
    strokeLinecap: "round"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M546.968 134.906C545.67 134.964 543.976 135.664 544.805 137.32C545.045 137.8 544.622 137.329 544.161 137.32C543.607 137.31 543.257 137.343 542.945 137.839C542.756 138.138 542.623 138.648 542.623 139.001C542.623 139.282 541.997 138.93 541.648 138.93C540.22 138.93 540.749 140.401 541.336 141.183",
    stroke: "#1E1E1E",
    strokeLinecap: "round"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 1014,
    y: 35.6666,
    width: 40.1538,
    height: 48.3333,
    fill: "white"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M1053.5 36C1053.5 36.758 1053.06 37.5512 1052.11 38.3395C1051.16 39.1252 1049.76 39.8552 1047.98 40.4778C1044.42 41.7215 1039.48 42.5 1034 42.5C1028.52 42.5 1023.58 41.7215 1020.02 40.4778C1018.24 39.8552 1016.84 39.1252 1015.89 38.3395C1014.94 37.5512 1014.5 36.758 1014.5 36C1014.5 35.242 1014.94 34.4488 1015.89 33.6605C1016.84 32.8748 1018.24 32.1448 1020.02 31.5222C1023.58 30.2785 1028.52 29.5 1034 29.5C1039.48 29.5 1044.42 30.2785 1047.98 31.5222C1049.76 32.1448 1051.16 32.8748 1052.11 33.6605C1053.06 34.4488 1053.5 35.242 1053.5 36Z",
    fill: "#1E1E1E",
    stroke: "white"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 1024.91,
    y: 53.2693,
    width: 28.7436,
    height: 20.5641,
    fill: "#1E1E1E",
    stroke: "white"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 1057,
    y: 35.6666,
    width: 40.1538,
    height: 48.3333,
    fill: "white"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M1096.5 36C1096.5 36.758 1096.06 37.5512 1095.11 38.3395C1094.16 39.1252 1092.76 39.8552 1090.98 40.4778C1087.42 41.7215 1082.48 42.5 1077 42.5C1071.52 42.5 1066.58 41.7215 1063.02 40.4778C1061.24 39.8552 1059.84 39.1252 1058.89 38.3395C1057.94 37.5512 1057.5 36.758 1057.5 36C1057.5 35.242 1057.94 34.4488 1058.89 33.6605C1059.84 32.8748 1061.24 32.1448 1063.02 31.5222C1066.58 30.2785 1071.52 29.5 1077 29.5C1082.48 29.5 1087.42 30.2785 1090.98 31.5222C1092.76 32.1448 1094.16 32.8748 1095.11 33.6605C1096.06 34.4488 1096.5 35.242 1096.5 36Z",
    fill: "#1E1E1E",
    stroke: "white"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 1067.91,
    y: 53.2693,
    width: 28.7436,
    height: 20.5641,
    fill: "#1E1E1E",
    stroke: "white"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 1106,
    y: 58,
    width: 40,
    height: 26,
    fill: "white"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M1145.5 57.5C1145.5 58.1731 1145.08 58.8986 1144.12 59.6336C1143.17 60.3632 1141.77 61.0418 1139.99 61.6207C1136.43 62.7767 1131.49 63.5 1126 63.5C1120.51 63.5 1115.57 62.7767 1112.01 61.6207C1110.23 61.0418 1108.83 60.3632 1107.88 59.6336C1106.92 58.8986 1106.5 58.1731 1106.5 57.5C1106.5 56.8269 1106.92 56.1014 1107.88 55.3664C1108.83 54.6368 1110.23 53.9582 1112.01 53.3793C1115.57 52.2233 1120.51 51.5 1126 51.5C1131.49 51.5 1136.43 52.2233 1139.99 53.3793C1141.77 53.9582 1143.17 54.6368 1144.12 55.3664C1145.08 56.1014 1145.5 56.8269 1145.5 57.5Z",
    fill: "#1E1E1E",
    stroke: "white"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 1116.5,
    y: 71.5,
    width: 29,
    height: 8,
    fill: "#1E1E1E",
    stroke: "white"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 1149,
    y: 58,
    width: 40,
    height: 26,
    fill: "white"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M1188.5 57.5C1188.5 58.1731 1188.08 58.8986 1187.12 59.6336C1186.17 60.3632 1184.77 61.0418 1182.99 61.6207C1179.43 62.7767 1174.49 63.5 1169 63.5C1163.51 63.5 1158.57 62.7767 1155.01 61.6207C1153.23 61.0418 1151.83 60.3632 1150.88 59.6336C1149.92 58.8986 1149.5 58.1731 1149.5 57.5C1149.5 56.8269 1149.92 56.1014 1150.88 55.3664C1151.83 54.6368 1153.23 53.9582 1155.01 53.3793C1158.57 52.2233 1163.51 51.5 1169 51.5C1174.49 51.5 1179.43 52.2233 1182.99 53.3793C1184.77 53.9582 1186.17 54.6368 1187.12 55.3664C1188.08 56.1014 1188.5 56.8269 1188.5 57.5Z",
    fill: "#1E1E1E",
    stroke: "white"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 1159.5,
    y: 71.5,
    width: 29,
    height: 8,
    fill: "#1E1E1E",
    stroke: "white"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M1126 16H1166V42C1166 42 1159.5 47.5 1146 47.5C1132.5 47.5 1126 42 1126 42V16Z",
    fill: "white"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M1165.5 15.5C1165.5 16.1731 1165.08 16.8986 1164.12 17.6336C1163.17 18.3632 1161.77 19.0418 1159.99 19.6207C1156.43 20.7767 1151.49 21.5 1146 21.5C1140.51 21.5 1135.57 20.7767 1132.01 19.6207C1130.23 19.0418 1128.83 18.3632 1127.88 17.6336C1126.92 16.8986 1126.5 16.1731 1126.5 15.5C1126.5 14.8269 1126.92 14.1014 1127.88 13.3664C1128.83 12.6368 1130.23 11.9582 1132.01 11.3793C1135.57 10.2233 1140.51 9.5 1146 9.5C1151.49 9.5 1156.43 10.2233 1159.99 11.3793C1161.77 11.9582 1163.17 12.6368 1164.12 13.3664C1165.08 14.1014 1165.5 14.8269 1165.5 15.5Z",
    fill: "#1E1E1E",
    stroke: "white"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 1136.5,
    y: 29.5,
    width: 29,
    height: 8,
    fill: "#1E1E1E",
    stroke: "white"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M425.124 478.245C431.393 480.961 438.022 481.315 444.083 478.675C450.142 476.036 455.565 470.436 459.489 461.38C463.412 452.326 464.452 443.017 462.939 435.276C461.426 427.536 457.346 421.312 450.987 418.556C444.629 415.801 437.296 417.081 430.615 421.27C423.932 425.46 417.851 432.584 413.929 441.638C410.004 450.695 409.627 458.481 411.845 464.706C414.064 470.933 418.855 475.528 425.124 478.245Z",
    fill: "white",
    stroke: "#1E1E1E"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M426.244 430.856C425.546 433.662 428.784 434.763 430.731 433.504",
    stroke: "#1E1E1E",
    strokeWidth: 1.77255,
    strokeLinecap: "round"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M432.949 440.82C432.252 443.625 435.49 444.726 437.436 443.468",
    stroke: "#1E1E1E",
    strokeWidth: 1.77255,
    strokeLinecap: "round"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M446.551 437.315C445.853 440.121 449.091 441.222 451.037 439.963",
    stroke: "#1E1E1E",
    strokeWidth: 1.77255,
    strokeLinecap: "round"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M454.518 446.809C453.82 449.615 457.058 450.716 459.004 449.457",
    stroke: "#1E1E1E",
    strokeWidth: 1.77255,
    strokeLinecap: "round"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M421.221 442.45C420.523 445.256 423.761 446.357 425.707 445.099",
    stroke: "#1E1E1E",
    strokeWidth: 1.77255,
    strokeLinecap: "round"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M427.926 452.413C427.228 455.218 430.466 456.32 432.412 455.061",
    stroke: "#1E1E1E",
    strokeWidth: 1.77255,
    strokeLinecap: "round"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M441.527 448.91C440.83 451.715 444.068 452.816 446.014 451.558",
    stroke: "#1E1E1E",
    strokeWidth: 1.77255,
    strokeLinecap: "round"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M449.494 458.402C448.796 461.208 452.034 462.309 453.981 461.051",
    stroke: "#1E1E1E",
    strokeWidth: 1.77255,
    strokeLinecap: "round"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M416.08 454.318C415.382 457.123 418.62 458.224 420.567 456.966",
    stroke: "#1E1E1E",
    strokeWidth: 1.77255,
    strokeLinecap: "round"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M422.785 464.28C422.088 467.086 425.325 468.187 427.272 466.928",
    stroke: "#1E1E1E",
    strokeWidth: 1.77255,
    strokeLinecap: "round"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M436.385 460.777C435.687 463.582 438.925 464.683 440.871 463.425",
    stroke: "#1E1E1E",
    strokeWidth: 1.77255,
    strokeLinecap: "round"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M444.352 470.271C443.654 473.076 446.892 474.177 448.838 472.919",
    stroke: "#1E1E1E",
    strokeWidth: 1.77255,
    strokeLinecap: "round"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M431.125 472.917C430.427 475.722 433.665 476.824 435.612 475.565",
    stroke: "#1E1E1E",
    strokeWidth: 1.77255,
    strokeLinecap: "round"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M442.142 399.157C438.09 395.893 439.428 410.678 440.603 418.478C449.4 426.212 456.201 426.871 458.501 426.233C464.235 422.055 475.291 413.068 473.65 410.547C471.599 407.396 466.473 413.093 464.009 410.894C461.399 408.564 466.809 402.68 464.847 401.075C462.794 399.395 460.765 401.444 458.628 404.038C456.751 406.619 452.183 405.771 453.515 401.822C454.846 397.874 453.167 394.956 450.096 396.57C446.164 398.637 447.207 403.238 442.142 399.157Z",
    fill: "#1E1E1E",
    stroke: "white"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M456.554 495.245C462.823 497.961 469.452 498.315 475.513 495.675C481.572 493.036 486.995 487.436 490.919 478.38C494.842 469.326 495.882 460.017 494.369 452.276C492.856 444.536 488.776 438.312 482.417 435.556C476.058 432.801 468.726 434.081 462.045 438.27C455.362 442.46 449.281 449.584 445.358 458.638C441.434 467.695 441.057 475.481 443.275 481.706C445.494 487.933 450.284 492.528 456.554 495.245Z",
    fill: "white",
    stroke: "#1E1E1E"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M457.674 447.856C456.976 450.662 460.214 451.763 462.16 450.504",
    stroke: "#1E1E1E",
    strokeWidth: 1.77255,
    strokeLinecap: "round"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M464.379 457.819C463.681 460.625 466.919 461.726 468.865 460.468",
    stroke: "#1E1E1E",
    strokeWidth: 1.77255,
    strokeLinecap: "round"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M477.98 454.315C477.283 457.121 480.521 458.222 482.467 456.963",
    stroke: "#1E1E1E",
    strokeWidth: 1.77255,
    strokeLinecap: "round"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M485.947 463.809C485.25 466.615 488.488 467.716 490.434 466.457",
    stroke: "#1E1E1E",
    strokeWidth: 1.77255,
    strokeLinecap: "round"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M452.65 459.45C451.953 462.256 455.191 463.357 457.137 462.099",
    stroke: "#1E1E1E",
    strokeWidth: 1.77255,
    strokeLinecap: "round"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M459.355 469.413C458.658 472.218 461.896 473.319 463.842 472.061",
    stroke: "#1E1E1E",
    strokeWidth: 1.77255,
    strokeLinecap: "round"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M472.957 465.908C472.259 468.714 475.497 469.815 477.444 468.557",
    stroke: "#1E1E1E",
    strokeWidth: 1.77255,
    strokeLinecap: "round"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M480.924 475.402C480.226 478.208 483.464 479.309 485.41 478.051",
    stroke: "#1E1E1E",
    strokeWidth: 1.77255,
    strokeLinecap: "round"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M447.51 471.318C446.812 474.123 450.05 475.224 451.996 473.966",
    stroke: "#1E1E1E",
    strokeWidth: 1.77255,
    strokeLinecap: "round"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M454.213 481.28C453.515 484.086 456.753 485.187 458.699 483.928",
    stroke: "#1E1E1E",
    strokeWidth: 1.77255,
    strokeLinecap: "round"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M467.814 477.776C467.117 480.581 470.355 481.682 472.301 480.424",
    stroke: "#1E1E1E",
    strokeWidth: 1.77255,
    strokeLinecap: "round"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M475.781 487.271C475.084 490.076 478.322 491.177 480.268 489.919",
    stroke: "#1E1E1E",
    strokeWidth: 1.77255,
    strokeLinecap: "round"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M462.555 489.917C461.857 492.722 465.095 493.823 467.041 492.565",
    stroke: "#1E1E1E",
    strokeWidth: 1.77255,
    strokeLinecap: "round"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M473.572 416.157C469.52 412.893 470.858 427.678 472.033 435.478C480.829 443.212 487.63 443.871 489.931 443.233C495.664 439.055 506.72 430.068 505.08 427.547C503.029 424.396 497.903 430.093 495.439 427.894C492.829 425.564 498.239 419.679 496.277 418.075C494.224 416.395 492.194 418.444 490.058 421.038C488.181 423.618 483.613 422.771 484.944 418.822C486.276 414.874 484.597 411.956 481.526 413.57C477.593 415.637 478.637 420.238 473.572 416.157Z",
    fill: "#1E1E1E",
    stroke: "white"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M657.403 578.585C683.745 567.505 684.452 542.325 681.512 531.12C680.85 527.67 680.929 522.288 681.05 520.028C683.49 519.493 688.002 518.836 686.539 520.483C684.711 522.542 686.427 525.172 687.8 528.602C689.174 532.031 704.5 540.487 694.561 563.704C686.61 582.278 667.85 584.793 659.464 583.729C653.975 583.274 655.803 580.11 657.403 578.585Z",
    fill: "white"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M690.662 534.09C695.584 544.722 704.421 570.105 669.756 582.926C679.245 578.462 699.729 560.707 690.662 534.09Z",
    fill: "#1E1E1E"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M625.737 556.775C652.875 565.731 669.952 547.213 675.098 536.834C676.866 533.799 680.461 529.793 682.038 528.169C684.228 529.369 688.062 531.839 685.877 532.119C683.145 532.47 682.711 535.58 681.493 539.068C680.275 542.556 686.273 559 663.526 569.972C645.328 578.749 629.533 568.319 623.91 562.007C620.071 558.058 623.528 556.873 625.737 556.775Z",
    fill: "white"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M680.045 545.084C676.769 556.333 666.754 581.275 632.197 568.163C642.283 571.033 669.392 571.107 680.045 545.084Z",
    fill: "#1E1E1E"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M663.938 536.341C637.814 543.794 621.963 524.465 617.303 513.868C615.69 510.755 612.356 506.579 610.89 504.88C608.77 505.956 605.05 508.206 607.129 508.602C609.728 509.097 610.067 512.213 611.144 515.747C612.222 519.281 606.096 535.313 627.544 547.442C644.702 557.144 660.034 547.618 665.555 541.642C669.316 537.92 666.044 536.557 663.938 536.341Z",
    fill: "white"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M612.382 521.806C615.236 533.168 624.188 558.507 657.496 547.318C647.798 549.632 621.918 548.255 612.382 521.806Z",
    fill: "#1E1E1E"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M497.101 567.192C490.486 579.206 472.335 592.083 450.263 579.932C428.191 567.781 421.223 549.216 431.277 530.954C438.797 517.294 460.959 508.262 483.03 520.413C505.102 532.564 507.154 548.93 497.101 567.192Z",
    fill: "white"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M444.391 576.132C412.908 540.145 449.655 521.243 472.325 516.488C479.007 520.167 469.646 516.026 452.042 532.187C437.959 545.116 441.851 567.806 444.391 576.132Z",
    fill: "#1E1E1E"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M489.609 526.006C511.394 557.484 477.797 576.608 458.342 582.8C453.232 579.845 459.606 582.019 476.245 565.477C489.556 552.243 490.7 533.649 489.609 526.006Z",
    fill: "#1E1E1E"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M450.68 578.426C442.876 566.296 464.64 522.976 481.605 521.626C482.42 521.561 482.785 522.506 482.245 523.12C469 538.167 457.105 564.995 452.189 578.176C451.935 578.857 451.073 579.037 450.68 578.426Z",
    fill: "#1E1E1E"
  })), _mask14 || (_mask14 = /*#__PURE__*/React.createElement("mask", {
    id: "path-410-inside-14_4896_18569",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M476 551C476 555.465 475.121 559.886 473.412 564.011C471.703 568.136 469.199 571.884 466.042 575.042C462.884 578.199 459.136 580.703 455.011 582.412C450.886 584.121 446.465 585 442 585C437.535 585 433.114 584.121 428.989 582.412C424.864 580.703 421.116 578.199 417.958 575.042C414.801 571.884 412.297 568.136 410.588 564.011C408.879 559.886 408 555.465 408 551L442 551H476Z"
  }))), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M476 551C476 555.465 475.121 559.886 473.412 564.011C471.703 568.136 469.199 571.884 466.042 575.042C462.884 578.199 459.136 580.703 455.011 582.412C450.886 584.121 446.465 585 442 585C437.535 585 433.114 584.121 428.989 582.412C424.864 580.703 421.116 578.199 417.958 575.042C414.801 571.884 412.297 568.136 410.588 564.011C408.879 559.886 408 555.465 408 551L442 551H476Z",
    fill: "#1E1E1E",
    stroke: "white",
    strokeWidth: 2,
    mask: "url(#path-410-inside-14_4896_18569)"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M469 551C469 554.546 468.302 558.057 466.945 561.332C465.588 564.608 463.599 567.585 461.092 570.092C458.585 572.599 455.608 574.588 452.332 575.945C449.057 577.302 445.546 578 442 578C438.454 578 434.943 577.302 431.668 575.945C428.392 574.588 425.415 572.599 422.908 570.092C420.401 567.585 418.412 564.608 417.055 561.332C415.698 558.057 415 554.546 415 551L442 551H469Z",
    fill: "white"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M425.471 557.758C425.5 557.497 425.702 557.375 425.93 557.299C425.983 557.281 426.484 557.179 426.315 557.348C426.134 557.529 425.779 557.753 425.544 557.831",
    stroke: "#1E1E1E",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M440.07 567.491C440.345 567.246 440.665 567.194 440.955 567.049",
    stroke: "#1E1E1E",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M454.154 557.757C454.639 557.647 455.098 557.424 455.555 557.241",
    stroke: "#1E1E1E",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M440.734 554.956C441.012 554.892 441.293 554.713 441.545 554.587",
    stroke: "#1E1E1E",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M572 439.104C572 453.464 560.359 467.604 546 467.604C531.641 467.604 520 453.464 520 439.104C520 424.745 531.641 420.604 546 420.604C560.359 420.604 572 424.745 572 439.104Z",
    fill: "white"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 546.5,
    cy: 427.104,
    rx: 8.5,
    ry: 3,
    fill: "#1E1E1E"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M545.688 426.665C545.688 423.179 545.146 418.88 543.227 416",
    stroke: "#1E1E1E",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M574 499.104C581.35 499.104 587.979 495.486 592.76 490.07C597.539 484.656 600.5 477.415 600.5 470.104C600.5 462.761 597.507 457.967 592.642 455.041C587.821 452.141 581.21 451.104 574 451.104C566.79 451.104 560.179 452.141 555.358 455.041C550.493 457.967 547.5 462.761 547.5 470.104C547.5 477.415 550.461 484.656 555.24 490.07C560.021 495.486 566.65 499.104 574 499.104Z",
    fill: "white",
    stroke: "#1E1E1E"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 574.5,
    cy: 458.104,
    rx: 8.5,
    ry: 3,
    fill: "#1E1E1E"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M573.688 457.665C573.688 454.179 573.146 449.88 571.227 447",
    stroke: "#1E1E1E",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M530 498.104C537.35 498.104 543.979 494.486 548.76 489.07C553.539 483.656 556.5 476.415 556.5 469.104C556.5 461.761 553.507 456.967 548.642 454.041C543.821 451.141 537.21 450.104 530 450.104C522.79 450.104 516.179 451.141 511.358 454.041C506.493 456.967 503.5 461.761 503.5 469.104C503.5 476.415 506.461 483.656 511.24 489.07C516.021 494.486 522.65 498.104 530 498.104Z",
    fill: "white",
    stroke: "#1E1E1E"
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 530.5,
    cy: 457.104,
    rx: 8.5,
    ry: 3,
    fill: "#1E1E1E"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M529.688 456.665C529.688 453.179 529.146 448.88 527.227 446",
    stroke: "#1E1E1E",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 723.188,
    cy: 452,
    rx: 20.1875,
    ry: 20,
    fill: "white"
  })), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 726.354,
    cy: 437.417,
    rx: 3.5625,
    ry: 2.08333,
    fill: "#1E1E1E"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M713.006 444.675C713.182 444.839 713.287 444.859 713.495 444.932",
    stroke: "#1E1E1E",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M712.271 458.07C712.489 458.274 712.765 458.416 713.006 458.585",
    stroke: "#1E1E1E",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M726.955 462.707C727.23 462.678 727.436 462.556 727.689 462.449",
    stroke: "#1E1E1E",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M736.254 444.417C735.918 445.105 735.546 445.766 735.275 446.478",
    stroke: "#1E1E1E",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _ellipse19 || (_ellipse19 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 756.54,
    cy: 477.556,
    rx: 20.1875,
    ry: 20.322,
    transform: "rotate(-40.2888 756.54 477.556)",
    fill: "white"
  })), _ellipse20 || (_ellipse20 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 749.373,
    cy: 464.205,
    rx: 3.5625,
    ry: 2.11688,
    transform: "rotate(-40.2888 749.373 464.205)",
    fill: "#1E1E1E"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M743.961 478.462C744.203 478.476 744.297 478.424 744.504 478.346",
    stroke: "#1E1E1E",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M752.203 489.319C752.503 489.337 752.807 489.269 753.102 489.244",
    stroke: "#1E1E1E",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M766.449 483.419C766.639 483.218 766.716 482.99 766.839 482.744",
    stroke: "#1E1E1E",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M761.524 463.228C761.72 463.98 761.87 464.733 762.131 465.459",
    stroke: "#1E1E1E",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _ellipse21 || (_ellipse21 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 762.709,
    cy: 436.207,
    rx: 20.1875,
    ry: 20.2803,
    transform: "rotate(35.1824 762.709 436.207)",
    fill: "white"
  })), _ellipse22 || (_ellipse22 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 773.818,
    cy: 425.946,
    rx: 3.5625,
    ry: 2.11253,
    transform: "rotate(35.1824 773.818 425.946)",
    fill: "#1E1E1E"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M758.668 424.27C758.716 424.507 758.79 424.585 758.917 424.765",
    stroke: "#1E1E1E",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M750.24 434.949C750.299 435.243 750.441 435.52 750.539 435.799",
    stroke: "#1E1E1E",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M759.533 447.251C759.775 447.385 760.015 447.403 760.284 447.46",
    stroke: "#1E1E1E",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M777.82 437.451C777.142 437.828 776.452 438.161 775.816 438.595",
    stroke: "#1E1E1E",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M726.608 579.479C725.234 579.626 724.335 578.16 725.076 577.029C726.827 574.358 729.386 570.606 732.167 567.023C734.956 563.431 737.943 560.045 740.548 558.078C746.001 553.962 753.56 546.02 757.374 541.888C758.231 540.959 759.744 541.278 760.133 542.447C761.698 547.153 764.296 555.583 764.757 560.881C764.973 563.362 766.295 566.127 767.97 568.736C769.652 571.357 771.73 573.877 773.528 575.877C774.048 576.455 774.101 577.248 773.803 577.907C773.506 578.564 772.893 579.02 772.131 578.976C765.377 578.589 754.877 577.968 751.519 577.658C749.599 577.481 745.141 577.749 740.32 578.149C735.475 578.551 730.201 579.093 726.608 579.479Z",
    fill: "white",
    stroke: "black"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 745.712,
    cy: 550.767,
    r: 3.73642,
    transform: "rotate(29.1331 745.712 550.767)",
    fill: "white",
    stroke: "black"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 746.093,
    cy: 574.016,
    r: 6.91374,
    transform: "rotate(29.1331 746.093 574.016)",
    fill: "white",
    stroke: "black"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 758.848,
    cy: 575.062,
    r: 5.85463,
    transform: "rotate(29.1331 758.848 575.062)",
    fill: "white",
    stroke: "black"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 757.861,
    cy: 544.2,
    r: 6.91374,
    transform: "rotate(29.1331 757.861 544.2)",
    fill: "white",
    stroke: "black"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 767.916,
    cy: 563.141,
    r: 5.85463,
    transform: "rotate(29.1331 767.916 563.141)",
    fill: "white",
    stroke: "black"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 755.908,
    cy: 565.56,
    r: 4.29996,
    transform: "rotate(-120.867 755.908 565.56)",
    fill: "white",
    stroke: "black"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 771.086,
    cy: 574.29,
    r: 5.49995,
    transform: "rotate(-120.867 771.086 574.29)",
    fill: "white",
    stroke: "black"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 756.521,
    cy: 555.926,
    r: 6.69993,
    transform: "rotate(-120.867 756.521 555.926)",
    fill: "white",
    stroke: "black"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 743.965,
    cy: 561.052,
    r: 6.69993,
    transform: "rotate(-120.867 743.965 561.052)",
    fill: "white",
    stroke: "black"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 728.193,
    cy: 577.282,
    r: 5.49995,
    transform: "rotate(-120.867 728.193 577.282)",
    fill: "white",
    stroke: "black"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 733.445,
    cy: 567.86,
    r: 5.49995,
    transform: "rotate(-120.867 733.445 567.86)",
    fill: "white",
    stroke: "black"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 736.933,
    cy: 574.655,
    r: 5.49995,
    transform: "rotate(-120.867 736.933 574.655)",
    fill: "white",
    stroke: "black"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M763.23 546.298L763.29 546.267L763.339 546.222C763.759 545.839 763.945 545.36 763.945 544.842C763.944 544.347 763.774 543.837 763.53 543.345C763.043 542.365 762.175 541.291 761.306 540.278C761.073 540.007 760.839 539.74 760.611 539.478C759.967 538.74 759.361 538.045 758.903 537.421C758.593 536.999 758.377 536.643 758.266 536.357C758.15 536.06 758.186 535.942 758.206 535.905C758.28 535.773 758.374 535.693 758.503 535.644C758.644 535.591 758.855 535.565 759.163 535.608C759.79 535.694 760.685 536.04 761.884 536.709C764.271 538.039 767.684 540.539 772.254 544.298C776.695 547.95 777.89 552.136 778.492 555.604C778.595 556.196 778.679 556.759 778.761 557.3C778.8 557.561 778.838 557.817 778.877 558.068C778.996 558.83 779.123 559.545 779.301 560.173C779.659 561.43 780.264 562.468 781.571 562.82C783.46 563.33 784.939 565.235 786.143 567.421C786.724 568.475 787.221 569.555 787.662 570.512L787.688 570.57C788.125 571.52 788.524 572.384 788.887 572.917C789.115 573.251 789.187 573.809 789.065 574.424C788.945 575.036 788.66 575.57 788.341 575.84C788.189 575.97 788.052 576.021 787.934 576.024C787.821 576.028 787.663 575.99 787.459 575.82C787.023 575.459 786.48 574.581 785.974 572.802C785.452 570.966 784.81 569.574 784.107 568.614C783.411 567.664 782.607 567.073 781.752 566.996C780.867 566.916 780.104 567.399 779.547 568.206C778.995 569.006 778.603 570.172 778.415 571.631C778.318 572.391 777.958 573.48 777.454 574.638C776.953 575.787 776.328 576.962 775.727 577.885C775.427 578.347 775.138 578.736 774.881 579.023C774.675 579.253 774.517 579.387 774.41 579.455C774.372 579.313 774.341 579.049 774.361 578.603C774.47 576.164 773.998 573.116 772.981 570.234C771.965 567.355 770.386 564.59 768.24 562.761C766.604 561.366 764.765 560.601 763.274 559.981C762.83 559.796 762.417 559.625 762.05 559.453C761.219 559.064 760.65 558.696 760.336 558.234C760.045 557.807 759.921 557.223 760.179 556.265C760.306 555.795 760.473 555.52 760.632 555.36C760.785 555.206 760.954 555.133 761.143 555.107C761.565 555.05 762.07 555.225 762.583 555.433C762.613 555.445 762.644 555.457 762.674 555.47C762.875 555.552 763.096 555.642 763.273 555.685C763.37 555.708 763.536 555.741 763.708 555.696C763.806 555.671 763.915 555.619 764.006 555.523C764.097 555.428 764.144 555.317 764.165 555.218C764.203 555.04 764.166 554.864 764.13 554.735C764.089 554.592 764.025 554.428 763.941 554.244C763.773 553.876 763.504 553.373 763.117 552.701C761.927 550.632 761.77 549.129 761.984 548.117C762.198 547.1 762.796 546.521 763.23 546.298Z",
    fill: "#1E1E1E",
    stroke: "white"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M718.183 573.276C717.306 574.342 715.636 573.924 715.373 572.597C714.735 569.379 713.902 564.741 713.357 560.056C712.811 555.359 712.559 550.661 713.063 547.301C714.117 540.28 713.944 528.857 713.77 523.091C713.731 521.827 715.033 520.997 716.13 521.559C720.663 523.885 728.764 528.265 732.966 531.868C734.937 533.558 737.953 534.648 741.112 535.361C744.287 536.077 747.676 536.428 750.451 536.598C751.227 536.645 751.82 537.172 752.069 537.85C752.317 538.525 752.198 539.278 751.624 539.78C746.372 544.368 738.051 551.61 735.325 553.829C733.773 555.092 730.651 558.545 727.361 562.353C724.055 566.179 720.539 570.412 718.183 573.276Z",
    fill: "white",
    stroke: "black"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 711.606,
    cy: 538.181,
    r: 3.87338,
    transform: "rotate(-15.2811 711.606 538.181)",
    fill: "white",
    stroke: "black"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 728.683,
    cy: 555.051,
    r: 7.15341,
    transform: "rotate(-15.2811 728.683 555.051)",
    fill: "white",
    stroke: "black"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 738.844,
    cy: 546.607,
    r: 6.06007,
    transform: "rotate(-15.2811 738.844 546.607)",
    fill: "white",
    stroke: "black"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 715.82,
    cy: 524.563,
    r: 7.15341,
    transform: "rotate(-15.2811 715.82 524.563)",
    fill: "white",
    stroke: "black"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 736.918,
    cy: 531.266,
    r: 6.06007,
    transform: "rotate(-15.2811 736.918 531.266)",
    fill: "white",
    stroke: "black"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 729.812,
    cy: 541.724,
    r: 4.45513,
    transform: "rotate(-165.281 729.812 541.724)",
    fill: "white",
    stroke: "black"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 747.312,
    cy: 537.197,
    r: 5.69392,
    transform: "rotate(-165.281 747.312 537.197)",
    fill: "white",
    stroke: "black"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 723.303,
    cy: 534.176,
    r: 6.9327,
    transform: "rotate(-165.281 723.303 534.176)",
    fill: "white",
    stroke: "black"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 717.749,
    cy: 547.028,
    r: 6.9327,
    transform: "rotate(-165.281 717.749 547.028)",
    fill: "white",
    stroke: "black"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 717.845,
    cy: 570.391,
    r: 5.69392,
    transform: "rotate(-165.281 717.845 570.391)",
    fill: "white",
    stroke: "black"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 714.909,
    cy: 559.65,
    r: 5.69392,
    transform: "rotate(-165.281 714.909 559.65)",
    fill: "white",
    stroke: "black"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 722.39,
    cy: 562.14,
    r: 5.69392,
    transform: "rotate(-165.281 722.39 562.14)",
    fill: "white",
    stroke: "black"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M721.28 522.225L721.301 522.162L721.305 522.095C721.337 521.515 721.13 521.031 720.759 520.652C720.403 520.29 719.912 520.038 719.378 519.852C718.313 519.481 716.899 519.317 715.526 519.198C715.158 519.167 714.794 519.138 714.436 519.11C713.428 519.031 712.478 518.957 711.689 518.827C711.155 518.74 710.737 518.633 710.446 518.502C710.145 518.365 710.08 518.25 710.067 518.201C710.025 518.047 710.037 517.916 710.098 517.783C710.165 517.639 710.304 517.466 710.564 517.273C711.091 516.882 712.003 516.49 713.371 516.116C716.093 515.373 720.417 514.75 726.503 514.22C732.422 513.705 736.331 515.931 739.283 518.054C739.786 518.416 740.256 518.77 740.707 519.111C740.924 519.275 741.137 519.436 741.347 519.593C741.985 520.068 742.594 520.504 743.179 520.837C744.349 521.505 745.538 521.83 746.749 521.149C748.516 520.157 750.989 520.496 753.457 521.237C754.647 521.595 755.795 522.032 756.81 522.42L756.872 522.443C757.882 522.828 758.798 523.178 759.449 523.307C759.864 523.39 760.323 523.754 760.68 524.297C761.035 524.837 761.212 525.441 761.172 525.875C761.153 526.083 761.087 526.223 761 526.314C760.916 526.401 760.768 526.489 760.492 526.512C759.905 526.561 758.866 526.304 757.207 525.357C755.497 524.381 754.019 523.819 752.81 523.62C751.613 523.422 750.598 523.568 749.918 524.124C749.213 524.7 749 525.6 749.171 526.594C749.341 527.58 749.893 528.72 750.808 529.931C751.286 530.563 751.809 531.628 752.274 532.847C752.735 534.056 753.123 535.375 753.347 536.491C753.459 537.049 753.528 537.545 753.546 537.945C753.561 538.28 753.538 538.501 753.505 538.628C753.374 538.555 753.153 538.382 752.83 538.021C751.15 536.146 748.602 534.24 745.771 532.851C742.944 531.463 739.785 530.566 736.885 530.767C734.674 530.921 732.768 531.684 731.221 532.303C730.76 532.488 730.331 532.66 729.935 532.799C729.041 533.113 728.352 533.253 727.782 533.14C727.253 533.034 726.736 532.689 726.233 531.793C725.985 531.353 725.909 531.026 725.91 530.79C725.912 530.562 725.985 530.383 726.108 530.225C726.381 529.873 726.885 529.637 727.412 529.419C727.443 529.406 727.474 529.394 727.506 529.381C727.713 529.296 727.94 529.203 728.101 529.108C728.188 529.056 728.331 528.961 728.424 528.807C728.477 528.72 728.519 528.607 728.517 528.473C728.515 528.341 728.47 528.228 728.415 528.142C728.317 527.987 728.166 527.885 728.047 527.816C727.914 527.74 727.749 527.667 727.555 527.592C727.166 527.442 726.604 527.266 725.834 527.05C723.459 526.383 722.254 525.386 721.677 524.481C721.098 523.572 721.12 522.708 721.28 522.225Z",
    fill: "#1E1E1E",
    stroke: "white"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M589.041 560.908C584.925 565.996 572.081 573.438 566.993 569.322C561.905 565.205 566.499 551.09 570.615 546.002C574.732 540.914 582.193 540.127 587.281 544.243C592.369 548.359 593.157 555.82 589.041 560.908Z",
    fill: "white"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M575.777 543.385L578.816 543.981C578.947 544.007 579.055 544.1 579.099 544.225L580.393 547.869C580.575 548.381 581.04 548.738 581.581 548.782L585.073 549.062C585.204 549.072 585.321 549.15 585.38 549.267L587.459 553.361C587.884 554.198 589.03 554.319 589.621 553.589C589.763 553.414 590.04 553.455 590.124 553.664L590.193 553.833C590.443 554.45 591.008 554.786 591.575 554.671C592.164 554.552 592.528 553.995 592.445 553.317C592.103 550.501 591.171 547.067 589.035 544.584C588.798 544.309 588.914 543.928 589.15 543.824L589.569 543.64C590.351 543.296 590.492 542.245 589.827 541.708C589.583 541.51 589.269 541.422 588.957 541.464L585.983 541.862C585.91 541.872 585.83 541.86 585.751 541.824C584.641 541.306 582.984 540.742 581.154 540.495C579.326 540.249 577.288 540.314 575.445 541.096C574.881 541.335 574.634 541.864 574.73 542.373C574.822 542.861 575.215 543.274 575.777 543.385Z",
    fill: "#1E1E1E",
    stroke: "white"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M575.089 548.875C575.223 548.983 575.303 549.033 575.457 549.067",
    stroke: "#1E1E1E",
    strokeWidth: 1.31665,
    strokeLinecap: "round"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M581.529 553.457C581.547 553.751 581.535 553.985 581.779 554.182",
    stroke: "#1E1E1E",
    strokeWidth: 1.31665,
    strokeLinecap: "round"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M587.182 558.239C586.96 558.252 586.61 558.212 586.522 558.02",
    stroke: "#1E1E1E",
    strokeWidth: 1.31665,
    strokeLinecap: "round"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M580.189 561.58C580 561.476 579.733 561.525 579.593 561.411",
    stroke: "#1E1E1E",
    strokeWidth: 1.31665,
    strokeLinecap: "round"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M574.156 557.011L574.511 557.09",
    stroke: "#1E1E1E",
    strokeWidth: 1.31665,
    strokeLinecap: "round"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M569.727 562.22C569.45 562.179 569.177 562.128 568.902 562.076",
    stroke: "#1E1E1E",
    strokeWidth: 1.31665,
    strokeLinecap: "round"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M569.194 553.834C569.124 553.789 569.03 553.773 568.953 553.744",
    stroke: "#1E1E1E",
    strokeWidth: 1.31665,
    strokeLinecap: "round"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M568.057 566.62L568.436 566.927",
    stroke: "#1E1E1E",
    strokeWidth: 1.31665,
    strokeLinecap: "round"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M572.977 565.413L573.356 565.72",
    stroke: "#1E1E1E",
    strokeWidth: 1.31665,
    strokeLinecap: "round"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M562.041 560.908C557.925 565.996 545.081 573.438 539.993 569.322C534.905 565.205 539.499 551.09 543.615 546.002C547.732 540.914 555.193 540.127 560.281 544.243C565.369 548.359 566.157 555.82 562.041 560.908Z",
    fill: "white"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M548.777 543.385L551.816 543.981C551.947 544.007 552.055 544.1 552.099 544.225L553.393 547.869C553.575 548.381 554.04 548.738 554.581 548.782L558.073 549.062C558.204 549.072 558.321 549.15 558.38 549.267L560.459 553.361C560.884 554.198 562.03 554.319 562.621 553.589C562.763 553.414 563.04 553.455 563.124 553.664L563.193 553.833C563.443 554.45 564.008 554.786 564.575 554.671C565.164 554.552 565.528 553.995 565.445 553.317C565.103 550.501 564.171 547.067 562.035 544.584C561.798 544.309 561.914 543.928 562.15 543.824L562.569 543.64C563.351 543.296 563.492 542.245 562.827 541.708C562.583 541.51 562.269 541.422 561.957 541.464L558.983 541.862C558.91 541.872 558.83 541.86 558.751 541.824C557.641 541.306 555.984 540.742 554.154 540.495C552.326 540.249 550.288 540.314 548.445 541.096C547.881 541.335 547.634 541.864 547.73 542.373C547.822 542.861 548.215 543.274 548.777 543.385Z",
    fill: "#1E1E1E",
    stroke: "white"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M548.089 548.875C548.223 548.983 548.303 549.033 548.457 549.067",
    stroke: "#1E1E1E",
    strokeWidth: 1.31665,
    strokeLinecap: "round"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M554.529 553.457C554.547 553.751 554.535 553.985 554.779 554.182",
    stroke: "#1E1E1E",
    strokeWidth: 1.31665,
    strokeLinecap: "round"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M560.182 558.239C559.96 558.252 559.61 558.212 559.522 558.02",
    stroke: "#1E1E1E",
    strokeWidth: 1.31665,
    strokeLinecap: "round"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M553.189 561.58C553 561.476 552.733 561.525 552.593 561.411",
    stroke: "#1E1E1E",
    strokeWidth: 1.31665,
    strokeLinecap: "round"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M547.156 557.011L547.511 557.09",
    stroke: "#1E1E1E",
    strokeWidth: 1.31665,
    strokeLinecap: "round"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M542.727 562.22C542.45 562.179 542.177 562.128 541.902 562.076",
    stroke: "#1E1E1E",
    strokeWidth: 1.31665,
    strokeLinecap: "round"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M542.194 553.834C542.124 553.789 542.03 553.773 541.953 553.744",
    stroke: "#1E1E1E",
    strokeWidth: 1.31665,
    strokeLinecap: "round"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M541.057 566.62L541.436 566.927",
    stroke: "#1E1E1E",
    strokeWidth: 1.31665,
    strokeLinecap: "round"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M545.977 565.413L546.356 565.72",
    stroke: "#1E1E1E",
    strokeWidth: 1.31665,
    strokeLinecap: "round"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M585.041 531.507C580.925 536.595 568.081 544.036 562.993 539.92C557.905 535.804 562.499 521.689 566.615 516.601C570.732 511.513 578.193 510.725 583.281 514.841C588.369 518.957 589.157 526.419 585.041 531.507Z",
    fill: "white"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M571.777 513.983L574.816 514.58C574.947 514.605 575.055 514.698 575.099 514.824L576.393 518.468C576.575 518.979 577.04 519.337 577.581 519.38L581.073 519.66C581.204 519.671 581.321 519.749 581.38 519.866L583.459 523.96C583.884 524.797 585.03 524.918 585.621 524.188C585.763 524.013 586.04 524.054 586.124 524.263L586.193 524.432C586.443 525.049 587.008 525.385 587.575 525.27C588.164 525.15 588.528 524.593 588.445 523.916C588.103 521.099 587.171 517.665 585.035 515.183C584.798 514.908 584.914 514.527 585.15 514.423L585.569 514.239C586.351 513.894 586.492 512.844 585.827 512.306C585.583 512.109 585.269 512.021 584.957 512.062L581.983 512.461C581.91 512.471 581.83 512.459 581.751 512.422C580.641 511.904 578.984 511.34 577.154 511.094C575.326 510.847 573.288 510.912 571.445 511.694C570.881 511.934 570.634 512.463 570.73 512.972C570.822 513.46 571.215 513.873 571.777 513.983Z",
    fill: "#1E1E1E",
    stroke: "white"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M571.089 519.473C571.223 519.581 571.303 519.632 571.457 519.666",
    stroke: "#1E1E1E",
    strokeWidth: 1.31665,
    strokeLinecap: "round"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M577.529 524.056C577.547 524.349 577.535 524.583 577.779 524.781",
    stroke: "#1E1E1E",
    strokeWidth: 1.31665,
    strokeLinecap: "round"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M583.182 528.838C582.96 528.85 582.61 528.811 582.522 528.618",
    stroke: "#1E1E1E",
    strokeWidth: 1.31665,
    strokeLinecap: "round"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M576.189 532.178C576 532.075 575.733 532.124 575.593 532.01",
    stroke: "#1E1E1E",
    strokeWidth: 1.31665,
    strokeLinecap: "round"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M570.156 527.61L570.511 527.688",
    stroke: "#1E1E1E",
    strokeWidth: 1.31665,
    strokeLinecap: "round"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M565.727 532.819C565.45 532.778 565.177 532.726 564.902 532.674",
    stroke: "#1E1E1E",
    strokeWidth: 1.31665,
    strokeLinecap: "round"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M565.194 524.433C565.124 524.388 565.03 524.372 564.953 524.343",
    stroke: "#1E1E1E",
    strokeWidth: 1.31665,
    strokeLinecap: "round"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M564.057 537.219L564.436 537.525",
    stroke: "#1E1E1E",
    strokeWidth: 1.31665,
    strokeLinecap: "round"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M568.977 536.012L569.356 536.319",
    stroke: "#1E1E1E",
    strokeWidth: 1.31665,
    strokeLinecap: "round"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M535.261 560.908C531.145 565.996 518.301 573.438 513.213 569.322C508.125 565.205 512.72 551.09 516.836 546.002C520.952 540.914 528.414 540.127 533.502 544.243C538.59 548.359 539.378 555.82 535.261 560.908Z",
    fill: "white"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M521.998 543.385L525.037 543.981C525.168 544.007 525.275 544.1 525.32 544.225L526.614 547.869C526.795 548.381 527.261 548.738 527.802 548.782L531.294 549.062C531.425 549.072 531.541 549.15 531.601 549.267L533.68 553.361C534.105 554.198 535.251 554.319 535.842 553.589C535.983 553.414 536.261 553.455 536.345 553.664L536.414 553.833C536.663 554.45 537.229 554.786 537.796 554.671C538.385 554.552 538.748 553.995 538.666 553.317C538.324 550.501 537.392 547.067 535.256 544.584C535.019 544.309 535.135 543.928 535.371 543.824L535.789 543.64C536.572 543.296 536.712 542.245 536.048 541.708C535.804 541.51 535.489 541.422 535.178 541.464L532.203 541.862C532.13 541.872 532.05 541.86 531.972 541.824C530.862 541.306 529.205 540.742 527.375 540.495C525.547 540.249 523.509 540.314 521.666 541.096C521.102 541.335 520.855 541.864 520.951 542.373C521.042 542.861 521.436 543.274 521.998 543.385Z",
    fill: "#1E1E1E",
    stroke: "white"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M521.31 548.875C521.443 548.983 521.523 549.033 521.678 549.067",
    stroke: "#1E1E1E",
    strokeWidth: 1.31665,
    strokeLinecap: "round"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M527.75 553.457C527.768 553.751 527.756 553.985 528 554.182",
    stroke: "#1E1E1E",
    strokeWidth: 1.31665,
    strokeLinecap: "round"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M533.402 558.239C533.181 558.252 532.831 558.212 532.743 558.02",
    stroke: "#1E1E1E",
    strokeWidth: 1.31665,
    strokeLinecap: "round"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M526.409 561.58C526.22 561.476 525.954 561.525 525.813 561.411",
    stroke: "#1E1E1E",
    strokeWidth: 1.31665,
    strokeLinecap: "round"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M520.376 557.011L520.731 557.09",
    stroke: "#1E1E1E",
    strokeWidth: 1.31665,
    strokeLinecap: "round"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M515.948 562.22C515.671 562.179 515.398 562.128 515.123 562.076",
    stroke: "#1E1E1E",
    strokeWidth: 1.31665,
    strokeLinecap: "round"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M515.414 553.834C515.344 553.789 515.25 553.773 515.173 553.744",
    stroke: "#1E1E1E",
    strokeWidth: 1.31665,
    strokeLinecap: "round"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M514.277 566.62L514.657 566.927",
    stroke: "#1E1E1E",
    strokeWidth: 1.31665,
    strokeLinecap: "round"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M519.197 565.413L519.577 565.72",
    stroke: "#1E1E1E",
    strokeWidth: 1.31665,
    strokeLinecap: "round"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M558.261 531.507C554.145 536.595 541.301 544.036 536.213 539.92C531.125 535.804 535.72 521.689 539.836 516.601C543.952 511.513 551.414 510.725 556.502 514.841C561.59 518.957 562.378 526.419 558.261 531.507Z",
    fill: "white"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M544.998 513.983L548.037 514.58C548.168 514.605 548.275 514.698 548.32 514.824L549.614 518.468C549.795 518.979 550.261 519.337 550.802 519.38L554.294 519.66C554.425 519.671 554.541 519.749 554.601 519.866L556.68 523.96C557.105 524.797 558.251 524.918 558.842 524.188C558.983 524.013 559.261 524.054 559.345 524.263L559.414 524.432C559.663 525.049 560.229 525.385 560.796 525.27C561.385 525.15 561.748 524.593 561.666 523.916C561.324 521.099 560.392 517.665 558.256 515.183C558.019 514.908 558.135 514.527 558.371 514.423L558.789 514.239C559.572 513.894 559.712 512.844 559.048 512.306C558.804 512.109 558.489 512.021 558.178 512.062L555.203 512.461C555.13 512.471 555.05 512.459 554.972 512.422C553.862 511.904 552.205 511.34 550.375 511.094C548.547 510.847 546.509 510.912 544.666 511.694C544.102 511.934 543.855 512.463 543.951 512.972C544.042 513.46 544.436 513.873 544.998 513.983Z",
    fill: "#1E1E1E",
    stroke: "white"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M544.31 519.473C544.443 519.581 544.523 519.632 544.678 519.666",
    stroke: "#1E1E1E",
    strokeWidth: 1.31665,
    strokeLinecap: "round"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M550.75 524.056C550.768 524.349 550.756 524.583 551 524.781",
    stroke: "#1E1E1E",
    strokeWidth: 1.31665,
    strokeLinecap: "round"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M556.402 528.838C556.181 528.85 555.831 528.811 555.743 528.618",
    stroke: "#1E1E1E",
    strokeWidth: 1.31665,
    strokeLinecap: "round"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M549.409 532.178C549.22 532.075 548.954 532.124 548.813 532.01",
    stroke: "#1E1E1E",
    strokeWidth: 1.31665,
    strokeLinecap: "round"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M543.376 527.61L543.731 527.688",
    stroke: "#1E1E1E",
    strokeWidth: 1.31665,
    strokeLinecap: "round"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M538.948 532.819C538.671 532.778 538.398 532.726 538.123 532.674",
    stroke: "#1E1E1E",
    strokeWidth: 1.31665,
    strokeLinecap: "round"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M538.414 524.433C538.344 524.388 538.25 524.372 538.173 524.343",
    stroke: "#1E1E1E",
    strokeWidth: 1.31665,
    strokeLinecap: "round"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M537.277 537.219L537.657 537.525",
    stroke: "#1E1E1E",
    strokeWidth: 1.31665,
    strokeLinecap: "round"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M542.197 536.012L542.577 536.319",
    stroke: "#1E1E1E",
    strokeWidth: 1.31665,
    strokeLinecap: "round"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M671.952 442.95C671.044 440.39 671.647 437.33 672.959 434.952C675.627 430.116 674.252 424.244 669.888 421.837C665.524 419.429 659.823 421.398 657.156 426.234C655.73 428.818 653.369 431.264 650.538 432.093C645.467 433.578 640.808 437.186 637.903 442.452C632.434 452.366 635.253 464.403 644.2 469.338C653.146 474.273 664.831 470.237 670.3 460.324C673.429 454.651 673.845 448.285 671.952 442.95Z",
    fill: "white"
  })), _ellipse23 || (_ellipse23 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 668.153,
    cy: 424.878,
    rx: 4,
    ry: 1.5,
    transform: "rotate(28.8829 668.153 424.878)",
    fill: "#1E1E1E"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M667.865 424.775C668.878 423.197 669.916 421.256 671.499 420.275C672.113 419.895 672.805 419.61 673.532 419.523C673.951 419.472 674.747 419.538 675.064 419.32",
    stroke: "#1E1E1E",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M655.111 431.959C655.551 430.3 657.266 429.468 659.069 428.873C660.088 428.537 660.229 428.847 659.476 429.61C658.08 431.024 656.838 432.968 655.655 435.114C653.481 439.054 648.726 440.428 645.329 441.41C641.933 442.391 637.676 448.037 642.219 440.836C646.763 433.635 654.054 435.944 655.111 431.959Z",
    fill: "white"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M685.301 469.783C684.454 467.398 685.007 464.49 686.274 462.193C689.051 457.159 687.653 450.963 683.006 448.399C678.359 445.835 672.372 447.959 669.595 452.992C668.207 455.509 665.934 457.834 663.274 458.613C658.074 460.136 653.31 463.831 650.342 469.21C644.764 479.323 647.606 491.684 656.835 496.775C666.064 501.867 678.037 497.677 683.615 487.565C686.811 481.771 687.242 475.256 685.301 469.783Z",
    fill: "white",
    stroke: "#1E1E1E"
  })), _ellipse24 || (_ellipse24 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 681.03,
    cy: 451.878,
    rx: 4,
    ry: 1.5,
    transform: "rotate(28.8829 681.03 451.878)",
    fill: "#1E1E1E"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M680.742 451.775C681.755 450.197 682.792 448.256 684.376 447.275C684.99 446.895 685.682 446.61 686.409 446.523C686.828 446.472 687.624 446.538 687.941 446.32",
    stroke: "#1E1E1E",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M667.988 458.959C668.428 457.3 670.143 456.468 671.946 455.873C672.965 455.537 673.106 455.847 672.352 456.61C670.957 458.024 669.715 459.968 668.531 462.114C666.358 466.054 661.603 467.428 658.206 468.41C654.81 469.391 650.553 475.037 655.096 467.836C659.64 460.635 666.931 462.944 667.988 458.959Z",
    fill: "#1E1E1E"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M651.424 470.783C650.577 468.398 651.13 465.49 652.397 463.193C655.174 458.159 653.776 451.963 649.129 449.399C644.482 446.835 638.495 448.959 635.718 453.992C634.33 456.509 632.058 458.834 629.397 459.613C624.197 461.136 619.433 464.831 616.465 470.21C610.887 480.323 613.729 492.684 622.958 497.775C632.187 502.867 644.16 498.677 649.738 488.565C652.934 482.771 653.365 476.256 651.424 470.783Z",
    fill: "white",
    stroke: "#1E1E1E"
  })), _ellipse25 || (_ellipse25 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 647.153,
    cy: 452.878,
    rx: 4,
    ry: 1.5,
    transform: "rotate(28.8829 647.153 452.878)",
    fill: "#1E1E1E"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M646.865 452.775C647.878 451.197 648.916 449.256 650.499 448.275C651.113 447.895 651.805 447.61 652.532 447.523C652.951 447.472 653.747 447.538 654.064 447.32",
    stroke: "#1E1E1E",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M634.111 459.959C634.551 458.3 636.266 457.468 638.069 456.873C639.088 456.537 639.229 456.847 638.476 457.61C637.08 459.024 635.838 460.968 634.655 463.114C632.481 467.054 627.726 468.428 624.329 469.41C620.933 470.391 616.676 476.037 621.219 468.836C625.763 461.635 633.054 463.944 634.111 459.959Z",
    fill: "#1E1E1E"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 1090.62,
    y: 246.864,
    width: 34.8355,
    height: 78.1367,
    transform: "rotate(90 1090.62 246.864)",
    fill: "#1E1E1E",
    stroke: "white"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 1095.1,
    y: 246.364,
    width: 35.8355,
    height: 3.98172,
    transform: "rotate(90 1095.1 246.364)",
    fill: "white"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 1011.98,
    y: 246.364,
    width: 35.8355,
    height: 3.98172,
    transform: "rotate(90 1011.98 246.364)",
    fill: "white"
  })), _ellipse26 || (_ellipse26 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1049.31,
    cy: 263.287,
    rx: 13.4383,
    ry: 25.8812,
    transform: "rotate(90 1049.31 263.287)",
    fill: "#1E1E1E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4896_18569",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1023,
    y: 249,
    width: 53,
    height: 28
  }, _ellipse27 || (_ellipse27 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1049.31,
    cy: 263.287,
    rx: 13.4383,
    ry: 25.8812,
    transform: "rotate(90 1049.31 263.287)",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4896_18569)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1075.19 249.351L1075.19 248.356L1023.43 248.356L1023.43 249.351L1075.19 249.351ZM1075.19 265.278L1075.19 264.283L1023.43 264.283L1023.43 265.278L1075.19 265.278ZM1075.19 256.319L1075.19 257.314L1023.43 257.314L1023.43 256.319L1075.19 256.319ZM1075.19 273.241L1075.19 272.246L1023.43 272.246L1023.43 273.241L1075.19 273.241ZM1075.19 252.337L1075.19 253.333L1023.43 253.333L1023.43 252.337L1075.19 252.337ZM1075.19 269.26L1075.19 268.264L1023.43 268.264L1023.43 269.26L1075.19 269.26ZM1075.19 260.301L1075.19 261.297L1023.43 261.297L1023.43 260.301L1075.19 260.301ZM1075.19 277.223L1075.19 276.227L1023.43 276.227L1023.43 277.223L1075.19 277.223ZM1075.19 250.347L1075.19 251.342L1023.43 251.342L1023.43 250.347L1075.19 250.347ZM1075.19 267.269L1075.19 266.273L1023.43 266.273L1023.43 267.269L1075.19 267.269ZM1075.19 258.31L1075.19 259.305L1023.43 259.305L1023.43 258.31L1075.19 258.31ZM1075.19 275.232L1075.19 274.237L1023.43 274.237L1023.43 275.232L1075.19 275.232ZM1075.19 254.328L1075.19 255.324L1023.43 255.324L1023.43 254.328L1075.19 254.328ZM1075.19 271.251L1075.19 270.255L1023.43 270.255L1023.43 271.251L1075.19 271.251ZM1075.19 262.292L1075.19 263.287L1023.43 263.287L1023.43 262.292L1075.19 262.292ZM1075.19 279.214L1075.19 278.219L1023.43 278.219L1023.43 279.214L1075.19 279.214Z",
    fill: "white"
  }))), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M1049.31 249.848C1042.45 249.848 1035.86 251.264 1031.01 253.784C1026.16 256.304 1023.43 259.722 1023.43 263.286C1023.43 266.85 1026.16 270.268 1031.01 272.788C1035.86 275.309 1042.45 276.724 1049.31 276.724L1049.31 263.286L1049.31 249.848Z",
    fill: "white"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 1090.62,
    y: 208.5,
    width: 34.8355,
    height: 78.1367,
    transform: "rotate(90 1090.62 208.5)",
    fill: "#1E1E1E",
    stroke: "white"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 1095.1,
    y: 208,
    width: 35.8355,
    height: 3.98172,
    transform: "rotate(90 1095.1 208)",
    fill: "white"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 1011.98,
    y: 208,
    width: 35.8355,
    height: 3.98172,
    transform: "rotate(90 1011.98 208)",
    fill: "white"
  })), _ellipse28 || (_ellipse28 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1049.31,
    cy: 224.922,
    rx: 13.4383,
    ry: 25.8812,
    transform: "rotate(90 1049.31 224.922)",
    fill: "#1E1E1E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_4896_18569",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1023,
    y: 211,
    width: 53,
    height: 28
  }, _ellipse29 || (_ellipse29 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1049.31,
    cy: 224.922,
    rx: 13.4383,
    ry: 25.8812,
    transform: "rotate(90 1049.31 224.922)",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_4896_18569)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1075.19 210.987L1075.19 209.991L1023.43 209.991L1023.43 210.987L1075.19 210.987ZM1075.19 226.914L1075.19 225.918L1023.43 225.918L1023.43 226.914L1075.19 226.914ZM1075.19 217.955L1075.19 218.95L1023.43 218.95L1023.43 217.955L1075.19 217.955ZM1075.19 234.877L1075.19 233.882L1023.43 233.882L1023.43 234.877L1075.19 234.877ZM1075.19 213.973L1075.19 214.968L1023.43 214.968L1023.43 213.973L1075.19 213.973ZM1075.19 230.895L1075.19 229.9L1023.43 229.9L1023.43 230.895L1075.19 230.895ZM1075.19 221.937L1075.19 222.932L1023.43 222.932L1023.43 221.937L1075.19 221.937ZM1075.19 238.859L1075.19 237.863L1023.43 237.863L1023.43 238.859L1075.19 238.859ZM1075.19 211.983L1075.19 212.978L1023.43 212.978L1023.43 211.983L1075.19 211.983ZM1075.19 228.904L1075.19 227.909L1023.43 227.909L1023.43 228.904L1075.19 228.904ZM1075.19 219.946L1075.19 220.941L1023.43 220.941L1023.43 219.946L1075.19 219.946ZM1075.19 236.868L1075.19 235.873L1023.43 235.873L1023.43 236.868L1075.19 236.868ZM1075.19 215.964L1075.19 216.96L1023.43 216.96L1023.43 215.964L1075.19 215.964ZM1075.19 232.887L1075.19 231.891L1023.43 231.891L1023.43 232.887L1075.19 232.887ZM1075.19 223.927L1075.19 224.923L1023.43 224.923L1023.43 223.927L1075.19 223.927ZM1075.19 240.85L1075.19 239.854L1023.43 239.854L1023.43 240.85L1075.19 240.85Z",
    fill: "white"
  }))), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M1049.31 211.484C1042.45 211.484 1035.86 212.899 1031.01 215.42C1026.16 217.94 1023.43 221.358 1023.43 224.922C1023.43 228.486 1026.16 231.904 1031.01 234.424C1035.86 236.944 1042.45 238.36 1049.31 238.36L1049.31 224.922L1049.31 211.484Z",
    fill: "white"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M988.263 51.5931H965.054V57.5793C960.62 60.7461 957.773 65.6527 957.773 71.1608C957.773 76.0835 960.047 80.5257 963.696 83.6749C963.395 84.1103 963.234 84.5681 963.234 85.0405C963.234 87.9307 969.244 90.2737 976.658 90.2737C984.072 90.2737 990.083 87.9307 990.083 85.0405C990.083 84.6584 989.978 84.2858 989.778 83.927C993.601 80.7651 995.999 76.2163 995.999 71.1608C995.999 65.4665 992.957 60.415 988.263 57.2642V51.5931Z",
    fill: "white"
  })), _mask15 || (_mask15 = /*#__PURE__*/React.createElement("mask", {
    id: "path-553-inside-15_4896_18569",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M965.01 50.8769C965.257 49.2771 970.307 48 976.5 48C982.048 48 986.679 49.0249 987.761 50.3886C988.627 51.1619 989.173 52.2872 989.173 53.5399C989.173 54.8898 988.505 56.1412 987.232 56.5921C985.403 57.2404 982.158 58 976.999 58C971.768 58 968.276 57.2192 966.268 56.5651C964.909 56.1225 964.145 54.8138 964.145 53.3848C964.145 52.4386 964.468 51.5679 965.01 50.8769Z"
  }))), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M965.01 50.8769C965.257 49.2771 970.307 48 976.5 48C982.048 48 986.679 49.0249 987.761 50.3886C988.627 51.1619 989.173 52.2872 989.173 53.5399C989.173 54.8898 988.505 56.1412 987.232 56.5921C985.403 57.2404 982.158 58 976.999 58C971.768 58 968.276 57.2192 966.268 56.5651C964.909 56.1225 964.145 54.8138 964.145 53.3848C964.145 52.4386 964.468 51.5679 965.01 50.8769Z",
    fill: "#1E1E1E"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M965.01 50.8769L965.796 51.494L965.958 51.2882L965.998 51.0298L965.01 50.8769ZM987.761 50.3886L986.978 51.0103L987.031 51.0775L987.095 51.1347L987.761 50.3886ZM987.232 56.5921L987.566 57.5346L987.232 56.5921ZM966.268 56.5651L966.577 55.6143H966.577L966.268 56.5651ZM965.998 51.0298C965.986 51.1089 965.983 50.9351 966.533 50.6213C967.028 50.3395 967.779 50.057 968.769 49.8084C970.737 49.3141 973.462 49 976.5 49V47C973.344 47 970.448 47.3245 968.282 47.8687C967.204 48.1393 966.259 48.476 965.543 48.8836C964.884 49.2592 964.157 49.845 964.021 50.724L965.998 51.0298ZM976.5 49C979.219 49 981.691 49.2516 983.595 49.6606C984.548 49.8654 985.336 50.1047 985.932 50.3595C986.553 50.6253 986.862 50.8646 986.978 51.0103L988.544 49.7669C988.119 49.2308 987.443 48.8306 986.718 48.5207C985.968 48.1998 985.048 47.9271 984.015 47.7052C981.946 47.2608 979.33 47 976.5 47V49ZM987.095 51.1347C987.758 51.7263 988.173 52.584 988.173 53.5399H990.173C990.173 51.9904 989.497 50.5975 988.427 49.6425L987.095 51.1347ZM988.173 53.5399C988.173 54.5865 987.669 55.3764 986.898 55.6495L987.566 57.5346C989.341 56.906 990.173 55.1931 990.173 53.5399H988.173ZM986.898 55.6495C985.189 56.2551 982.059 57 976.999 57V59C982.257 59 985.616 58.2257 987.566 57.5346L986.898 55.6495ZM976.999 57C971.87 57 968.482 56.2345 966.577 55.6143L965.958 57.5159C968.07 58.2038 971.667 59 976.999 59V57ZM966.577 55.6143C965.715 55.3334 965.145 54.4772 965.145 53.3848H963.145C963.145 55.1504 964.103 56.9117 965.958 57.5159L966.577 55.6143ZM965.145 53.3848C965.145 52.6702 965.388 52.0152 965.796 51.494L964.223 50.2598C963.548 51.1206 963.145 52.207 963.145 53.3848H965.145Z",
    fill: "white",
    mask: "url(#path-553-inside-15_4896_18569)"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 966.34,
    y: 64.7893,
    width: 21.843,
    height: 13.6519,
    rx: 5,
    fill: "#1E1E1E"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M961.79 71.3875C960.657 67.2792 962.298 63.5477 963.904 61.3083C964.654 60.2619 966.081 60.1122 965.95 61.3932C965.824 62.6325 965.12 64.388 963.838 65.9268C961.562 68.6572 963.61 77.9859 961.79 71.3875Z",
    fill: "#1E1E1E"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M946.489 51.5931H923.281V57.5793C918.846 60.7461 916 65.6527 916 71.1608C916 76.0835 918.273 80.5257 921.922 83.6749C921.621 84.1103 921.461 84.5681 921.461 85.0405C921.461 87.9307 927.471 90.2737 934.885 90.2737C942.299 90.2737 948.309 87.9307 948.309 85.0405C948.309 84.6584 948.204 84.2858 948.005 83.927C951.827 80.7651 954.225 76.2163 954.225 71.1608C954.225 65.4665 951.183 60.415 946.489 57.2642V51.5931Z",
    fill: "white"
  })), _mask16 || (_mask16 = /*#__PURE__*/React.createElement("mask", {
    id: "path-558-inside-16_4896_18569",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M923.236 50.8769C923.484 49.2771 928.533 48 934.727 48C940.275 48 944.905 49.0249 945.988 50.3886C946.854 51.1619 947.4 52.2872 947.4 53.5399C947.4 54.8898 946.731 56.1412 945.459 56.5921C943.629 57.2404 940.385 58 935.226 58C929.995 58 926.502 57.2192 924.494 56.5651C923.136 56.1225 922.371 54.8138 922.371 53.3848C922.371 52.4386 922.694 51.5679 923.236 50.8769Z"
  }))), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M923.236 50.8769C923.484 49.2771 928.533 48 934.727 48C940.275 48 944.905 49.0249 945.988 50.3886C946.854 51.1619 947.4 52.2872 947.4 53.5399C947.4 54.8898 946.731 56.1412 945.459 56.5921C943.629 57.2404 940.385 58 935.226 58C929.995 58 926.502 57.2192 924.494 56.5651C923.136 56.1225 922.371 54.8138 922.371 53.3848C922.371 52.4386 922.694 51.5679 923.236 50.8769Z",
    fill: "#1E1E1E"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M923.236 50.8769L924.023 51.494L924.184 51.2882L924.224 51.0298L923.236 50.8769ZM945.988 50.3886L945.204 51.0103L945.258 51.0775L945.322 51.1347L945.988 50.3886ZM945.459 56.5921L945.793 57.5346L945.459 56.5921ZM924.494 56.5651L924.804 55.6143H924.804L924.494 56.5651ZM924.224 51.0298C924.212 51.1089 924.209 50.9351 924.76 50.6213C925.255 50.3395 926.006 50.057 926.995 49.8084C928.964 49.3141 931.689 49 934.727 49V47C931.571 47 928.675 47.3245 926.508 47.8687C925.43 48.1393 924.485 48.476 923.77 48.8836C923.111 49.2592 922.384 49.845 922.248 50.724L924.224 51.0298ZM934.727 49C937.445 49 939.918 49.2516 941.822 49.6606C942.775 49.8654 943.563 50.1047 944.158 50.3595C944.78 50.6253 945.089 50.8646 945.204 51.0103L946.771 49.7669C946.345 49.2308 945.67 48.8306 944.945 48.5207C944.195 48.1998 943.275 47.9271 942.242 47.7052C940.173 47.2608 937.556 47 934.727 47V49ZM945.322 51.1347C945.985 51.7263 946.4 52.584 946.4 53.5399H948.4C948.4 51.9904 947.723 50.5975 946.653 49.6425L945.322 51.1347ZM946.4 53.5399C946.4 54.5865 945.896 55.3764 945.125 55.6495L945.793 57.5346C947.567 56.906 948.4 55.1931 948.4 53.5399H946.4ZM945.125 55.6495C943.416 56.2551 940.286 57 935.226 57V59C940.483 59 943.843 58.2257 945.793 57.5346L945.125 55.6495ZM935.226 57C930.096 57 926.708 56.2345 924.804 55.6143L924.185 57.5159C926.296 58.2038 929.894 59 935.226 59V57ZM924.804 55.6143C923.942 55.3334 923.371 54.4772 923.371 53.3848H921.371C921.371 55.1504 922.329 56.9117 924.185 57.5159L924.804 55.6143ZM923.371 53.3848C923.371 52.6702 923.614 52.0152 924.023 51.494L922.449 50.2598C921.774 51.1206 921.371 52.207 921.371 53.3848H923.371Z",
    fill: "white",
    mask: "url(#path-558-inside-16_4896_18569)"
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: 924.566,
    y: 64.7893,
    width: 21.843,
    height: 13.6519,
    rx: 5,
    fill: "#1E1E1E"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M920.016 71.3875C918.883 67.2792 920.525 63.5477 922.13 61.3083C922.881 60.2619 924.307 60.1122 924.177 61.3932C924.051 62.6325 923.346 64.388 922.064 65.9268C919.789 68.6572 921.837 77.9859 920.016 71.3875Z",
    fill: "#1E1E1E"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M967.489 10.5931H944.281V16.5793C939.846 19.7461 937 24.6527 937 30.1608C937 35.0835 939.273 39.5257 942.922 42.6749C942.621 43.1103 942.461 43.5681 942.461 44.0405C942.461 46.9307 948.471 49.2737 955.885 49.2737C963.299 49.2737 969.309 46.9307 969.309 44.0405C969.309 43.6584 969.204 43.2858 969.005 42.927C972.827 39.7651 975.225 35.2163 975.225 30.1608C975.225 24.4665 972.183 19.415 967.489 16.2642V10.5931Z",
    fill: "white"
  })), _mask17 || (_mask17 = /*#__PURE__*/React.createElement("mask", {
    id: "path-563-inside-17_4896_18569",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M944.236 9.87689C944.484 8.27712 949.533 7 955.727 7C961.275 7 965.905 8.02494 966.988 9.3886C967.854 10.1619 968.4 11.2872 968.4 12.5399C968.4 13.8898 967.731 15.1412 966.459 15.5921C964.629 16.2404 961.385 17 956.226 17C950.995 17 947.502 16.2192 945.494 15.5651C944.136 15.1225 943.371 13.8138 943.371 12.3848C943.371 11.4386 943.694 10.5679 944.236 9.87689Z"
  }))), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M944.236 9.87689C944.484 8.27712 949.533 7 955.727 7C961.275 7 965.905 8.02494 966.988 9.3886C967.854 10.1619 968.4 11.2872 968.4 12.5399C968.4 13.8898 967.731 15.1412 966.459 15.5921C964.629 16.2404 961.385 17 956.226 17C950.995 17 947.502 16.2192 945.494 15.5651C944.136 15.1225 943.371 13.8138 943.371 12.3848C943.371 11.4386 943.694 10.5679 944.236 9.87689Z",
    fill: "#1E1E1E"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M944.236 9.87689L945.023 10.494L945.184 10.2882L945.224 10.0298L944.236 9.87689ZM966.988 9.3886L966.204 10.0103L966.258 10.0775L966.322 10.1347L966.988 9.3886ZM966.459 15.5921L966.793 16.5346L966.459 15.5921ZM945.494 15.5651L945.804 14.6143H945.804L945.494 15.5651ZM945.224 10.0298C945.212 10.1089 945.209 9.9351 945.76 9.62134C946.255 9.33952 947.006 9.05696 947.995 8.80841C949.964 8.31409 952.689 8 955.727 8V6C952.571 6 949.675 6.32447 947.508 6.86865C946.43 7.13935 945.485 7.47603 944.77 7.8836C944.111 8.25924 943.384 8.84501 943.248 9.72398L945.224 10.0298ZM955.727 8C958.445 8 960.918 8.25163 962.822 8.66063C963.775 8.8654 964.563 9.10472 965.158 9.35952C965.78 9.62529 966.089 9.86459 966.204 10.0103L967.771 8.76692C967.345 8.23078 966.67 7.83059 965.945 7.52066C965.195 7.19975 964.275 6.92715 963.242 6.70523C961.173 6.26084 958.556 6 955.727 6V8ZM966.322 10.1347C966.985 10.7263 967.4 11.584 967.4 12.5399H969.4C969.4 10.9904 968.723 9.59753 967.653 8.64253L966.322 10.1347ZM967.4 12.5399C967.4 13.5865 966.896 14.3764 966.125 14.6495L966.793 16.5346C968.567 15.906 969.4 14.1931 969.4 12.5399H967.4ZM966.125 14.6495C964.416 15.2551 961.286 16 956.226 16V18C961.483 18 964.843 17.2257 966.793 16.5346L966.125 14.6495ZM956.226 16C951.096 16 947.708 15.2345 945.804 14.6143L945.185 16.5159C947.296 17.2038 950.894 18 956.226 18V16ZM945.804 14.6143C944.942 14.3334 944.371 13.4772 944.371 12.3848H942.371C942.371 14.1504 943.329 15.9117 945.185 16.5159L945.804 14.6143ZM944.371 12.3848C944.371 11.6702 944.614 11.0152 945.023 10.494L943.449 9.25979C942.774 10.1206 942.371 11.207 942.371 12.3848H944.371Z",
    fill: "white",
    mask: "url(#path-563-inside-17_4896_18569)"
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    x: 945.566,
    y: 23.7893,
    width: 21.843,
    height: 13.6519,
    rx: 5,
    fill: "#1E1E1E"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M941.016 30.3875C939.883 26.2792 941.525 22.5477 943.13 20.3083C943.881 19.2619 945.307 19.1122 945.177 20.3932C945.051 21.6325 944.346 23.388 943.064 24.9268C940.789 27.6572 942.837 36.9859 941.016 30.3875Z",
    fill: "#1E1E1E"
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 701.5,
    width: 296,
    height: 97,
    fill: "#1E1E1E",
    stroke: "white",
    strokeWidth: 3
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 290.5,
    cy: 717.5,
    r: 2.5,
    fill: "white"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 717.5,
    r: 2.5,
    fill: "white"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: 290.5,
    cy: 749.5,
    r: 2.5,
    fill: "white"
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 749.5,
    r: 2.5,
    fill: "white"
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: 290.5,
    cy: 781.5,
    r: 2.5,
    fill: "white"
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 781.5,
    r: 2.5,
    fill: "white"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M23 728.534C28.1586 724.041 35.6359 726.266 41.725 727.159C45.6994 727.742 49.4569 728.857 53.5342 728.857C56.0251 728.857 58.3873 727.932 60.7734 727.361C62.8185 726.872 64.1474 725.622 66.395 725.622C69.706 725.622 72.3958 726.412 75.6159 726.997C78.9727 727.607 81.8589 727.924 85.2413 727.078",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4129 732.902C72.4664 732.018 70.0344 731.888 67.2434 733.084C64.3471 734.325 61.9511 734.722 58.7505 734.722C55.484 734.722 52.3446 733.266 49.0645 733.266C46.8549 733.266 44.8771 734.186 42.6543 733.63",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M183.88 777.672C177.854 780.685 172.108 778.927 165.883 777.854C162.813 777.324 160.067 778.096 157.127 778.926C155.066 779.507 152.335 780.706 150.232 780.928C147.785 781.185 145.618 782.375 143.114 782.404C139.118 782.45 135.376 781.618 131.466 780.948C128.061 780.364 124.772 779.987 121.396 781.029C119.74 781.54 118.266 782.04 116.543 782.04",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M140.566 787.136C136.445 787.352 132.968 788.896 128.898 787.297C125.514 785.968 122.522 785.68 118.949 785.68C116.087 785.68 113.98 787.193 111.326 787.783C109.096 788.278 106.663 787.668 104.531 787.136",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M284.705 711.791C278.436 713.517 272.294 715.026 265.757 715.026C258.472 715.026 251.376 713.66 244.08 714.339C239.295 714.784 234.603 715.7 229.783 715.795C226.663 715.856 223.792 716.017 220.684 715.411C218.88 715.059 217.037 714.339 215.184 714.339",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M221.371 709.971C224.506 710.34 227.346 711.066 230.471 710.719C232.978 710.441 235.297 709.882 237.791 709.445C242.737 708.58 247.413 709.243 252.31 709.243",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    x: 402.5,
    y: 600.5,
    width: 395,
    height: 97,
    fill: "#1E1E1E",
    stroke: "white",
    strokeWidth: 3
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cx: 409.5,
    cy: 616.5,
    r: 2.5,
    fill: "white"
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: 409.5,
    cy: 648.5,
    r: 2.5,
    fill: "white"
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cx: 409.5,
    cy: 680.5,
    r: 2.5,
    fill: "white"
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    cx: 789.5,
    cy: 616.5,
    r: 2.5,
    fill: "white"
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    cx: 789.5,
    cy: 648.5,
    r: 2.5,
    fill: "white"
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    cx: 789.5,
    cy: 680.5,
    r: 2.5,
    fill: "white"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M428.359 630.279C433.518 625.786 440.995 628.011 447.084 628.904C451.059 629.487 454.816 630.603 458.894 630.603C461.384 630.603 463.747 629.677 466.133 629.106C468.178 628.617 469.507 627.367 471.754 627.367C475.065 627.367 477.755 628.157 480.975 628.742C484.332 629.353 487.218 629.669 490.601 628.823",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M480.772 634.647C477.826 633.763 475.394 633.633 472.603 634.829C469.706 636.07 467.31 636.467 464.11 636.467C460.843 636.467 457.704 635.011 454.424 635.011C452.214 635.011 450.236 635.931 448.014 635.375",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M589.239 679.417C583.214 682.43 577.467 680.672 571.242 679.599C568.172 679.07 565.426 679.842 562.487 680.671C560.425 681.252 557.694 682.451 555.591 682.673C553.144 682.93 550.978 684.12 548.473 684.149C544.477 684.195 540.735 683.363 536.826 682.693C533.42 682.109 530.131 681.732 526.755 682.774C525.099 683.285 523.625 683.785 521.902 683.785",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M545.925 688.881C541.805 689.098 538.328 690.642 534.257 689.043C530.873 687.713 527.881 687.425 524.308 687.425C521.446 687.425 519.34 688.938 516.685 689.528C514.456 690.023 512.022 689.414 509.891 688.881",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M690.064 613.536C683.795 615.262 677.653 616.772 671.117 616.772C663.831 616.772 656.735 615.405 649.439 616.084C644.654 616.529 639.963 617.445 635.143 617.54C632.022 617.601 629.152 617.762 626.043 617.156C624.239 616.804 622.397 616.084 620.543 616.084",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M626.73 611.716C629.865 612.085 632.706 612.811 635.83 612.464C638.337 612.186 640.657 611.627 643.15 611.19C648.097 610.325 652.772 610.988 657.669 610.988",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M775.236 674.322C767.836 674.411 760.39 674.339 753.215 676.323C747.465 677.914 741.301 679.056 735.319 678.325C729.673 677.636 724.266 675.511 718.575 675.09C716.368 674.926 714.117 675.05 711.902 675.05",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M753.031 669.59C756.988 667.384 760.6 666.197 765.164 666.759C768.625 667.185 771.941 667.549 775.315 668.498C779.782 669.754 783.977 670.543 788.459 668.862C790.648 668.041 792.198 667.77 794.525 667.77",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M1200 84H905C902.239 84 900 86.2386 900 89V96C900 98.7614 902.239 101 905 101H1200V84Z",
    fill: "white"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M972.156 215.348C974.976 215.348 977.262 217.634 977.262 220.454V228.743C977.262 233.2 980.413 237.22 983.216 240.686C987.531 246.021 990.312 254.727 990.312 260.5C990.312 265.523 988.207 273.172 984.818 277.103C984.061 277.981 983.504 279.054 983.504 280.214C983.504 282.305 981.808 284 979.717 284H964.595C962.504 284 960.809 282.305 960.809 280.214C960.809 279.054 960.251 277.981 959.494 277.103C956.105 273.172 954 265.523 954 260.5C954 254.996 956.528 246.827 960.502 241.454C960.4 241.415 960.298 241.375 960.197 241.332C958.575 240.648 957.206 239.478 956.278 237.983C955.35 236.487 954.909 234.741 955.016 232.985C955.122 231.228 955.772 229.548 956.874 228.176C957.976 226.804 959.477 225.808 961.169 225.326C962.862 224.843 964.662 224.898 966.322 225.482C966.57 225.569 966.813 225.668 967.05 225.777V220.454C967.05 217.634 969.336 215.348 972.156 215.348ZM966.879 230.56C966.372 229.977 965.721 229.533 964.987 229.275C964.112 228.967 963.164 228.938 962.272 229.193C961.38 229.447 960.589 229.972 960.008 230.695C959.428 231.417 959.085 232.303 959.029 233.228C958.973 234.154 959.205 235.074 959.694 235.862C960.183 236.65 960.905 237.267 961.759 237.627C962.226 237.824 962.72 237.939 963.22 237.97C964.904 235.687 966.389 233.208 966.879 230.56Z",
    fill: "white"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M976.769 267.621C979.317 270.169 983.662 270.139 984.677 266.681C984.786 266.31 984.878 265.934 984.954 265.553C985.458 263.022 985.199 260.398 984.211 258.013C983.224 255.629 981.551 253.591 979.405 252.157C977.259 250.723 974.736 249.957 972.155 249.957C969.574 249.957 967.051 250.723 964.905 252.157C962.759 253.591 961.087 255.629 960.099 258.013C959.111 260.398 958.853 263.022 959.356 265.553C959.432 265.934 959.525 266.31 959.633 266.681C960.648 270.139 964.993 270.169 967.541 267.621C970.089 265.073 974.221 265.073 976.769 267.621Z",
    fill: "#1E1E1E"
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    x: 967.049,
    y: 214.78,
    width: 10.2128,
    height: 4.53901,
    fill: "#1E1E1E"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M967.049 209C967.049 206.239 969.287 204 972.049 204H972.262C975.023 204 977.262 206.239 977.262 209V214.78H967.049V209Z",
    fill: "white"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M934.156 215.348C936.976 215.348 939.262 217.634 939.262 220.454V228.743C939.262 233.2 942.413 237.22 945.216 240.686C949.531 246.021 952.312 254.727 952.312 260.5C952.312 265.523 950.207 273.172 946.818 277.103C946.061 277.981 945.504 279.054 945.504 280.214C945.504 282.305 943.808 284 941.717 284H926.595C924.504 284 922.809 282.305 922.809 280.214C922.809 279.054 922.251 277.981 921.494 277.103C918.105 273.172 916 265.523 916 260.5C916 254.996 918.528 246.827 922.502 241.454C922.4 241.415 922.298 241.375 922.197 241.332C920.575 240.648 919.206 239.478 918.278 237.983C917.35 236.487 916.909 234.741 917.016 232.985C917.122 231.228 917.772 229.548 918.874 228.176C919.976 226.804 921.477 225.808 923.169 225.326C924.862 224.843 926.662 224.898 928.322 225.482C928.57 225.569 928.813 225.668 929.05 225.777V220.454C929.05 217.634 931.336 215.348 934.156 215.348ZM928.879 230.56C928.372 229.977 927.721 229.533 926.987 229.275C926.112 228.967 925.164 228.938 924.272 229.193C923.38 229.447 922.589 229.972 922.008 230.695C921.428 231.417 921.085 232.303 921.029 233.228C920.973 234.154 921.205 235.074 921.694 235.862C922.183 236.65 922.905 237.267 923.759 237.627C924.226 237.824 924.72 237.939 925.22 237.97C926.904 235.687 928.389 233.208 928.879 230.56Z",
    fill: "white"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M938.769 267.621C941.317 270.169 945.662 270.139 946.677 266.681C946.786 266.31 946.878 265.934 946.954 265.553C947.458 263.022 947.199 260.398 946.211 258.013C945.224 255.629 943.551 253.591 941.405 252.157C939.259 250.723 936.736 249.957 934.155 249.957C931.574 249.957 929.051 250.723 926.905 252.157C924.759 253.591 923.087 255.629 922.099 258.013C921.111 260.398 920.853 263.022 921.356 265.553C921.432 265.934 921.525 266.31 921.633 266.681C922.648 270.139 926.993 270.169 929.541 267.621C932.089 265.073 936.221 265.073 938.769 267.621Z",
    fill: "#1E1E1E"
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    x: 929.049,
    y: 214.78,
    width: 10.2128,
    height: 4.53901,
    fill: "#1E1E1E"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M929.049 209C929.049 206.239 931.287 204 934.049 204H934.262C937.023 204 939.262 206.239 939.262 209V214.78H929.049V209Z",
    fill: "white"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M145.223 681.927C157.315 688.705 166.177 685.625 168.54 678.812C163.638 659.938 127.35 636.977 110.877 639.188C97.6989 640.958 102.176 651.435 106.062 656.453C97.7097 658.106 94.7367 664.56 107.696 662.744C120.656 660.928 130.108 673.454 145.223 681.927Z",
    fill: "white"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M165.631 684.008L165.451 684.159L165.221 684.117C153.761 682.051 139.204 673.267 127.541 663.363C121.701 658.403 116.562 653.143 112.879 648.268C111.038 645.831 109.554 643.481 108.529 641.306C107.507 639.136 106.927 637.11 106.93 635.329C106.935 632.539 107.776 630.599 109.224 629.366C110.657 628.145 112.601 627.688 114.671 627.678C118.543 627.66 123.09 629.207 126.312 630.726C126.549 629.25 127.08 627.989 127.777 627.039C128.575 625.95 129.629 625.226 130.736 625.147C131.883 625.066 132.935 625.686 133.661 626.968C134.376 628.23 134.8 630.162 134.773 632.847C134.748 635.353 135.676 637.72 137.312 640.071C138.952 642.428 141.285 644.744 144.029 647.141C145.903 648.778 147.975 650.455 150.133 652.203C154.251 655.538 158.688 659.13 162.687 663.197C167.622 668.214 169.212 672.716 169.119 676.347C169.025 679.966 167.26 682.641 165.631 684.008Z",
    fill: "#1E1E1E",
    stroke: "white"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M164.449 662.012C172.406 671.589 169.072 679.265 166.41 681.907C147.36 678.472 118.41 648.826 118.802 635.463C119.116 624.772 129.881 628.097 135.224 631.096C135.944 624.305 141.957 621.726 141.574 632.241C141.191 642.756 154.504 650.042 164.449 662.012Z",
    fill: "white"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M171.119 671.96C177.964 684.014 187.142 685.96 192.687 681.351C198.251 662.661 179.063 624.244 163.82 617.619C151.625 612.319 150.04 623.603 150.772 629.907C142.768 627.002 136.885 630.99 148.917 636.137C160.949 641.283 162.562 656.892 171.119 671.96Z",
    fill: "white"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M187.509 684.293L187.278 684.329L187.102 684.174C178.362 676.48 170.444 661.434 165.582 646.926C163.147 639.662 161.469 632.502 160.837 626.425C160.522 623.387 160.466 620.608 160.714 618.217C160.961 615.831 161.513 613.797 162.436 612.274C163.882 609.889 165.606 608.663 167.483 608.356C169.341 608.052 171.241 608.666 173.018 609.728C176.341 611.714 179.433 615.389 181.405 618.356C182.372 617.215 183.479 616.411 184.566 615.958C185.812 615.439 187.089 615.363 188.078 615.869C189.101 616.392 189.681 617.467 189.639 618.939C189.599 620.39 188.963 622.262 187.552 624.546C186.234 626.679 185.805 629.184 185.989 632.043C186.174 634.908 186.973 638.097 188.083 641.567C188.841 643.938 189.746 646.444 190.69 649.056C192.491 654.04 194.43 659.41 195.751 664.958C197.38 671.804 196.414 676.479 194.456 679.539C192.505 682.589 189.61 683.966 187.509 684.293Z",
    fill: "#1E1E1E",
    stroke: "white"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M197.873 664.856C199.731 677.167 192.908 682.013 189.264 682.898C174.734 670.107 165.284 629.763 172.53 618.528C178.326 609.539 185.821 617.951 188.844 623.281C192.971 617.841 199.452 618.742 193.687 627.545C187.922 636.347 195.549 649.467 197.873 664.856Z",
    fill: "white"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M1115.8 227.668C1120.76 211.019 1140.82 207.858 1150.23 208.358C1166.53 206.095 1182.82 214.795 1188.79 227.668C1193.56 237.967 1193.99 255.56 1193.61 263.07C1194.99 266.288 1200.5 270.566 1193.61 278.075C1186.72 285.585 1168.59 288.387 1141.28 287.958C1113.97 287.529 1105.49 278.732 1104.35 275.728C1103.2 272.724 1105.01 267.575 1108.23 263.07C1111.44 258.564 1109.6 248.48 1115.8 227.668Z",
    fill: "white"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M1124.77 190.187C1123.85 197.962 1130.09 207.441 1133.33 211.208C1136.02 210.645 1138.48 210.202 1140.73 209.859C1163.73 206.342 1165.08 212.136 1164.24 208.017C1163.32 203.496 1172.41 186.796 1168.25 186.796C1164.09 186.796 1170.79 186.796 1159.92 184.083C1149.05 181.371 1140.96 184.31 1133.33 186.796C1125.7 189.282 1125.93 180.467 1124.77 190.187Z",
    fill: "white"
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    cx: 1150.5,
    cy: 244.5,
    r: 18.5,
    fill: "#1E1E1E"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M1146.7 252.08C1144.43 254.247 1140.35 251.247 1139.88 244.303C1144.46 245.324 1151.42 248.251 1146.7 252.08Z",
    fill: "white"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M1148.39 252.367C1148.44 255.505 1153.06 256.329 1157.95 251.81C1154.31 249.252 1147.87 246.318 1148.39 252.367Z",
    fill: "white"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M1149.7 244.806C1148.29 246.732 1143.03 243.978 1143.48 237.135C1146.47 238.431 1152.1 241.543 1149.7 244.806Z",
    fill: "white"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M1151.14 245.485C1151.01 247.871 1156.39 249.035 1160.1 243.431C1157.21 242.564 1151.36 241.443 1151.14 245.485Z",
    fill: "white"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M1152.11 241.647C1156.22 242.887 1157.49 238.756 1154.69 232.437C1152.02 234.645 1146.36 239.072 1152.11 241.647Z",
    fill: "white"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M1200 282H905C902.239 282 900 284.239 900 287V294C900 296.761 902.239 299 905 299H1200V282Z",
    fill: "white"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M1149 206.5C1154.6 205.3 1163 207 1166.5 208C1166.5 209.333 1165.6 211.7 1162 210.5C1157.5 209 1150 209 1145 210.5C1140 212 1133 212 1130.5 210.5C1128 209 1131 208 1135 208C1139 208 1142 208 1149 206.5Z",
    fill: "#1E1E1E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4896_18569"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 800,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGroceryStoreContrast);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/GroceryStoreContrast.8847edc5c56cd2b20675cab4368aa02b.svg";